/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthgatedRouteImport } from './routes/_authgated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as AuthgatedSuperadminRouteImport } from './routes/_authgated/superadmin'
import { Route as AuthSelectWorkspaceRouteImport } from './routes/_auth/select-workspace'
import { Route as AuthResetRouteImport } from './routes/_auth/reset'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthForgotRouteImport } from './routes/_auth/forgot'
import { Route as AuthConfirmEmailRouteImport } from './routes/_auth/confirm-email'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as Auth2faVerifyRouteImport } from './routes/_auth/2fa-verify'
import { Route as Auth2faSetupRouteImport } from './routes/_auth/2fa-setup'
import { Route as AuthgatedSuperadminIndexRouteImport } from './routes/_authgated/superadmin.index'
import { Route as AuthgatedSuperadminUsersRouteImport } from './routes/_authgated/superadmin.users'
import { Route as AuthgatedSuperadminPlansRouteImport } from './routes/_authgated/superadmin.plans'
import { Route as AuthgatedSuperadminFunnelRouteImport } from './routes/_authgated/superadmin.funnel'
import { Route as AuthgatedSuperadminAuditRouteImport } from './routes/_authgated/superadmin.audit'
import { Route as AuthgatedAppTenantSlugRouteImport } from './routes/_authgated/app.$tenantSlug'
import { Route as AuthgatedSuperadminTenantsIndexRouteImport } from './routes/_authgated/superadmin.tenants.index'
import { Route as AuthgatedSuperadminSupportIndexRouteImport } from './routes/_authgated/superadmin.support.index'
import { Route as AuthgatedAppTenantSlugIndexRouteImport } from './routes/_authgated/app.$tenantSlug.index'
import { Route as AuthgatedSuperadminTenantsIdRouteImport } from './routes/_authgated/superadmin.tenants.$id'
import { Route as AuthgatedSuperadminSupportIdRouteImport } from './routes/_authgated/superadmin.support.$id'
import { Route as AuthgatedAppTenantSlugTasksRouteImport } from './routes/_authgated/app.$tenantSlug.tasks'
import { Route as AuthgatedAppTenantSlugSupportTicketsRouteImport } from './routes/_authgated/app.$tenantSlug.support-tickets'
import { Route as AuthgatedAppTenantSlugSkillsRouteImport } from './routes/_authgated/app.$tenantSlug.skills'
import { Route as AuthgatedAppTenantSlugReferralsRouteImport } from './routes/_authgated/app.$tenantSlug.referrals'
import { Route as AuthgatedAppTenantSlugOverviewRouteImport } from './routes/_authgated/app.$tenantSlug.overview'
import { Route as AuthgatedAppTenantSlugMyTimeRouteImport } from './routes/_authgated/app.$tenantSlug.my-time'
import { Route as AuthgatedAppTenantSlugInterviewsRouteImport } from './routes/_authgated/app.$tenantSlug.interviews'
import { Route as AuthgatedAppTenantSlugHolidaysRouteImport } from './routes/_authgated/app.$tenantSlug.holidays'
import { Route as AuthgatedAppTenantSlugHelpdeskRouteImport } from './routes/_authgated/app.$tenantSlug.helpdesk'
import { Route as AuthgatedAppTenantSlugExitTasksRouteImport } from './routes/_authgated/app.$tenantSlug.exit-tasks'
import { Route as AuthgatedAppTenantSlugDirectoryRouteImport } from './routes/_authgated/app.$tenantSlug.directory'
import { Route as AuthgatedAppTenantSlugComplianceRouteImport } from './routes/_authgated/app.$tenantSlug.compliance'
import { Route as AuthgatedAppTenantSlugCompOffRouteImport } from './routes/_authgated/app.$tenantSlug.comp-off'
import { Route as AuthgatedAppTenantSlugCalendarRouteImport } from './routes/_authgated/app.$tenantSlug.calendar'
import { Route as AuthgatedAppTenantSlugApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.approvals'
import { Route as AuthgatedAppTenantSlugApprovalDelegationRouteImport } from './routes/_authgated/app.$tenantSlug.approval-delegation'
import { Route as AuthgatedAppTenantSlugAnnouncementsRouteImport } from './routes/_authgated/app.$tenantSlug.announcements'
import { Route as AuthgatedAppTenantSlugWfhIndexRouteImport } from './routes/_authgated/app.$tenantSlug.wfh.index'
import { Route as AuthgatedAppTenantSlugTravelPreapprovalsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.travel-preapprovals.index'
import { Route as AuthgatedAppTenantSlugTimesheetIndexRouteImport } from './routes/_authgated/app.$tenantSlug.timesheet.index'
import { Route as AuthgatedAppTenantSlugSurveysIndexRouteImport } from './routes/_authgated/app.$tenantSlug.surveys.index'
import { Route as AuthgatedAppTenantSlugShiftsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.shifts.index'
import { Route as AuthgatedAppTenantSlugSettingsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.settings.index'
import { Route as AuthgatedAppTenantSlugReportsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.reports.index'
import { Route as AuthgatedAppTenantSlugPoshIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.index'
import { Route as AuthgatedAppTenantSlugPerformanceIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.index'
import { Route as AuthgatedAppTenantSlugPeopleIndexRouteImport } from './routes/_authgated/app.$tenantSlug.people.index'
import { Route as AuthgatedAppTenantSlugPayrollIndexRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.index'
import { Route as AuthgatedAppTenantSlugMaternityCasesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.maternity-cases.index'
import { Route as AuthgatedAppTenantSlugLoansIndexRouteImport } from './routes/_authgated/app.$tenantSlug.loans.index'
import { Route as AuthgatedAppTenantSlugLeaveIndexRouteImport } from './routes/_authgated/app.$tenantSlug.leave.index'
import { Route as AuthgatedAppTenantSlugHrIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hr.index'
import { Route as AuthgatedAppTenantSlugHiringIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.index'
import { Route as AuthgatedAppTenantSlugExpensesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.expenses.index'
import { Route as AuthgatedAppTenantSlugChangeRequestsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.change-requests.index'
import { Route as AuthgatedAppTenantSlugBulkImportsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.bulk-imports.index'
import { Route as AuthgatedAppTenantSlugAttendanceIndexRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.index'
import { Route as AuthgatedAppTenantSlugAccountingIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.index'
import { Route as AuthgatedAppTenantSlugWfhApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.wfh.approvals'
import { Route as AuthgatedAppTenantSlugWfhIdRouteImport } from './routes/_authgated/app.$tenantSlug.wfh.$id'
import { Route as AuthgatedAppTenantSlugTravelPreapprovalsNewRouteImport } from './routes/_authgated/app.$tenantSlug.travel-preapprovals.new'
import { Route as AuthgatedAppTenantSlugTravelPreapprovalsIdRouteImport } from './routes/_authgated/app.$tenantSlug.travel-preapprovals.$id'
import { Route as AuthgatedAppTenantSlugTimesheetInboxRouteImport } from './routes/_authgated/app.$tenantSlug.timesheet.inbox'
import { Route as AuthgatedAppTenantSlugSurveysNewRouteImport } from './routes/_authgated/app.$tenantSlug.surveys.new'
import { Route as AuthgatedAppTenantSlugSupportTicketsIdRouteImport } from './routes/_authgated/app.$tenantSlug.support-tickets_.$id'
import { Route as AuthgatedAppTenantSlugSupportTicketsNewRouteImport } from './routes/_authgated/app.$tenantSlug.support-tickets.new'
import { Route as AuthgatedAppTenantSlugShiftsSwapsRouteImport } from './routes/_authgated/app.$tenantSlug.shifts.swaps'
import { Route as AuthgatedAppTenantSlugShiftsRosterRouteImport } from './routes/_authgated/app.$tenantSlug.shifts.roster'
import { Route as AuthgatedAppTenantSlugSettingsWorkspaceRouteImport } from './routes/_authgated/app.$tenantSlug.settings.workspace'
import { Route as AuthgatedAppTenantSlugSettingsWebhooksRouteImport } from './routes/_authgated/app.$tenantSlug.settings.webhooks'
import { Route as AuthgatedAppTenantSlugSettingsTallyMappingsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.tally-mappings'
import { Route as AuthgatedAppTenantSlugSettingsSkillsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.skills'
import { Route as AuthgatedAppTenantSlugSettingsShiftsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.shifts'
import { Route as AuthgatedAppTenantSlugSettingsSecurityRouteImport } from './routes/_authgated/app.$tenantSlug.settings.security'
import { Route as AuthgatedAppTenantSlugSettingsScorecardTemplatesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.scorecard-templates'
import { Route as AuthgatedAppTenantSlugSettingsRolesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.roles'
import { Route as AuthgatedAppTenantSlugSettingsPostingAccountsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.posting-accounts'
import { Route as AuthgatedAppTenantSlugSettingsPaymentAccountsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.payment-accounts'
import { Route as AuthgatedAppTenantSlugSettingsOnboardingTemplatesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.onboarding-templates'
import { Route as AuthgatedAppTenantSlugSettingsNotificationsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.notifications'
import { Route as AuthgatedAppTenantSlugSettingsModulesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.modules'
import { Route as AuthgatedAppTenantSlugSettingsLeaveTypesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.leave-types'
import { Route as AuthgatedAppTenantSlugSettingsJdTemplatesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.jd-templates'
import { Route as AuthgatedAppTenantSlugSettingsHolidaysRouteImport } from './routes/_authgated/app.$tenantSlug.settings.holidays'
import { Route as AuthgatedAppTenantSlugSettingsHiringEmailsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.hiring-emails'
import { Route as AuthgatedAppTenantSlugSettingsHiringApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.hiring-approvals'
import { Route as AuthgatedAppTenantSlugSettingsExpenseCategoriesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.expense-categories'
import { Route as AuthgatedAppTenantSlugSettingsEntitiesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.entities'
import { Route as AuthgatedAppTenantSlugSettingsDepartmentsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.departments'
import { Route as AuthgatedAppTenantSlugSettingsCustomFieldsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.custom-fields'
import { Route as AuthgatedAppTenantSlugSettingsCompetenciesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.competencies'
import { Route as AuthgatedAppTenantSlugSettingsCoaRouteImport } from './routes/_authgated/app.$tenantSlug.settings.coa'
import { Route as AuthgatedAppTenantSlugSettingsCareersBrandingRouteImport } from './routes/_authgated/app.$tenantSlug.settings.careers-branding'
import { Route as AuthgatedAppTenantSlugSettingsBillingRouteImport } from './routes/_authgated/app.$tenantSlug.settings.billing'
import { Route as AuthgatedAppTenantSlugSettingsAuditLogRouteImport } from './routes/_authgated/app.$tenantSlug.settings.audit-log'
import { Route as AuthgatedAppTenantSlugSettingsAttendanceDevicesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.attendance-devices'
import { Route as AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.attendance-device-profiles'
import { Route as AuthgatedAppTenantSlugSettingsAttendanceRouteImport } from './routes/_authgated/app.$tenantSlug.settings.attendance'
import { Route as AuthgatedAppTenantSlugSettingsAssetTypesRouteImport } from './routes/_authgated/app.$tenantSlug.settings.asset-types'
import { Route as AuthgatedAppTenantSlugSettingsApiTokensRouteImport } from './routes/_authgated/app.$tenantSlug.settings.api-tokens'
import { Route as AuthgatedAppTenantSlugSettingsAnalyticsRouteImport } from './routes/_authgated/app.$tenantSlug.settings.analytics'
import { Route as AuthgatedAppTenantSlugReportsSalaryRegisterRouteImport } from './routes/_authgated/app.$tenantSlug.reports.salary-register'
import { Route as AuthgatedAppTenantSlugReportsPayrollCostRouteImport } from './routes/_authgated/app.$tenantSlug.reports.payroll-cost'
import { Route as AuthgatedAppTenantSlugReportsHeadcountRouteImport } from './routes/_authgated/app.$tenantSlug.reports.headcount'
import { Route as AuthgatedAppTenantSlugReportsAnalyticsRouteImport } from './routes/_authgated/app.$tenantSlug.reports.analytics'
import { Route as AuthgatedAppTenantSlugPoshIccRouteImport } from './routes/_authgated/app.$tenantSlug.posh.icc'
import { Route as AuthgatedAppTenantSlugPoshComplianceRouteImport } from './routes/_authgated/app.$tenantSlug.posh.compliance'
import { Route as AuthgatedAppTenantSlugPoshCertificatesRouteImport } from './routes/_authgated/app.$tenantSlug.posh.certificates'
import { Route as AuthgatedAppTenantSlugPoshAboutRouteImport } from './routes/_authgated/app.$tenantSlug.posh.about'
import { Route as AuthgatedAppTenantSlugPerformanceFeedbackRouteImport } from './routes/_authgated/app.$tenantSlug.performance.feedback'
import { Route as AuthgatedAppTenantSlugPeoplePreboardingRouteImport } from './routes/_authgated/app.$tenantSlug.people.preboarding'
import { Route as AuthgatedAppTenantSlugPeopleOrgChartRouteImport } from './routes/_authgated/app.$tenantSlug.people.org-chart'
import { Route as AuthgatedAppTenantSlugPeopleNewRouteImport } from './routes/_authgated/app.$tenantSlug.people.new'
import { Route as AuthgatedAppTenantSlugPeopleIdRouteImport } from './routes/_authgated/app.$tenantSlug.people.$id'
import { Route as AuthgatedAppTenantSlugPayrollStatutoryBonusRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.statutory-bonus'
import { Route as AuthgatedAppTenantSlugPayrollStatutoryRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.statutory'
import { Route as AuthgatedAppTenantSlugPayrollPfCeilingRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.pf-ceiling'
import { Route as AuthgatedAppTenantSlugPayrollNewRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.new'
import { Route as AuthgatedAppTenantSlugPayrollFilingsRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.filings'
import { Route as AuthgatedAppTenantSlugPayrollIdRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.$id'
import { Route as AuthgatedAppTenantSlugMeTaxRouteImport } from './routes/_authgated/app.$tenantSlug.me.tax'
import { Route as AuthgatedAppTenantSlugMeSurveysRouteImport } from './routes/_authgated/app.$tenantSlug.me.surveys'
import { Route as AuthgatedAppTenantSlugMeSecurityRouteImport } from './routes/_authgated/app.$tenantSlug.me.security'
import { Route as AuthgatedAppTenantSlugMeSalaryRouteImport } from './routes/_authgated/app.$tenantSlug.me.salary'
import { Route as AuthgatedAppTenantSlugMeProfileRouteImport } from './routes/_authgated/app.$tenantSlug.me.profile'
import { Route as AuthgatedAppTenantSlugMePayRouteImport } from './routes/_authgated/app.$tenantSlug.me.pay'
import { Route as AuthgatedAppTenantSlugMeLoansRouteImport } from './routes/_authgated/app.$tenantSlug.me.loans'
import { Route as AuthgatedAppTenantSlugMeExitRouteImport } from './routes/_authgated/app.$tenantSlug.me.exit'
import { Route as AuthgatedAppTenantSlugMeDocumentsRouteImport } from './routes/_authgated/app.$tenantSlug.me.documents'
import { Route as AuthgatedAppTenantSlugMeAssetsRouteImport } from './routes/_authgated/app.$tenantSlug.me.assets'
import { Route as AuthgatedAppTenantSlugMaternityCasesNewRouteImport } from './routes/_authgated/app.$tenantSlug.maternity-cases.new'
import { Route as AuthgatedAppTenantSlugMaternityCasesIdRouteImport } from './routes/_authgated/app.$tenantSlug.maternity-cases.$id'
import { Route as AuthgatedAppTenantSlugLoansNewRouteImport } from './routes/_authgated/app.$tenantSlug.loans.new'
import { Route as AuthgatedAppTenantSlugLoansManageRouteImport } from './routes/_authgated/app.$tenantSlug.loans.manage'
import { Route as AuthgatedAppTenantSlugLoansApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.loans.approvals'
import { Route as AuthgatedAppTenantSlugLoansLoanIdRouteImport } from './routes/_authgated/app.$tenantSlug.loans.$loanId'
import { Route as AuthgatedAppTenantSlugLeaveNewRouteImport } from './routes/_authgated/app.$tenantSlug.leave.new'
import { Route as AuthgatedAppTenantSlugLeaveHolidaysRouteImport } from './routes/_authgated/app.$tenantSlug.leave.holidays'
import { Route as AuthgatedAppTenantSlugLeaveCompOffRouteImport } from './routes/_authgated/app.$tenantSlug.leave.comp-off'
import { Route as AuthgatedAppTenantSlugLeaveCalendarRouteImport } from './routes/_authgated/app.$tenantSlug.leave.calendar'
import { Route as AuthgatedAppTenantSlugLeaveBalancesRouteImport } from './routes/_authgated/app.$tenantSlug.leave.balances'
import { Route as AuthgatedAppTenantSlugLeaveApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.leave.approvals'
import { Route as AuthgatedAppTenantSlugLeaveIdRouteImport } from './routes/_authgated/app.$tenantSlug.leave.$id'
import { Route as AuthgatedAppTenantSlugHrDocumentsRouteImport } from './routes/_authgated/app.$tenantSlug.hr.documents'
import { Route as AuthgatedAppTenantSlugHrAssetsRouteImport } from './routes/_authgated/app.$tenantSlug.hr.assets'
import { Route as AuthgatedAppTenantSlugHiringReportsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.reports'
import { Route as AuthgatedAppTenantSlugHiringReferralsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.referrals'
import { Route as AuthgatedAppTenantSlugHiringJobsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.jobs'
import { Route as AuthgatedAppTenantSlugHiringInterviewsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.interviews'
import { Route as AuthgatedAppTenantSlugHiringCostsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.costs'
import { Route as AuthgatedAppTenantSlugHiringAnalyticsRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.analytics'
import { Route as AuthgatedAppTenantSlugHelpdeskNewRouteImport } from './routes/_authgated/app.$tenantSlug.helpdesk.new'
import { Route as AuthgatedAppTenantSlugExpensesNewRouteImport } from './routes/_authgated/app.$tenantSlug.expenses.new'
import { Route as AuthgatedAppTenantSlugExpensesBatchesRouteImport } from './routes/_authgated/app.$tenantSlug.expenses.batches'
import { Route as AuthgatedAppTenantSlugExpensesApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.expenses.approvals'
import { Route as AuthgatedAppTenantSlugExpensesIdRouteImport } from './routes/_authgated/app.$tenantSlug.expenses.$id'
import { Route as AuthgatedAppTenantSlugChangeRequestsNewRouteImport } from './routes/_authgated/app.$tenantSlug.change-requests.new'
import { Route as AuthgatedAppTenantSlugChangeRequestsIdRouteImport } from './routes/_authgated/app.$tenantSlug.change-requests.$id'
import { Route as AuthgatedAppTenantSlugBulkImportsNewRouteImport } from './routes/_authgated/app.$tenantSlug.bulk-imports.new'
import { Route as AuthgatedAppTenantSlugBulkImportsIdRouteImport } from './routes/_authgated/app.$tenantSlug.bulk-imports.$id'
import { Route as AuthgatedAppTenantSlugAttendanceTeamRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.team'
import { Route as AuthgatedAppTenantSlugAttendanceRegularizeRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.regularize'
import { Route as AuthgatedAppTenantSlugAttendanceRegisterRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.register'
import { Route as AuthgatedAppTenantSlugAttendanceMonthlySummaryRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.monthly-summary'
import { Route as AuthgatedAppTenantSlugAttendanceApprovalsRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.approvals'
import { Route as AuthgatedAppTenantSlugAccountingReturnsRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.returns'
import { Route as AuthgatedAppTenantSlugAccountingPostToBooksRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.post-to-books'
import { Route as AuthgatedAppTenantSlugAccountingPeriodLocksRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.period-locks'
import { Route as AuthgatedAppTenantSlugAccountingOpeningBalanceRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.opening-balance'
import { Route as AuthgatedAppTenantSlugAccountingAuditRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.audit'
import { Route as AuthgatedAppTenantSlugSurveysIdIndexRouteImport } from './routes/_authgated/app.$tenantSlug.surveys.$id.index'
import { Route as AuthgatedAppTenantSlugSettingsTaxCodesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.settings.tax-codes.index'
import { Route as AuthgatedAppTenantSlugSettingsChecklistsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.settings.checklists.index'
import { Route as AuthgatedAppTenantSlugPoshTrainingIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.training.index'
import { Route as AuthgatedAppTenantSlugPoshReportsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.reports.index'
import { Route as AuthgatedAppTenantSlugPoshPolicyIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.policy.index'
import { Route as AuthgatedAppTenantSlugPoshComplaintsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.complaints.index'
import { Route as AuthgatedAppTenantSlugPerformanceReviewsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.reviews.index'
import { Route as AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.one-on-ones.index'
import { Route as AuthgatedAppTenantSlugPerformanceMyResultsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.my-results.index'
import { Route as AuthgatedAppTenantSlugPerformanceGoalsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.goals.index'
import { Route as AuthgatedAppTenantSlugPerformanceCyclesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.performance.cycles.index'
import { Route as AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.tax-declaration.index'
import { Route as AuthgatedAppTenantSlugMeLettersIndexRouteImport } from './routes/_authgated/app.$tenantSlug.me.letters.index'
import { Route as AuthgatedAppTenantSlugMeDetailsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.me.details.index'
import { Route as AuthgatedAppTenantSlugMeAccountIndexRouteImport } from './routes/_authgated/app.$tenantSlug.me.account.index'
import { Route as AuthgatedAppTenantSlugHrOnboardingIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hr.onboarding.index'
import { Route as AuthgatedAppTenantSlugHrOffboardingIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hr.offboarding.index'
import { Route as AuthgatedAppTenantSlugHiringRequisitionsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.requisitions.index'
import { Route as AuthgatedAppTenantSlugHiringCandidatesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.candidates.index'
import { Route as AuthgatedAppTenantSlugAttendanceImportIndexRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.import.index'
import { Route as AuthgatedAppTenantSlugAccountingSalesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.index'
import { Route as AuthgatedAppTenantSlugAccountingReportsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.index'
import { Route as AuthgatedAppTenantSlugAccountingPurchasesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.purchases.index'
import { Route as AuthgatedAppTenantSlugAccountingMoneyIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.index'
import { Route as AuthgatedAppTenantSlugAccountingJournalsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.journals.index'
import { Route as AuthgatedAppTenantSlugAccountingItemsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.items.index'
import { Route as AuthgatedAppTenantSlugAccountingContactsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.contacts.index'
import { Route as AuthgatedAppTenantSlugAccountingAccountsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.accounts.index'
import { Route as AuthgatedAppTenantSlugTimesheetWeeksWeekStartRouteImport } from './routes/_authgated/app.$tenantSlug.timesheet.weeks.$weekStart'
import { Route as AuthgatedAppTenantSlugSurveysIdResultsRouteImport } from './routes/_authgated/app.$tenantSlug.surveys.$id.results'
import { Route as AuthgatedAppTenantSlugSettingsTaxCodesNewRouteImport } from './routes/_authgated/app.$tenantSlug.settings.tax-codes.new'
import { Route as AuthgatedAppTenantSlugSettingsChecklistsPreboardingRouteImport } from './routes/_authgated/app.$tenantSlug.settings.checklists.preboarding'
import { Route as AuthgatedAppTenantSlugSettingsChecklistsOnboardingRouteImport } from './routes/_authgated/app.$tenantSlug.settings.checklists.onboarding'
import { Route as AuthgatedAppTenantSlugSettingsChecklistsOffboardingRouteImport } from './routes/_authgated/app.$tenantSlug.settings.checklists.offboarding'
import { Route as AuthgatedAppTenantSlugPoshReportsIdRouteImport } from './routes/_authgated/app.$tenantSlug.posh.reports.$id'
import { Route as AuthgatedAppTenantSlugPoshPolicyIdRouteImport } from './routes/_authgated/app.$tenantSlug.posh.policy.$id'
import { Route as AuthgatedAppTenantSlugPoshComplaintsNewRouteImport } from './routes/_authgated/app.$tenantSlug.posh.complaints.new'
import { Route as AuthgatedAppTenantSlugPerformanceReviewsNewRouteImport } from './routes/_authgated/app.$tenantSlug.performance.reviews.new'
import { Route as AuthgatedAppTenantSlugPerformanceReviewsIdRouteImport } from './routes/_authgated/app.$tenantSlug.performance.reviews.$id'
import { Route as AuthgatedAppTenantSlugPerformanceOneOnOnesNewRouteImport } from './routes/_authgated/app.$tenantSlug.performance.one-on-ones.new'
import { Route as AuthgatedAppTenantSlugPerformanceOneOnOnesIdRouteImport } from './routes/_authgated/app.$tenantSlug.performance.one-on-ones.$id'
import { Route as AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRouteImport } from './routes/_authgated/app.$tenantSlug.performance.my-results.$cycleId'
import { Route as AuthgatedAppTenantSlugPerformanceGoalsNewRouteImport } from './routes/_authgated/app.$tenantSlug.performance.goals.new'
import { Route as AuthgatedAppTenantSlugPerformanceGoalsIdRouteImport } from './routes/_authgated/app.$tenantSlug.performance.goals.$id'
import { Route as AuthgatedAppTenantSlugPerformanceCyclesNewRouteImport } from './routes/_authgated/app.$tenantSlug.performance.cycles.new'
import { Route as AuthgatedAppTenantSlugPerformanceCyclesIdRouteImport } from './routes/_authgated/app.$tenantSlug.performance.cycles.$id'
import { Route as AuthgatedAppTenantSlugPeopleIdEditRouteImport } from './routes/_authgated/app.$tenantSlug.people.$id.edit'
import { Route as AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.tax-declaration.queue'
import { Route as AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.tax-declaration.$declId'
import { Route as AuthgatedAppTenantSlugPayrollFilingsIdRouteImport } from './routes/_authgated/app.$tenantSlug.payroll.filings.$id'
import { Route as AuthgatedAppTenantSlugMeSurveysIdRouteImport } from './routes/_authgated/app.$tenantSlug.me.surveys.$id'
import { Route as AuthgatedAppTenantSlugMeLettersIdRouteImport } from './routes/_authgated/app.$tenantSlug.me.letters.$id'
import { Route as AuthgatedAppTenantSlugMeDetailsItemIdRouteImport } from './routes/_authgated/app.$tenantSlug.me.details.$itemId'
import { Route as AuthgatedAppTenantSlugMeAccountSecurityRouteImport } from './routes/_authgated/app.$tenantSlug.me.account.security'
import { Route as AuthgatedAppTenantSlugMeAccountNotificationsRouteImport } from './routes/_authgated/app.$tenantSlug.me.account.notifications'
import { Route as AuthgatedAppTenantSlugHrOnboardingIdRouteImport } from './routes/_authgated/app.$tenantSlug.hr.onboarding.$id'
import { Route as AuthgatedAppTenantSlugHrOffboardingNewRouteImport } from './routes/_authgated/app.$tenantSlug.hr.offboarding.new'
import { Route as AuthgatedAppTenantSlugHrOffboardingIdRouteImport } from './routes/_authgated/app.$tenantSlug.hr.offboarding.$id'
import { Route as AuthgatedAppTenantSlugHiringRequisitionsNewRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.requisitions.new'
import { Route as AuthgatedAppTenantSlugHiringCandidatesIdRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.candidates.$id'
import { Route as AuthgatedAppTenantSlugHelpdeskTicketsIdRouteImport } from './routes/_authgated/app.$tenantSlug.helpdesk_.tickets.$id'
import { Route as AuthgatedAppTenantSlugAttendanceImportRunsRouteImport } from './routes/_authgated/app.$tenantSlug.attendance.import.runs'
import { Route as AuthgatedAppTenantSlugAccountingReportsTrialBalanceRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.trial-balance'
import { Route as AuthgatedAppTenantSlugAccountingReportsTdsReceivableRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.tds-receivable'
import { Route as AuthgatedAppTenantSlugAccountingReportsProfitAndLossRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.profit-and-loss'
import { Route as AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.msme-overdue'
import { Route as AuthgatedAppTenantSlugAccountingReportsBalanceSheetRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.reports.balance-sheet'
import { Route as AuthgatedAppTenantSlugAccountingPurchasesNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.purchases.new'
import { Route as AuthgatedAppTenantSlugAccountingPurchasesIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.purchases.$id'
import { Route as AuthgatedAppTenantSlugAccountingPayrollRunsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.payroll-runs.$id'
import { Route as AuthgatedAppTenantSlugAccountingLedgerAccountIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.ledger.$accountId'
import { Route as AuthgatedAppTenantSlugAccountingJournalsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.journals.new'
import { Route as AuthgatedAppTenantSlugAccountingJournalsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.journals.$id'
import { Route as AuthgatedAppTenantSlugAccountingItemsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.items.new'
import { Route as AuthgatedAppTenantSlugAccountingItemsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.items.$id'
import { Route as AuthgatedAppTenantSlugAccountingContactsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.contacts.new'
import { Route as AuthgatedAppTenantSlugAccountingContactsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.contacts.$id'
import { Route as AuthgatedAppTenantSlugAccountingAccountsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.accounts.new'
import { Route as AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.timesheet.admin.projects.index'
import { Route as AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.training.$moduleId.index'
import { Route as AuthgatedAppTenantSlugPoshComplaintsIdIndexRouteImport } from './routes/_authgated/app.$tenantSlug.posh.complaints.$id.index'
import { Route as AuthgatedAppTenantSlugHrOffboardingLettersIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hr.offboarding.letters.index'
import { Route as AuthgatedAppTenantSlugHiringRequisitionsIdIndexRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.requisitions.$id.index'
import { Route as AuthgatedAppTenantSlugAccountingSalesQuotesIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.quotes.index'
import { Route as AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.receipts.index'
import { Route as AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.payments.index'
import { Route as AuthgatedAppTenantSlugTimesheetAdminProjectsIdRouteImport } from './routes/_authgated/app.$tenantSlug.timesheet.admin.projects.$id'
import { Route as AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRouteImport } from './routes/_authgated/app.$tenantSlug.posh.training.$moduleId.quiz'
import { Route as AuthgatedAppTenantSlugPoshComplaintsIdManageRouteImport } from './routes/_authgated/app.$tenantSlug.posh.complaints.$id.manage'
import { Route as AuthgatedAppTenantSlugHiringRequisitionsIdReportRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.requisitions.$id.report'
import { Route as AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRouteImport } from './routes/_authgated/app.$tenantSlug.hiring.requisitions.$id.pipeline'
import { Route as AuthgatedAppTenantSlugAccountingSalesQuotesNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.quotes.new'
import { Route as AuthgatedAppTenantSlugAccountingSalesQuotesIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.quotes.$id'
import { Route as AuthgatedAppTenantSlugAccountingSalesInvoicesNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.invoices.new'
import { Route as AuthgatedAppTenantSlugAccountingSalesInvoicesIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.sales.invoices.$id'
import { Route as AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.receipts.new'
import { Route as AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.receipts.$id'
import { Route as AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.payments.new'
import { Route as AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRouteImport } from './routes/_authgated/app.$tenantSlug.accounting.money.payments.$id'
import { Route as AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRouteImport } from './routes/_authgated/app.$tenantSlug.hr.offboarding.letters.$id.acknowledge'

const AuthgatedRoute = AuthgatedRouteImport.update({
  id: '/_authgated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthgatedSuperadminRoute = AuthgatedSuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => AuthgatedRoute,
} as any)
const AuthSelectWorkspaceRoute = AuthSelectWorkspaceRouteImport.update({
  id: '/select-workspace',
  path: '/select-workspace',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfirmEmailRoute = AuthConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faVerifyRoute = Auth2faVerifyRouteImport.update({
  id: '/2fa-verify',
  path: '/2fa-verify',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faSetupRoute = Auth2faSetupRouteImport.update({
  id: '/2fa-setup',
  path: '/2fa-setup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthgatedSuperadminIndexRoute =
  AuthgatedSuperadminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminUsersRoute =
  AuthgatedSuperadminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminPlansRoute =
  AuthgatedSuperadminPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminFunnelRoute =
  AuthgatedSuperadminFunnelRouteImport.update({
    id: '/funnel',
    path: '/funnel',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminAuditRoute =
  AuthgatedSuperadminAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedAppTenantSlugRoute = AuthgatedAppTenantSlugRouteImport.update({
  id: '/app/$tenantSlug',
  path: '/app/$tenantSlug',
  getParentRoute: () => AuthgatedRoute,
} as any)
const AuthgatedSuperadminTenantsIndexRoute =
  AuthgatedSuperadminTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminSupportIndexRoute =
  AuthgatedSuperadminSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedAppTenantSlugIndexRoute =
  AuthgatedAppTenantSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedSuperadminTenantsIdRoute =
  AuthgatedSuperadminTenantsIdRouteImport.update({
    id: '/tenants/$id',
    path: '/tenants/$id',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedSuperadminSupportIdRoute =
  AuthgatedSuperadminSupportIdRouteImport.update({
    id: '/support/$id',
    path: '/support/$id',
    getParentRoute: () => AuthgatedSuperadminRoute,
  } as any)
const AuthgatedAppTenantSlugTasksRoute =
  AuthgatedAppTenantSlugTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSupportTicketsRoute =
  AuthgatedAppTenantSlugSupportTicketsRouteImport.update({
    id: '/support-tickets',
    path: '/support-tickets',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSkillsRoute =
  AuthgatedAppTenantSlugSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReferralsRoute =
  AuthgatedAppTenantSlugReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugOverviewRoute =
  AuthgatedAppTenantSlugOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMyTimeRoute =
  AuthgatedAppTenantSlugMyTimeRouteImport.update({
    id: '/my-time',
    path: '/my-time',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugInterviewsRoute =
  AuthgatedAppTenantSlugInterviewsRouteImport.update({
    id: '/interviews',
    path: '/interviews',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHolidaysRoute =
  AuthgatedAppTenantSlugHolidaysRouteImport.update({
    id: '/holidays',
    path: '/holidays',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHelpdeskRoute =
  AuthgatedAppTenantSlugHelpdeskRouteImport.update({
    id: '/helpdesk',
    path: '/helpdesk',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugExitTasksRoute =
  AuthgatedAppTenantSlugExitTasksRouteImport.update({
    id: '/exit-tasks',
    path: '/exit-tasks',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugDirectoryRoute =
  AuthgatedAppTenantSlugDirectoryRouteImport.update({
    id: '/directory',
    path: '/directory',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugComplianceRoute =
  AuthgatedAppTenantSlugComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugCompOffRoute =
  AuthgatedAppTenantSlugCompOffRouteImport.update({
    id: '/comp-off',
    path: '/comp-off',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugCalendarRoute =
  AuthgatedAppTenantSlugCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugApprovalsRoute =
  AuthgatedAppTenantSlugApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugApprovalDelegationRoute =
  AuthgatedAppTenantSlugApprovalDelegationRouteImport.update({
    id: '/approval-delegation',
    path: '/approval-delegation',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAnnouncementsRoute =
  AuthgatedAppTenantSlugAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugWfhIndexRoute =
  AuthgatedAppTenantSlugWfhIndexRouteImport.update({
    id: '/wfh/',
    path: '/wfh/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute =
  AuthgatedAppTenantSlugTravelPreapprovalsIndexRouteImport.update({
    id: '/travel-preapprovals/',
    path: '/travel-preapprovals/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTimesheetIndexRoute =
  AuthgatedAppTenantSlugTimesheetIndexRouteImport.update({
    id: '/timesheet/',
    path: '/timesheet/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSurveysIndexRoute =
  AuthgatedAppTenantSlugSurveysIndexRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugShiftsIndexRoute =
  AuthgatedAppTenantSlugShiftsIndexRouteImport.update({
    id: '/shifts/',
    path: '/shifts/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsIndexRoute =
  AuthgatedAppTenantSlugSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReportsIndexRoute =
  AuthgatedAppTenantSlugReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshIndexRoute =
  AuthgatedAppTenantSlugPoshIndexRouteImport.update({
    id: '/posh/',
    path: '/posh/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceIndexRoute =
  AuthgatedAppTenantSlugPerformanceIndexRouteImport.update({
    id: '/performance/',
    path: '/performance/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeopleIndexRoute =
  AuthgatedAppTenantSlugPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollIndexRoute =
  AuthgatedAppTenantSlugPayrollIndexRouteImport.update({
    id: '/payroll/',
    path: '/payroll/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMaternityCasesIndexRoute =
  AuthgatedAppTenantSlugMaternityCasesIndexRouteImport.update({
    id: '/maternity-cases/',
    path: '/maternity-cases/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLoansIndexRoute =
  AuthgatedAppTenantSlugLoansIndexRouteImport.update({
    id: '/loans/',
    path: '/loans/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveIndexRoute =
  AuthgatedAppTenantSlugLeaveIndexRouteImport.update({
    id: '/leave/',
    path: '/leave/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrIndexRoute =
  AuthgatedAppTenantSlugHrIndexRouteImport.update({
    id: '/hr/',
    path: '/hr/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringIndexRoute =
  AuthgatedAppTenantSlugHiringIndexRouteImport.update({
    id: '/hiring/',
    path: '/hiring/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugExpensesIndexRoute =
  AuthgatedAppTenantSlugExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugChangeRequestsIndexRoute =
  AuthgatedAppTenantSlugChangeRequestsIndexRouteImport.update({
    id: '/change-requests/',
    path: '/change-requests/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugBulkImportsIndexRoute =
  AuthgatedAppTenantSlugBulkImportsIndexRouteImport.update({
    id: '/bulk-imports/',
    path: '/bulk-imports/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceIndexRoute =
  AuthgatedAppTenantSlugAttendanceIndexRouteImport.update({
    id: '/attendance/',
    path: '/attendance/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingIndexRoute =
  AuthgatedAppTenantSlugAccountingIndexRouteImport.update({
    id: '/accounting/',
    path: '/accounting/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugWfhApprovalsRoute =
  AuthgatedAppTenantSlugWfhApprovalsRouteImport.update({
    id: '/wfh/approvals',
    path: '/wfh/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugWfhIdRoute =
  AuthgatedAppTenantSlugWfhIdRouteImport.update({
    id: '/wfh/$id',
    path: '/wfh/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTravelPreapprovalsNewRoute =
  AuthgatedAppTenantSlugTravelPreapprovalsNewRouteImport.update({
    id: '/travel-preapprovals/new',
    path: '/travel-preapprovals/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTravelPreapprovalsIdRoute =
  AuthgatedAppTenantSlugTravelPreapprovalsIdRouteImport.update({
    id: '/travel-preapprovals/$id',
    path: '/travel-preapprovals/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTimesheetInboxRoute =
  AuthgatedAppTenantSlugTimesheetInboxRouteImport.update({
    id: '/timesheet/inbox',
    path: '/timesheet/inbox',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSurveysNewRoute =
  AuthgatedAppTenantSlugSurveysNewRouteImport.update({
    id: '/surveys/new',
    path: '/surveys/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSupportTicketsIdRoute =
  AuthgatedAppTenantSlugSupportTicketsIdRouteImport.update({
    id: '/support-tickets_/$id',
    path: '/support-tickets/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSupportTicketsNewRoute =
  AuthgatedAppTenantSlugSupportTicketsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthgatedAppTenantSlugSupportTicketsRoute,
  } as any)
const AuthgatedAppTenantSlugShiftsSwapsRoute =
  AuthgatedAppTenantSlugShiftsSwapsRouteImport.update({
    id: '/shifts/swaps',
    path: '/shifts/swaps',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugShiftsRosterRoute =
  AuthgatedAppTenantSlugShiftsRosterRouteImport.update({
    id: '/shifts/roster',
    path: '/shifts/roster',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsWorkspaceRoute =
  AuthgatedAppTenantSlugSettingsWorkspaceRouteImport.update({
    id: '/settings/workspace',
    path: '/settings/workspace',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsWebhooksRoute =
  AuthgatedAppTenantSlugSettingsWebhooksRouteImport.update({
    id: '/settings/webhooks',
    path: '/settings/webhooks',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsTallyMappingsRoute =
  AuthgatedAppTenantSlugSettingsTallyMappingsRouteImport.update({
    id: '/settings/tally-mappings',
    path: '/settings/tally-mappings',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsSkillsRoute =
  AuthgatedAppTenantSlugSettingsSkillsRouteImport.update({
    id: '/settings/skills',
    path: '/settings/skills',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsShiftsRoute =
  AuthgatedAppTenantSlugSettingsShiftsRouteImport.update({
    id: '/settings/shifts',
    path: '/settings/shifts',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsSecurityRoute =
  AuthgatedAppTenantSlugSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute =
  AuthgatedAppTenantSlugSettingsScorecardTemplatesRouteImport.update({
    id: '/settings/scorecard-templates',
    path: '/settings/scorecard-templates',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsRolesRoute =
  AuthgatedAppTenantSlugSettingsRolesRouteImport.update({
    id: '/settings/roles',
    path: '/settings/roles',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsPostingAccountsRoute =
  AuthgatedAppTenantSlugSettingsPostingAccountsRouteImport.update({
    id: '/settings/posting-accounts',
    path: '/settings/posting-accounts',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsPaymentAccountsRoute =
  AuthgatedAppTenantSlugSettingsPaymentAccountsRouteImport.update({
    id: '/settings/payment-accounts',
    path: '/settings/payment-accounts',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute =
  AuthgatedAppTenantSlugSettingsOnboardingTemplatesRouteImport.update({
    id: '/settings/onboarding-templates',
    path: '/settings/onboarding-templates',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsNotificationsRoute =
  AuthgatedAppTenantSlugSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsModulesRoute =
  AuthgatedAppTenantSlugSettingsModulesRouteImport.update({
    id: '/settings/modules',
    path: '/settings/modules',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsLeaveTypesRoute =
  AuthgatedAppTenantSlugSettingsLeaveTypesRouteImport.update({
    id: '/settings/leave-types',
    path: '/settings/leave-types',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsJdTemplatesRoute =
  AuthgatedAppTenantSlugSettingsJdTemplatesRouteImport.update({
    id: '/settings/jd-templates',
    path: '/settings/jd-templates',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsHolidaysRoute =
  AuthgatedAppTenantSlugSettingsHolidaysRouteImport.update({
    id: '/settings/holidays',
    path: '/settings/holidays',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsHiringEmailsRoute =
  AuthgatedAppTenantSlugSettingsHiringEmailsRouteImport.update({
    id: '/settings/hiring-emails',
    path: '/settings/hiring-emails',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsHiringApprovalsRoute =
  AuthgatedAppTenantSlugSettingsHiringApprovalsRouteImport.update({
    id: '/settings/hiring-approvals',
    path: '/settings/hiring-approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute =
  AuthgatedAppTenantSlugSettingsExpenseCategoriesRouteImport.update({
    id: '/settings/expense-categories',
    path: '/settings/expense-categories',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsEntitiesRoute =
  AuthgatedAppTenantSlugSettingsEntitiesRouteImport.update({
    id: '/settings/entities',
    path: '/settings/entities',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsDepartmentsRoute =
  AuthgatedAppTenantSlugSettingsDepartmentsRouteImport.update({
    id: '/settings/departments',
    path: '/settings/departments',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsCustomFieldsRoute =
  AuthgatedAppTenantSlugSettingsCustomFieldsRouteImport.update({
    id: '/settings/custom-fields',
    path: '/settings/custom-fields',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsCompetenciesRoute =
  AuthgatedAppTenantSlugSettingsCompetenciesRouteImport.update({
    id: '/settings/competencies',
    path: '/settings/competencies',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsCoaRoute =
  AuthgatedAppTenantSlugSettingsCoaRouteImport.update({
    id: '/settings/coa',
    path: '/settings/coa',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsCareersBrandingRoute =
  AuthgatedAppTenantSlugSettingsCareersBrandingRouteImport.update({
    id: '/settings/careers-branding',
    path: '/settings/careers-branding',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsBillingRoute =
  AuthgatedAppTenantSlugSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAuditLogRoute =
  AuthgatedAppTenantSlugSettingsAuditLogRouteImport.update({
    id: '/settings/audit-log',
    path: '/settings/audit-log',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute =
  AuthgatedAppTenantSlugSettingsAttendanceDevicesRouteImport.update({
    id: '/settings/attendance-devices',
    path: '/settings/attendance-devices',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute =
  AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRouteImport.update({
    id: '/settings/attendance-device-profiles',
    path: '/settings/attendance-device-profiles',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAttendanceRoute =
  AuthgatedAppTenantSlugSettingsAttendanceRouteImport.update({
    id: '/settings/attendance',
    path: '/settings/attendance',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAssetTypesRoute =
  AuthgatedAppTenantSlugSettingsAssetTypesRouteImport.update({
    id: '/settings/asset-types',
    path: '/settings/asset-types',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsApiTokensRoute =
  AuthgatedAppTenantSlugSettingsApiTokensRouteImport.update({
    id: '/settings/api-tokens',
    path: '/settings/api-tokens',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsAnalyticsRoute =
  AuthgatedAppTenantSlugSettingsAnalyticsRouteImport.update({
    id: '/settings/analytics',
    path: '/settings/analytics',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReportsSalaryRegisterRoute =
  AuthgatedAppTenantSlugReportsSalaryRegisterRouteImport.update({
    id: '/reports/salary-register',
    path: '/reports/salary-register',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReportsPayrollCostRoute =
  AuthgatedAppTenantSlugReportsPayrollCostRouteImport.update({
    id: '/reports/payroll-cost',
    path: '/reports/payroll-cost',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReportsHeadcountRoute =
  AuthgatedAppTenantSlugReportsHeadcountRouteImport.update({
    id: '/reports/headcount',
    path: '/reports/headcount',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugReportsAnalyticsRoute =
  AuthgatedAppTenantSlugReportsAnalyticsRouteImport.update({
    id: '/reports/analytics',
    path: '/reports/analytics',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshIccRoute =
  AuthgatedAppTenantSlugPoshIccRouteImport.update({
    id: '/posh/icc',
    path: '/posh/icc',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshComplianceRoute =
  AuthgatedAppTenantSlugPoshComplianceRouteImport.update({
    id: '/posh/compliance',
    path: '/posh/compliance',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshCertificatesRoute =
  AuthgatedAppTenantSlugPoshCertificatesRouteImport.update({
    id: '/posh/certificates',
    path: '/posh/certificates',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshAboutRoute =
  AuthgatedAppTenantSlugPoshAboutRouteImport.update({
    id: '/posh/about',
    path: '/posh/about',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceFeedbackRoute =
  AuthgatedAppTenantSlugPerformanceFeedbackRouteImport.update({
    id: '/performance/feedback',
    path: '/performance/feedback',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeoplePreboardingRoute =
  AuthgatedAppTenantSlugPeoplePreboardingRouteImport.update({
    id: '/people/preboarding',
    path: '/people/preboarding',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeopleOrgChartRoute =
  AuthgatedAppTenantSlugPeopleOrgChartRouteImport.update({
    id: '/people/org-chart',
    path: '/people/org-chart',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeopleNewRoute =
  AuthgatedAppTenantSlugPeopleNewRouteImport.update({
    id: '/people/new',
    path: '/people/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeopleIdRoute =
  AuthgatedAppTenantSlugPeopleIdRouteImport.update({
    id: '/people/$id',
    path: '/people/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollStatutoryBonusRoute =
  AuthgatedAppTenantSlugPayrollStatutoryBonusRouteImport.update({
    id: '/payroll/statutory-bonus',
    path: '/payroll/statutory-bonus',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollStatutoryRoute =
  AuthgatedAppTenantSlugPayrollStatutoryRouteImport.update({
    id: '/payroll/statutory',
    path: '/payroll/statutory',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollPfCeilingRoute =
  AuthgatedAppTenantSlugPayrollPfCeilingRouteImport.update({
    id: '/payroll/pf-ceiling',
    path: '/payroll/pf-ceiling',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollNewRoute =
  AuthgatedAppTenantSlugPayrollNewRouteImport.update({
    id: '/payroll/new',
    path: '/payroll/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollFilingsRoute =
  AuthgatedAppTenantSlugPayrollFilingsRouteImport.update({
    id: '/payroll/filings',
    path: '/payroll/filings',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollIdRoute =
  AuthgatedAppTenantSlugPayrollIdRouteImport.update({
    id: '/payroll/$id',
    path: '/payroll/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeTaxRoute =
  AuthgatedAppTenantSlugMeTaxRouteImport.update({
    id: '/me/tax',
    path: '/me/tax',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeSurveysRoute =
  AuthgatedAppTenantSlugMeSurveysRouteImport.update({
    id: '/me/surveys',
    path: '/me/surveys',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeSecurityRoute =
  AuthgatedAppTenantSlugMeSecurityRouteImport.update({
    id: '/me/security',
    path: '/me/security',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeSalaryRoute =
  AuthgatedAppTenantSlugMeSalaryRouteImport.update({
    id: '/me/salary',
    path: '/me/salary',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeProfileRoute =
  AuthgatedAppTenantSlugMeProfileRouteImport.update({
    id: '/me/profile',
    path: '/me/profile',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMePayRoute =
  AuthgatedAppTenantSlugMePayRouteImport.update({
    id: '/me/pay',
    path: '/me/pay',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeLoansRoute =
  AuthgatedAppTenantSlugMeLoansRouteImport.update({
    id: '/me/loans',
    path: '/me/loans',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeExitRoute =
  AuthgatedAppTenantSlugMeExitRouteImport.update({
    id: '/me/exit',
    path: '/me/exit',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeDocumentsRoute =
  AuthgatedAppTenantSlugMeDocumentsRouteImport.update({
    id: '/me/documents',
    path: '/me/documents',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeAssetsRoute =
  AuthgatedAppTenantSlugMeAssetsRouteImport.update({
    id: '/me/assets',
    path: '/me/assets',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMaternityCasesNewRoute =
  AuthgatedAppTenantSlugMaternityCasesNewRouteImport.update({
    id: '/maternity-cases/new',
    path: '/maternity-cases/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMaternityCasesIdRoute =
  AuthgatedAppTenantSlugMaternityCasesIdRouteImport.update({
    id: '/maternity-cases/$id',
    path: '/maternity-cases/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLoansNewRoute =
  AuthgatedAppTenantSlugLoansNewRouteImport.update({
    id: '/loans/new',
    path: '/loans/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLoansManageRoute =
  AuthgatedAppTenantSlugLoansManageRouteImport.update({
    id: '/loans/manage',
    path: '/loans/manage',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLoansApprovalsRoute =
  AuthgatedAppTenantSlugLoansApprovalsRouteImport.update({
    id: '/loans/approvals',
    path: '/loans/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLoansLoanIdRoute =
  AuthgatedAppTenantSlugLoansLoanIdRouteImport.update({
    id: '/loans/$loanId',
    path: '/loans/$loanId',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveNewRoute =
  AuthgatedAppTenantSlugLeaveNewRouteImport.update({
    id: '/leave/new',
    path: '/leave/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveHolidaysRoute =
  AuthgatedAppTenantSlugLeaveHolidaysRouteImport.update({
    id: '/leave/holidays',
    path: '/leave/holidays',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveCompOffRoute =
  AuthgatedAppTenantSlugLeaveCompOffRouteImport.update({
    id: '/leave/comp-off',
    path: '/leave/comp-off',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveCalendarRoute =
  AuthgatedAppTenantSlugLeaveCalendarRouteImport.update({
    id: '/leave/calendar',
    path: '/leave/calendar',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveBalancesRoute =
  AuthgatedAppTenantSlugLeaveBalancesRouteImport.update({
    id: '/leave/balances',
    path: '/leave/balances',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveApprovalsRoute =
  AuthgatedAppTenantSlugLeaveApprovalsRouteImport.update({
    id: '/leave/approvals',
    path: '/leave/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugLeaveIdRoute =
  AuthgatedAppTenantSlugLeaveIdRouteImport.update({
    id: '/leave/$id',
    path: '/leave/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrDocumentsRoute =
  AuthgatedAppTenantSlugHrDocumentsRouteImport.update({
    id: '/hr/documents',
    path: '/hr/documents',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrAssetsRoute =
  AuthgatedAppTenantSlugHrAssetsRouteImport.update({
    id: '/hr/assets',
    path: '/hr/assets',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringReportsRoute =
  AuthgatedAppTenantSlugHiringReportsRouteImport.update({
    id: '/hiring/reports',
    path: '/hiring/reports',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringReferralsRoute =
  AuthgatedAppTenantSlugHiringReferralsRouteImport.update({
    id: '/hiring/referrals',
    path: '/hiring/referrals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringJobsRoute =
  AuthgatedAppTenantSlugHiringJobsRouteImport.update({
    id: '/hiring/jobs',
    path: '/hiring/jobs',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringInterviewsRoute =
  AuthgatedAppTenantSlugHiringInterviewsRouteImport.update({
    id: '/hiring/interviews',
    path: '/hiring/interviews',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringCostsRoute =
  AuthgatedAppTenantSlugHiringCostsRouteImport.update({
    id: '/hiring/costs',
    path: '/hiring/costs',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringAnalyticsRoute =
  AuthgatedAppTenantSlugHiringAnalyticsRouteImport.update({
    id: '/hiring/analytics',
    path: '/hiring/analytics',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHelpdeskNewRoute =
  AuthgatedAppTenantSlugHelpdeskNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthgatedAppTenantSlugHelpdeskRoute,
  } as any)
const AuthgatedAppTenantSlugExpensesNewRoute =
  AuthgatedAppTenantSlugExpensesNewRouteImport.update({
    id: '/expenses/new',
    path: '/expenses/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugExpensesBatchesRoute =
  AuthgatedAppTenantSlugExpensesBatchesRouteImport.update({
    id: '/expenses/batches',
    path: '/expenses/batches',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugExpensesApprovalsRoute =
  AuthgatedAppTenantSlugExpensesApprovalsRouteImport.update({
    id: '/expenses/approvals',
    path: '/expenses/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugExpensesIdRoute =
  AuthgatedAppTenantSlugExpensesIdRouteImport.update({
    id: '/expenses/$id',
    path: '/expenses/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugChangeRequestsNewRoute =
  AuthgatedAppTenantSlugChangeRequestsNewRouteImport.update({
    id: '/change-requests/new',
    path: '/change-requests/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugChangeRequestsIdRoute =
  AuthgatedAppTenantSlugChangeRequestsIdRouteImport.update({
    id: '/change-requests/$id',
    path: '/change-requests/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugBulkImportsNewRoute =
  AuthgatedAppTenantSlugBulkImportsNewRouteImport.update({
    id: '/bulk-imports/new',
    path: '/bulk-imports/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugBulkImportsIdRoute =
  AuthgatedAppTenantSlugBulkImportsIdRouteImport.update({
    id: '/bulk-imports/$id',
    path: '/bulk-imports/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceTeamRoute =
  AuthgatedAppTenantSlugAttendanceTeamRouteImport.update({
    id: '/attendance/team',
    path: '/attendance/team',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceRegularizeRoute =
  AuthgatedAppTenantSlugAttendanceRegularizeRouteImport.update({
    id: '/attendance/regularize',
    path: '/attendance/regularize',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceRegisterRoute =
  AuthgatedAppTenantSlugAttendanceRegisterRouteImport.update({
    id: '/attendance/register',
    path: '/attendance/register',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute =
  AuthgatedAppTenantSlugAttendanceMonthlySummaryRouteImport.update({
    id: '/attendance/monthly-summary',
    path: '/attendance/monthly-summary',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceApprovalsRoute =
  AuthgatedAppTenantSlugAttendanceApprovalsRouteImport.update({
    id: '/attendance/approvals',
    path: '/attendance/approvals',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReturnsRoute =
  AuthgatedAppTenantSlugAccountingReturnsRouteImport.update({
    id: '/accounting/returns',
    path: '/accounting/returns',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPostToBooksRoute =
  AuthgatedAppTenantSlugAccountingPostToBooksRouteImport.update({
    id: '/accounting/post-to-books',
    path: '/accounting/post-to-books',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPeriodLocksRoute =
  AuthgatedAppTenantSlugAccountingPeriodLocksRouteImport.update({
    id: '/accounting/period-locks',
    path: '/accounting/period-locks',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingOpeningBalanceRoute =
  AuthgatedAppTenantSlugAccountingOpeningBalanceRouteImport.update({
    id: '/accounting/opening-balance',
    path: '/accounting/opening-balance',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingAuditRoute =
  AuthgatedAppTenantSlugAccountingAuditRouteImport.update({
    id: '/accounting/audit',
    path: '/accounting/audit',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSurveysIdIndexRoute =
  AuthgatedAppTenantSlugSurveysIdIndexRouteImport.update({
    id: '/surveys/$id/',
    path: '/surveys/$id/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute =
  AuthgatedAppTenantSlugSettingsTaxCodesIndexRouteImport.update({
    id: '/settings/tax-codes/',
    path: '/settings/tax-codes/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsChecklistsIndexRoute =
  AuthgatedAppTenantSlugSettingsChecklistsIndexRouteImport.update({
    id: '/settings/checklists/',
    path: '/settings/checklists/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshTrainingIndexRoute =
  AuthgatedAppTenantSlugPoshTrainingIndexRouteImport.update({
    id: '/posh/training/',
    path: '/posh/training/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshReportsIndexRoute =
  AuthgatedAppTenantSlugPoshReportsIndexRouteImport.update({
    id: '/posh/reports/',
    path: '/posh/reports/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshPolicyIndexRoute =
  AuthgatedAppTenantSlugPoshPolicyIndexRouteImport.update({
    id: '/posh/policy/',
    path: '/posh/policy/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshComplaintsIndexRoute =
  AuthgatedAppTenantSlugPoshComplaintsIndexRouteImport.update({
    id: '/posh/complaints/',
    path: '/posh/complaints/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceReviewsIndexRoute =
  AuthgatedAppTenantSlugPerformanceReviewsIndexRouteImport.update({
    id: '/performance/reviews/',
    path: '/performance/reviews/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute =
  AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRouteImport.update({
    id: '/performance/one-on-ones/',
    path: '/performance/one-on-ones/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute =
  AuthgatedAppTenantSlugPerformanceMyResultsIndexRouteImport.update({
    id: '/performance/my-results/',
    path: '/performance/my-results/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceGoalsIndexRoute =
  AuthgatedAppTenantSlugPerformanceGoalsIndexRouteImport.update({
    id: '/performance/goals/',
    path: '/performance/goals/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceCyclesIndexRoute =
  AuthgatedAppTenantSlugPerformanceCyclesIndexRouteImport.update({
    id: '/performance/cycles/',
    path: '/performance/cycles/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute =
  AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRouteImport.update({
    id: '/payroll/tax-declaration/',
    path: '/payroll/tax-declaration/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeLettersIndexRoute =
  AuthgatedAppTenantSlugMeLettersIndexRouteImport.update({
    id: '/me/letters/',
    path: '/me/letters/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeDetailsIndexRoute =
  AuthgatedAppTenantSlugMeDetailsIndexRouteImport.update({
    id: '/me/details/',
    path: '/me/details/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeAccountIndexRoute =
  AuthgatedAppTenantSlugMeAccountIndexRouteImport.update({
    id: '/me/account/',
    path: '/me/account/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOnboardingIndexRoute =
  AuthgatedAppTenantSlugHrOnboardingIndexRouteImport.update({
    id: '/hr/onboarding/',
    path: '/hr/onboarding/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOffboardingIndexRoute =
  AuthgatedAppTenantSlugHrOffboardingIndexRouteImport.update({
    id: '/hr/offboarding/',
    path: '/hr/offboarding/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringRequisitionsIndexRoute =
  AuthgatedAppTenantSlugHiringRequisitionsIndexRouteImport.update({
    id: '/hiring/requisitions/',
    path: '/hiring/requisitions/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringCandidatesIndexRoute =
  AuthgatedAppTenantSlugHiringCandidatesIndexRouteImport.update({
    id: '/hiring/candidates/',
    path: '/hiring/candidates/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceImportIndexRoute =
  AuthgatedAppTenantSlugAttendanceImportIndexRouteImport.update({
    id: '/attendance/import/',
    path: '/attendance/import/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesIndexRoute =
  AuthgatedAppTenantSlugAccountingSalesIndexRouteImport.update({
    id: '/accounting/sales/',
    path: '/accounting/sales/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsIndexRoute =
  AuthgatedAppTenantSlugAccountingReportsIndexRouteImport.update({
    id: '/accounting/reports/',
    path: '/accounting/reports/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPurchasesIndexRoute =
  AuthgatedAppTenantSlugAccountingPurchasesIndexRouteImport.update({
    id: '/accounting/purchases/',
    path: '/accounting/purchases/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyIndexRoute =
  AuthgatedAppTenantSlugAccountingMoneyIndexRouteImport.update({
    id: '/accounting/money/',
    path: '/accounting/money/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingJournalsIndexRoute =
  AuthgatedAppTenantSlugAccountingJournalsIndexRouteImport.update({
    id: '/accounting/journals/',
    path: '/accounting/journals/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingItemsIndexRoute =
  AuthgatedAppTenantSlugAccountingItemsIndexRouteImport.update({
    id: '/accounting/items/',
    path: '/accounting/items/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingContactsIndexRoute =
  AuthgatedAppTenantSlugAccountingContactsIndexRouteImport.update({
    id: '/accounting/contacts/',
    path: '/accounting/contacts/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingAccountsIndexRoute =
  AuthgatedAppTenantSlugAccountingAccountsIndexRouteImport.update({
    id: '/accounting/accounts/',
    path: '/accounting/accounts/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute =
  AuthgatedAppTenantSlugTimesheetWeeksWeekStartRouteImport.update({
    id: '/timesheet/weeks/$weekStart',
    path: '/timesheet/weeks/$weekStart',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSurveysIdResultsRoute =
  AuthgatedAppTenantSlugSurveysIdResultsRouteImport.update({
    id: '/surveys/$id/results',
    path: '/surveys/$id/results',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsTaxCodesNewRoute =
  AuthgatedAppTenantSlugSettingsTaxCodesNewRouteImport.update({
    id: '/settings/tax-codes/new',
    path: '/settings/tax-codes/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute =
  AuthgatedAppTenantSlugSettingsChecklistsPreboardingRouteImport.update({
    id: '/settings/checklists/preboarding',
    path: '/settings/checklists/preboarding',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute =
  AuthgatedAppTenantSlugSettingsChecklistsOnboardingRouteImport.update({
    id: '/settings/checklists/onboarding',
    path: '/settings/checklists/onboarding',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute =
  AuthgatedAppTenantSlugSettingsChecklistsOffboardingRouteImport.update({
    id: '/settings/checklists/offboarding',
    path: '/settings/checklists/offboarding',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshReportsIdRoute =
  AuthgatedAppTenantSlugPoshReportsIdRouteImport.update({
    id: '/posh/reports/$id',
    path: '/posh/reports/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshPolicyIdRoute =
  AuthgatedAppTenantSlugPoshPolicyIdRouteImport.update({
    id: '/posh/policy/$id',
    path: '/posh/policy/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshComplaintsNewRoute =
  AuthgatedAppTenantSlugPoshComplaintsNewRouteImport.update({
    id: '/posh/complaints/new',
    path: '/posh/complaints/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceReviewsNewRoute =
  AuthgatedAppTenantSlugPerformanceReviewsNewRouteImport.update({
    id: '/performance/reviews/new',
    path: '/performance/reviews/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceReviewsIdRoute =
  AuthgatedAppTenantSlugPerformanceReviewsIdRouteImport.update({
    id: '/performance/reviews/$id',
    path: '/performance/reviews/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute =
  AuthgatedAppTenantSlugPerformanceOneOnOnesNewRouteImport.update({
    id: '/performance/one-on-ones/new',
    path: '/performance/one-on-ones/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute =
  AuthgatedAppTenantSlugPerformanceOneOnOnesIdRouteImport.update({
    id: '/performance/one-on-ones/$id',
    path: '/performance/one-on-ones/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute =
  AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRouteImport.update({
    id: '/performance/my-results/$cycleId',
    path: '/performance/my-results/$cycleId',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceGoalsNewRoute =
  AuthgatedAppTenantSlugPerformanceGoalsNewRouteImport.update({
    id: '/performance/goals/new',
    path: '/performance/goals/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceGoalsIdRoute =
  AuthgatedAppTenantSlugPerformanceGoalsIdRouteImport.update({
    id: '/performance/goals/$id',
    path: '/performance/goals/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceCyclesNewRoute =
  AuthgatedAppTenantSlugPerformanceCyclesNewRouteImport.update({
    id: '/performance/cycles/new',
    path: '/performance/cycles/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPerformanceCyclesIdRoute =
  AuthgatedAppTenantSlugPerformanceCyclesIdRouteImport.update({
    id: '/performance/cycles/$id',
    path: '/performance/cycles/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPeopleIdEditRoute =
  AuthgatedAppTenantSlugPeopleIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthgatedAppTenantSlugPeopleIdRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute =
  AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRouteImport.update({
    id: '/payroll/tax-declaration/queue',
    path: '/payroll/tax-declaration/queue',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute =
  AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRouteImport.update({
    id: '/payroll/tax-declaration/$declId',
    path: '/payroll/tax-declaration/$declId',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPayrollFilingsIdRoute =
  AuthgatedAppTenantSlugPayrollFilingsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthgatedAppTenantSlugPayrollFilingsRoute,
  } as any)
const AuthgatedAppTenantSlugMeSurveysIdRoute =
  AuthgatedAppTenantSlugMeSurveysIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthgatedAppTenantSlugMeSurveysRoute,
  } as any)
const AuthgatedAppTenantSlugMeLettersIdRoute =
  AuthgatedAppTenantSlugMeLettersIdRouteImport.update({
    id: '/me/letters/$id',
    path: '/me/letters/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeDetailsItemIdRoute =
  AuthgatedAppTenantSlugMeDetailsItemIdRouteImport.update({
    id: '/me/details/$itemId',
    path: '/me/details/$itemId',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeAccountSecurityRoute =
  AuthgatedAppTenantSlugMeAccountSecurityRouteImport.update({
    id: '/me/account/security',
    path: '/me/account/security',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugMeAccountNotificationsRoute =
  AuthgatedAppTenantSlugMeAccountNotificationsRouteImport.update({
    id: '/me/account/notifications',
    path: '/me/account/notifications',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOnboardingIdRoute =
  AuthgatedAppTenantSlugHrOnboardingIdRouteImport.update({
    id: '/hr/onboarding/$id',
    path: '/hr/onboarding/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOffboardingNewRoute =
  AuthgatedAppTenantSlugHrOffboardingNewRouteImport.update({
    id: '/hr/offboarding/new',
    path: '/hr/offboarding/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOffboardingIdRoute =
  AuthgatedAppTenantSlugHrOffboardingIdRouteImport.update({
    id: '/hr/offboarding/$id',
    path: '/hr/offboarding/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringRequisitionsNewRoute =
  AuthgatedAppTenantSlugHiringRequisitionsNewRouteImport.update({
    id: '/hiring/requisitions/new',
    path: '/hiring/requisitions/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringCandidatesIdRoute =
  AuthgatedAppTenantSlugHiringCandidatesIdRouteImport.update({
    id: '/hiring/candidates/$id',
    path: '/hiring/candidates/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHelpdeskTicketsIdRoute =
  AuthgatedAppTenantSlugHelpdeskTicketsIdRouteImport.update({
    id: '/helpdesk_/tickets/$id',
    path: '/helpdesk/tickets/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAttendanceImportRunsRoute =
  AuthgatedAppTenantSlugAttendanceImportRunsRouteImport.update({
    id: '/attendance/import/runs',
    path: '/attendance/import/runs',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute =
  AuthgatedAppTenantSlugAccountingReportsTrialBalanceRouteImport.update({
    id: '/accounting/reports/trial-balance',
    path: '/accounting/reports/trial-balance',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute =
  AuthgatedAppTenantSlugAccountingReportsTdsReceivableRouteImport.update({
    id: '/accounting/reports/tds-receivable',
    path: '/accounting/reports/tds-receivable',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute =
  AuthgatedAppTenantSlugAccountingReportsProfitAndLossRouteImport.update({
    id: '/accounting/reports/profit-and-loss',
    path: '/accounting/reports/profit-and-loss',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute =
  AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRouteImport.update({
    id: '/accounting/reports/msme-overdue',
    path: '/accounting/reports/msme-overdue',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute =
  AuthgatedAppTenantSlugAccountingReportsBalanceSheetRouteImport.update({
    id: '/accounting/reports/balance-sheet',
    path: '/accounting/reports/balance-sheet',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPurchasesNewRoute =
  AuthgatedAppTenantSlugAccountingPurchasesNewRouteImport.update({
    id: '/accounting/purchases/new',
    path: '/accounting/purchases/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPurchasesIdRoute =
  AuthgatedAppTenantSlugAccountingPurchasesIdRouteImport.update({
    id: '/accounting/purchases/$id',
    path: '/accounting/purchases/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute =
  AuthgatedAppTenantSlugAccountingPayrollRunsIdRouteImport.update({
    id: '/accounting/payroll-runs/$id',
    path: '/accounting/payroll-runs/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute =
  AuthgatedAppTenantSlugAccountingLedgerAccountIdRouteImport.update({
    id: '/accounting/ledger/$accountId',
    path: '/accounting/ledger/$accountId',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingJournalsNewRoute =
  AuthgatedAppTenantSlugAccountingJournalsNewRouteImport.update({
    id: '/accounting/journals/new',
    path: '/accounting/journals/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingJournalsIdRoute =
  AuthgatedAppTenantSlugAccountingJournalsIdRouteImport.update({
    id: '/accounting/journals/$id',
    path: '/accounting/journals/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingItemsNewRoute =
  AuthgatedAppTenantSlugAccountingItemsNewRouteImport.update({
    id: '/accounting/items/new',
    path: '/accounting/items/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingItemsIdRoute =
  AuthgatedAppTenantSlugAccountingItemsIdRouteImport.update({
    id: '/accounting/items/$id',
    path: '/accounting/items/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingContactsNewRoute =
  AuthgatedAppTenantSlugAccountingContactsNewRouteImport.update({
    id: '/accounting/contacts/new',
    path: '/accounting/contacts/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingContactsIdRoute =
  AuthgatedAppTenantSlugAccountingContactsIdRouteImport.update({
    id: '/accounting/contacts/$id',
    path: '/accounting/contacts/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingAccountsNewRoute =
  AuthgatedAppTenantSlugAccountingAccountsNewRouteImport.update({
    id: '/accounting/accounts/new',
    path: '/accounting/accounts/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute =
  AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRouteImport.update({
    id: '/timesheet/admin/projects/',
    path: '/timesheet/admin/projects/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute =
  AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRouteImport.update({
    id: '/posh/training/$moduleId/',
    path: '/posh/training/$moduleId/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute =
  AuthgatedAppTenantSlugPoshComplaintsIdIndexRouteImport.update({
    id: '/posh/complaints/$id/',
    path: '/posh/complaints/$id/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute =
  AuthgatedAppTenantSlugHrOffboardingLettersIndexRouteImport.update({
    id: '/hr/offboarding/letters/',
    path: '/hr/offboarding/letters/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute =
  AuthgatedAppTenantSlugHiringRequisitionsIdIndexRouteImport.update({
    id: '/hiring/requisitions/$id/',
    path: '/hiring/requisitions/$id/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute =
  AuthgatedAppTenantSlugAccountingSalesQuotesIndexRouteImport.update({
    id: '/accounting/sales/quotes/',
    path: '/accounting/sales/quotes/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute =
  AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRouteImport.update({
    id: '/accounting/money/receipts/',
    path: '/accounting/money/receipts/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute =
  AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRouteImport.update({
    id: '/accounting/money/payments/',
    path: '/accounting/money/payments/',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute =
  AuthgatedAppTenantSlugTimesheetAdminProjectsIdRouteImport.update({
    id: '/timesheet/admin/projects/$id',
    path: '/timesheet/admin/projects/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute =
  AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRouteImport.update({
    id: '/posh/training/$moduleId/quiz',
    path: '/posh/training/$moduleId/quiz',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugPoshComplaintsIdManageRoute =
  AuthgatedAppTenantSlugPoshComplaintsIdManageRouteImport.update({
    id: '/posh/complaints/$id/manage',
    path: '/posh/complaints/$id/manage',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute =
  AuthgatedAppTenantSlugHiringRequisitionsIdReportRouteImport.update({
    id: '/hiring/requisitions/$id/report',
    path: '/hiring/requisitions/$id/report',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute =
  AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRouteImport.update({
    id: '/hiring/requisitions/$id/pipeline',
    path: '/hiring/requisitions/$id/pipeline',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute =
  AuthgatedAppTenantSlugAccountingSalesQuotesNewRouteImport.update({
    id: '/accounting/sales/quotes/new',
    path: '/accounting/sales/quotes/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute =
  AuthgatedAppTenantSlugAccountingSalesQuotesIdRouteImport.update({
    id: '/accounting/sales/quotes/$id',
    path: '/accounting/sales/quotes/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute =
  AuthgatedAppTenantSlugAccountingSalesInvoicesNewRouteImport.update({
    id: '/accounting/sales/invoices/new',
    path: '/accounting/sales/invoices/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute =
  AuthgatedAppTenantSlugAccountingSalesInvoicesIdRouteImport.update({
    id: '/accounting/sales/invoices/$id',
    path: '/accounting/sales/invoices/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute =
  AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRouteImport.update({
    id: '/accounting/money/receipts/new',
    path: '/accounting/money/receipts/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute =
  AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRouteImport.update({
    id: '/accounting/money/receipts/$id',
    path: '/accounting/money/receipts/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute =
  AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRouteImport.update({
    id: '/accounting/money/payments/new',
    path: '/accounting/money/payments/new',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute =
  AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRouteImport.update({
    id: '/accounting/money/payments/$id',
    path: '/accounting/money/payments/$id',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)
const AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute =
  AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRouteImport.update({
    id: '/hr/offboarding/letters/$id/acknowledge',
    path: '/hr/offboarding/letters/$id/acknowledge',
    getParentRoute: () => AuthgatedAppTenantSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/2fa-setup': typeof Auth2faSetupRoute
  '/2fa-verify': typeof Auth2faVerifyRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/forgot': typeof AuthForgotRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset': typeof AuthResetRoute
  '/select-workspace': typeof AuthSelectWorkspaceRoute
  '/superadmin': typeof AuthgatedSuperadminRouteWithChildren
  '/join/$token': typeof JoinTokenRoute
  '/app/$tenantSlug': typeof AuthgatedAppTenantSlugRouteWithChildren
  '/superadmin/audit': typeof AuthgatedSuperadminAuditRoute
  '/superadmin/funnel': typeof AuthgatedSuperadminFunnelRoute
  '/superadmin/plans': typeof AuthgatedSuperadminPlansRoute
  '/superadmin/users': typeof AuthgatedSuperadminUsersRoute
  '/superadmin/': typeof AuthgatedSuperadminIndexRoute
  '/app/$tenantSlug/announcements': typeof AuthgatedAppTenantSlugAnnouncementsRoute
  '/app/$tenantSlug/approval-delegation': typeof AuthgatedAppTenantSlugApprovalDelegationRoute
  '/app/$tenantSlug/approvals': typeof AuthgatedAppTenantSlugApprovalsRoute
  '/app/$tenantSlug/calendar': typeof AuthgatedAppTenantSlugCalendarRoute
  '/app/$tenantSlug/comp-off': typeof AuthgatedAppTenantSlugCompOffRoute
  '/app/$tenantSlug/compliance': typeof AuthgatedAppTenantSlugComplianceRoute
  '/app/$tenantSlug/directory': typeof AuthgatedAppTenantSlugDirectoryRoute
  '/app/$tenantSlug/exit-tasks': typeof AuthgatedAppTenantSlugExitTasksRoute
  '/app/$tenantSlug/helpdesk': typeof AuthgatedAppTenantSlugHelpdeskRouteWithChildren
  '/app/$tenantSlug/holidays': typeof AuthgatedAppTenantSlugHolidaysRoute
  '/app/$tenantSlug/interviews': typeof AuthgatedAppTenantSlugInterviewsRoute
  '/app/$tenantSlug/my-time': typeof AuthgatedAppTenantSlugMyTimeRoute
  '/app/$tenantSlug/overview': typeof AuthgatedAppTenantSlugOverviewRoute
  '/app/$tenantSlug/referrals': typeof AuthgatedAppTenantSlugReferralsRoute
  '/app/$tenantSlug/skills': typeof AuthgatedAppTenantSlugSkillsRoute
  '/app/$tenantSlug/support-tickets': typeof AuthgatedAppTenantSlugSupportTicketsRouteWithChildren
  '/app/$tenantSlug/tasks': typeof AuthgatedAppTenantSlugTasksRoute
  '/superadmin/support/$id': typeof AuthgatedSuperadminSupportIdRoute
  '/superadmin/tenants/$id': typeof AuthgatedSuperadminTenantsIdRoute
  '/app/$tenantSlug/': typeof AuthgatedAppTenantSlugIndexRoute
  '/superadmin/support/': typeof AuthgatedSuperadminSupportIndexRoute
  '/superadmin/tenants/': typeof AuthgatedSuperadminTenantsIndexRoute
  '/app/$tenantSlug/accounting/audit': typeof AuthgatedAppTenantSlugAccountingAuditRoute
  '/app/$tenantSlug/accounting/opening-balance': typeof AuthgatedAppTenantSlugAccountingOpeningBalanceRoute
  '/app/$tenantSlug/accounting/period-locks': typeof AuthgatedAppTenantSlugAccountingPeriodLocksRoute
  '/app/$tenantSlug/accounting/post-to-books': typeof AuthgatedAppTenantSlugAccountingPostToBooksRoute
  '/app/$tenantSlug/accounting/returns': typeof AuthgatedAppTenantSlugAccountingReturnsRoute
  '/app/$tenantSlug/attendance/approvals': typeof AuthgatedAppTenantSlugAttendanceApprovalsRoute
  '/app/$tenantSlug/attendance/monthly-summary': typeof AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute
  '/app/$tenantSlug/attendance/register': typeof AuthgatedAppTenantSlugAttendanceRegisterRoute
  '/app/$tenantSlug/attendance/regularize': typeof AuthgatedAppTenantSlugAttendanceRegularizeRoute
  '/app/$tenantSlug/attendance/team': typeof AuthgatedAppTenantSlugAttendanceTeamRoute
  '/app/$tenantSlug/bulk-imports/$id': typeof AuthgatedAppTenantSlugBulkImportsIdRoute
  '/app/$tenantSlug/bulk-imports/new': typeof AuthgatedAppTenantSlugBulkImportsNewRoute
  '/app/$tenantSlug/change-requests/$id': typeof AuthgatedAppTenantSlugChangeRequestsIdRoute
  '/app/$tenantSlug/change-requests/new': typeof AuthgatedAppTenantSlugChangeRequestsNewRoute
  '/app/$tenantSlug/expenses/$id': typeof AuthgatedAppTenantSlugExpensesIdRoute
  '/app/$tenantSlug/expenses/approvals': typeof AuthgatedAppTenantSlugExpensesApprovalsRoute
  '/app/$tenantSlug/expenses/batches': typeof AuthgatedAppTenantSlugExpensesBatchesRoute
  '/app/$tenantSlug/expenses/new': typeof AuthgatedAppTenantSlugExpensesNewRoute
  '/app/$tenantSlug/helpdesk/new': typeof AuthgatedAppTenantSlugHelpdeskNewRoute
  '/app/$tenantSlug/hiring/analytics': typeof AuthgatedAppTenantSlugHiringAnalyticsRoute
  '/app/$tenantSlug/hiring/costs': typeof AuthgatedAppTenantSlugHiringCostsRoute
  '/app/$tenantSlug/hiring/interviews': typeof AuthgatedAppTenantSlugHiringInterviewsRoute
  '/app/$tenantSlug/hiring/jobs': typeof AuthgatedAppTenantSlugHiringJobsRoute
  '/app/$tenantSlug/hiring/referrals': typeof AuthgatedAppTenantSlugHiringReferralsRoute
  '/app/$tenantSlug/hiring/reports': typeof AuthgatedAppTenantSlugHiringReportsRoute
  '/app/$tenantSlug/hr/assets': typeof AuthgatedAppTenantSlugHrAssetsRoute
  '/app/$tenantSlug/hr/documents': typeof AuthgatedAppTenantSlugHrDocumentsRoute
  '/app/$tenantSlug/leave/$id': typeof AuthgatedAppTenantSlugLeaveIdRoute
  '/app/$tenantSlug/leave/approvals': typeof AuthgatedAppTenantSlugLeaveApprovalsRoute
  '/app/$tenantSlug/leave/balances': typeof AuthgatedAppTenantSlugLeaveBalancesRoute
  '/app/$tenantSlug/leave/calendar': typeof AuthgatedAppTenantSlugLeaveCalendarRoute
  '/app/$tenantSlug/leave/comp-off': typeof AuthgatedAppTenantSlugLeaveCompOffRoute
  '/app/$tenantSlug/leave/holidays': typeof AuthgatedAppTenantSlugLeaveHolidaysRoute
  '/app/$tenantSlug/leave/new': typeof AuthgatedAppTenantSlugLeaveNewRoute
  '/app/$tenantSlug/loans/$loanId': typeof AuthgatedAppTenantSlugLoansLoanIdRoute
  '/app/$tenantSlug/loans/approvals': typeof AuthgatedAppTenantSlugLoansApprovalsRoute
  '/app/$tenantSlug/loans/manage': typeof AuthgatedAppTenantSlugLoansManageRoute
  '/app/$tenantSlug/loans/new': typeof AuthgatedAppTenantSlugLoansNewRoute
  '/app/$tenantSlug/maternity-cases/$id': typeof AuthgatedAppTenantSlugMaternityCasesIdRoute
  '/app/$tenantSlug/maternity-cases/new': typeof AuthgatedAppTenantSlugMaternityCasesNewRoute
  '/app/$tenantSlug/me/assets': typeof AuthgatedAppTenantSlugMeAssetsRoute
  '/app/$tenantSlug/me/documents': typeof AuthgatedAppTenantSlugMeDocumentsRoute
  '/app/$tenantSlug/me/exit': typeof AuthgatedAppTenantSlugMeExitRoute
  '/app/$tenantSlug/me/loans': typeof AuthgatedAppTenantSlugMeLoansRoute
  '/app/$tenantSlug/me/pay': typeof AuthgatedAppTenantSlugMePayRoute
  '/app/$tenantSlug/me/profile': typeof AuthgatedAppTenantSlugMeProfileRoute
  '/app/$tenantSlug/me/salary': typeof AuthgatedAppTenantSlugMeSalaryRoute
  '/app/$tenantSlug/me/security': typeof AuthgatedAppTenantSlugMeSecurityRoute
  '/app/$tenantSlug/me/surveys': typeof AuthgatedAppTenantSlugMeSurveysRouteWithChildren
  '/app/$tenantSlug/me/tax': typeof AuthgatedAppTenantSlugMeTaxRoute
  '/app/$tenantSlug/payroll/$id': typeof AuthgatedAppTenantSlugPayrollIdRoute
  '/app/$tenantSlug/payroll/filings': typeof AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren
  '/app/$tenantSlug/payroll/new': typeof AuthgatedAppTenantSlugPayrollNewRoute
  '/app/$tenantSlug/payroll/pf-ceiling': typeof AuthgatedAppTenantSlugPayrollPfCeilingRoute
  '/app/$tenantSlug/payroll/statutory': typeof AuthgatedAppTenantSlugPayrollStatutoryRoute
  '/app/$tenantSlug/payroll/statutory-bonus': typeof AuthgatedAppTenantSlugPayrollStatutoryBonusRoute
  '/app/$tenantSlug/people/$id': typeof AuthgatedAppTenantSlugPeopleIdRouteWithChildren
  '/app/$tenantSlug/people/new': typeof AuthgatedAppTenantSlugPeopleNewRoute
  '/app/$tenantSlug/people/org-chart': typeof AuthgatedAppTenantSlugPeopleOrgChartRoute
  '/app/$tenantSlug/people/preboarding': typeof AuthgatedAppTenantSlugPeoplePreboardingRoute
  '/app/$tenantSlug/performance/feedback': typeof AuthgatedAppTenantSlugPerformanceFeedbackRoute
  '/app/$tenantSlug/posh/about': typeof AuthgatedAppTenantSlugPoshAboutRoute
  '/app/$tenantSlug/posh/certificates': typeof AuthgatedAppTenantSlugPoshCertificatesRoute
  '/app/$tenantSlug/posh/compliance': typeof AuthgatedAppTenantSlugPoshComplianceRoute
  '/app/$tenantSlug/posh/icc': typeof AuthgatedAppTenantSlugPoshIccRoute
  '/app/$tenantSlug/reports/analytics': typeof AuthgatedAppTenantSlugReportsAnalyticsRoute
  '/app/$tenantSlug/reports/headcount': typeof AuthgatedAppTenantSlugReportsHeadcountRoute
  '/app/$tenantSlug/reports/payroll-cost': typeof AuthgatedAppTenantSlugReportsPayrollCostRoute
  '/app/$tenantSlug/reports/salary-register': typeof AuthgatedAppTenantSlugReportsSalaryRegisterRoute
  '/app/$tenantSlug/settings/analytics': typeof AuthgatedAppTenantSlugSettingsAnalyticsRoute
  '/app/$tenantSlug/settings/api-tokens': typeof AuthgatedAppTenantSlugSettingsApiTokensRoute
  '/app/$tenantSlug/settings/asset-types': typeof AuthgatedAppTenantSlugSettingsAssetTypesRoute
  '/app/$tenantSlug/settings/attendance': typeof AuthgatedAppTenantSlugSettingsAttendanceRoute
  '/app/$tenantSlug/settings/attendance-device-profiles': typeof AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute
  '/app/$tenantSlug/settings/attendance-devices': typeof AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute
  '/app/$tenantSlug/settings/audit-log': typeof AuthgatedAppTenantSlugSettingsAuditLogRoute
  '/app/$tenantSlug/settings/billing': typeof AuthgatedAppTenantSlugSettingsBillingRoute
  '/app/$tenantSlug/settings/careers-branding': typeof AuthgatedAppTenantSlugSettingsCareersBrandingRoute
  '/app/$tenantSlug/settings/coa': typeof AuthgatedAppTenantSlugSettingsCoaRoute
  '/app/$tenantSlug/settings/competencies': typeof AuthgatedAppTenantSlugSettingsCompetenciesRoute
  '/app/$tenantSlug/settings/custom-fields': typeof AuthgatedAppTenantSlugSettingsCustomFieldsRoute
  '/app/$tenantSlug/settings/departments': typeof AuthgatedAppTenantSlugSettingsDepartmentsRoute
  '/app/$tenantSlug/settings/entities': typeof AuthgatedAppTenantSlugSettingsEntitiesRoute
  '/app/$tenantSlug/settings/expense-categories': typeof AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute
  '/app/$tenantSlug/settings/hiring-approvals': typeof AuthgatedAppTenantSlugSettingsHiringApprovalsRoute
  '/app/$tenantSlug/settings/hiring-emails': typeof AuthgatedAppTenantSlugSettingsHiringEmailsRoute
  '/app/$tenantSlug/settings/holidays': typeof AuthgatedAppTenantSlugSettingsHolidaysRoute
  '/app/$tenantSlug/settings/jd-templates': typeof AuthgatedAppTenantSlugSettingsJdTemplatesRoute
  '/app/$tenantSlug/settings/leave-types': typeof AuthgatedAppTenantSlugSettingsLeaveTypesRoute
  '/app/$tenantSlug/settings/modules': typeof AuthgatedAppTenantSlugSettingsModulesRoute
  '/app/$tenantSlug/settings/notifications': typeof AuthgatedAppTenantSlugSettingsNotificationsRoute
  '/app/$tenantSlug/settings/onboarding-templates': typeof AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute
  '/app/$tenantSlug/settings/payment-accounts': typeof AuthgatedAppTenantSlugSettingsPaymentAccountsRoute
  '/app/$tenantSlug/settings/posting-accounts': typeof AuthgatedAppTenantSlugSettingsPostingAccountsRoute
  '/app/$tenantSlug/settings/roles': typeof AuthgatedAppTenantSlugSettingsRolesRoute
  '/app/$tenantSlug/settings/scorecard-templates': typeof AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute
  '/app/$tenantSlug/settings/security': typeof AuthgatedAppTenantSlugSettingsSecurityRoute
  '/app/$tenantSlug/settings/shifts': typeof AuthgatedAppTenantSlugSettingsShiftsRoute
  '/app/$tenantSlug/settings/skills': typeof AuthgatedAppTenantSlugSettingsSkillsRoute
  '/app/$tenantSlug/settings/tally-mappings': typeof AuthgatedAppTenantSlugSettingsTallyMappingsRoute
  '/app/$tenantSlug/settings/webhooks': typeof AuthgatedAppTenantSlugSettingsWebhooksRoute
  '/app/$tenantSlug/settings/workspace': typeof AuthgatedAppTenantSlugSettingsWorkspaceRoute
  '/app/$tenantSlug/shifts/roster': typeof AuthgatedAppTenantSlugShiftsRosterRoute
  '/app/$tenantSlug/shifts/swaps': typeof AuthgatedAppTenantSlugShiftsSwapsRoute
  '/app/$tenantSlug/support-tickets/new': typeof AuthgatedAppTenantSlugSupportTicketsNewRoute
  '/app/$tenantSlug/support-tickets/$id': typeof AuthgatedAppTenantSlugSupportTicketsIdRoute
  '/app/$tenantSlug/surveys/new': typeof AuthgatedAppTenantSlugSurveysNewRoute
  '/app/$tenantSlug/timesheet/inbox': typeof AuthgatedAppTenantSlugTimesheetInboxRoute
  '/app/$tenantSlug/travel-preapprovals/$id': typeof AuthgatedAppTenantSlugTravelPreapprovalsIdRoute
  '/app/$tenantSlug/travel-preapprovals/new': typeof AuthgatedAppTenantSlugTravelPreapprovalsNewRoute
  '/app/$tenantSlug/wfh/$id': typeof AuthgatedAppTenantSlugWfhIdRoute
  '/app/$tenantSlug/wfh/approvals': typeof AuthgatedAppTenantSlugWfhApprovalsRoute
  '/app/$tenantSlug/accounting/': typeof AuthgatedAppTenantSlugAccountingIndexRoute
  '/app/$tenantSlug/attendance/': typeof AuthgatedAppTenantSlugAttendanceIndexRoute
  '/app/$tenantSlug/bulk-imports/': typeof AuthgatedAppTenantSlugBulkImportsIndexRoute
  '/app/$tenantSlug/change-requests/': typeof AuthgatedAppTenantSlugChangeRequestsIndexRoute
  '/app/$tenantSlug/expenses/': typeof AuthgatedAppTenantSlugExpensesIndexRoute
  '/app/$tenantSlug/hiring/': typeof AuthgatedAppTenantSlugHiringIndexRoute
  '/app/$tenantSlug/hr/': typeof AuthgatedAppTenantSlugHrIndexRoute
  '/app/$tenantSlug/leave/': typeof AuthgatedAppTenantSlugLeaveIndexRoute
  '/app/$tenantSlug/loans/': typeof AuthgatedAppTenantSlugLoansIndexRoute
  '/app/$tenantSlug/maternity-cases/': typeof AuthgatedAppTenantSlugMaternityCasesIndexRoute
  '/app/$tenantSlug/payroll/': typeof AuthgatedAppTenantSlugPayrollIndexRoute
  '/app/$tenantSlug/people/': typeof AuthgatedAppTenantSlugPeopleIndexRoute
  '/app/$tenantSlug/performance/': typeof AuthgatedAppTenantSlugPerformanceIndexRoute
  '/app/$tenantSlug/posh/': typeof AuthgatedAppTenantSlugPoshIndexRoute
  '/app/$tenantSlug/reports/': typeof AuthgatedAppTenantSlugReportsIndexRoute
  '/app/$tenantSlug/settings/': typeof AuthgatedAppTenantSlugSettingsIndexRoute
  '/app/$tenantSlug/shifts/': typeof AuthgatedAppTenantSlugShiftsIndexRoute
  '/app/$tenantSlug/surveys/': typeof AuthgatedAppTenantSlugSurveysIndexRoute
  '/app/$tenantSlug/timesheet/': typeof AuthgatedAppTenantSlugTimesheetIndexRoute
  '/app/$tenantSlug/travel-preapprovals/': typeof AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute
  '/app/$tenantSlug/wfh/': typeof AuthgatedAppTenantSlugWfhIndexRoute
  '/app/$tenantSlug/accounting/accounts/new': typeof AuthgatedAppTenantSlugAccountingAccountsNewRoute
  '/app/$tenantSlug/accounting/contacts/$id': typeof AuthgatedAppTenantSlugAccountingContactsIdRoute
  '/app/$tenantSlug/accounting/contacts/new': typeof AuthgatedAppTenantSlugAccountingContactsNewRoute
  '/app/$tenantSlug/accounting/items/$id': typeof AuthgatedAppTenantSlugAccountingItemsIdRoute
  '/app/$tenantSlug/accounting/items/new': typeof AuthgatedAppTenantSlugAccountingItemsNewRoute
  '/app/$tenantSlug/accounting/journals/$id': typeof AuthgatedAppTenantSlugAccountingJournalsIdRoute
  '/app/$tenantSlug/accounting/journals/new': typeof AuthgatedAppTenantSlugAccountingJournalsNewRoute
  '/app/$tenantSlug/accounting/ledger/$accountId': typeof AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute
  '/app/$tenantSlug/accounting/payroll-runs/$id': typeof AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute
  '/app/$tenantSlug/accounting/purchases/$id': typeof AuthgatedAppTenantSlugAccountingPurchasesIdRoute
  '/app/$tenantSlug/accounting/purchases/new': typeof AuthgatedAppTenantSlugAccountingPurchasesNewRoute
  '/app/$tenantSlug/accounting/reports/balance-sheet': typeof AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute
  '/app/$tenantSlug/accounting/reports/msme-overdue': typeof AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute
  '/app/$tenantSlug/accounting/reports/profit-and-loss': typeof AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute
  '/app/$tenantSlug/accounting/reports/tds-receivable': typeof AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute
  '/app/$tenantSlug/accounting/reports/trial-balance': typeof AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute
  '/app/$tenantSlug/attendance/import/runs': typeof AuthgatedAppTenantSlugAttendanceImportRunsRoute
  '/app/$tenantSlug/helpdesk/tickets/$id': typeof AuthgatedAppTenantSlugHelpdeskTicketsIdRoute
  '/app/$tenantSlug/hiring/candidates/$id': typeof AuthgatedAppTenantSlugHiringCandidatesIdRoute
  '/app/$tenantSlug/hiring/requisitions/new': typeof AuthgatedAppTenantSlugHiringRequisitionsNewRoute
  '/app/$tenantSlug/hr/offboarding/$id': typeof AuthgatedAppTenantSlugHrOffboardingIdRoute
  '/app/$tenantSlug/hr/offboarding/new': typeof AuthgatedAppTenantSlugHrOffboardingNewRoute
  '/app/$tenantSlug/hr/onboarding/$id': typeof AuthgatedAppTenantSlugHrOnboardingIdRoute
  '/app/$tenantSlug/me/account/notifications': typeof AuthgatedAppTenantSlugMeAccountNotificationsRoute
  '/app/$tenantSlug/me/account/security': typeof AuthgatedAppTenantSlugMeAccountSecurityRoute
  '/app/$tenantSlug/me/details/$itemId': typeof AuthgatedAppTenantSlugMeDetailsItemIdRoute
  '/app/$tenantSlug/me/letters/$id': typeof AuthgatedAppTenantSlugMeLettersIdRoute
  '/app/$tenantSlug/me/surveys/$id': typeof AuthgatedAppTenantSlugMeSurveysIdRoute
  '/app/$tenantSlug/payroll/filings/$id': typeof AuthgatedAppTenantSlugPayrollFilingsIdRoute
  '/app/$tenantSlug/payroll/tax-declaration/$declId': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute
  '/app/$tenantSlug/payroll/tax-declaration/queue': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute
  '/app/$tenantSlug/people/$id/edit': typeof AuthgatedAppTenantSlugPeopleIdEditRoute
  '/app/$tenantSlug/performance/cycles/$id': typeof AuthgatedAppTenantSlugPerformanceCyclesIdRoute
  '/app/$tenantSlug/performance/cycles/new': typeof AuthgatedAppTenantSlugPerformanceCyclesNewRoute
  '/app/$tenantSlug/performance/goals/$id': typeof AuthgatedAppTenantSlugPerformanceGoalsIdRoute
  '/app/$tenantSlug/performance/goals/new': typeof AuthgatedAppTenantSlugPerformanceGoalsNewRoute
  '/app/$tenantSlug/performance/my-results/$cycleId': typeof AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute
  '/app/$tenantSlug/performance/one-on-ones/$id': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute
  '/app/$tenantSlug/performance/one-on-ones/new': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute
  '/app/$tenantSlug/performance/reviews/$id': typeof AuthgatedAppTenantSlugPerformanceReviewsIdRoute
  '/app/$tenantSlug/performance/reviews/new': typeof AuthgatedAppTenantSlugPerformanceReviewsNewRoute
  '/app/$tenantSlug/posh/complaints/new': typeof AuthgatedAppTenantSlugPoshComplaintsNewRoute
  '/app/$tenantSlug/posh/policy/$id': typeof AuthgatedAppTenantSlugPoshPolicyIdRoute
  '/app/$tenantSlug/posh/reports/$id': typeof AuthgatedAppTenantSlugPoshReportsIdRoute
  '/app/$tenantSlug/settings/checklists/offboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute
  '/app/$tenantSlug/settings/checklists/onboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute
  '/app/$tenantSlug/settings/checklists/preboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute
  '/app/$tenantSlug/settings/tax-codes/new': typeof AuthgatedAppTenantSlugSettingsTaxCodesNewRoute
  '/app/$tenantSlug/surveys/$id/results': typeof AuthgatedAppTenantSlugSurveysIdResultsRoute
  '/app/$tenantSlug/timesheet/weeks/$weekStart': typeof AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute
  '/app/$tenantSlug/accounting/accounts/': typeof AuthgatedAppTenantSlugAccountingAccountsIndexRoute
  '/app/$tenantSlug/accounting/contacts/': typeof AuthgatedAppTenantSlugAccountingContactsIndexRoute
  '/app/$tenantSlug/accounting/items/': typeof AuthgatedAppTenantSlugAccountingItemsIndexRoute
  '/app/$tenantSlug/accounting/journals/': typeof AuthgatedAppTenantSlugAccountingJournalsIndexRoute
  '/app/$tenantSlug/accounting/money/': typeof AuthgatedAppTenantSlugAccountingMoneyIndexRoute
  '/app/$tenantSlug/accounting/purchases/': typeof AuthgatedAppTenantSlugAccountingPurchasesIndexRoute
  '/app/$tenantSlug/accounting/reports/': typeof AuthgatedAppTenantSlugAccountingReportsIndexRoute
  '/app/$tenantSlug/accounting/sales/': typeof AuthgatedAppTenantSlugAccountingSalesIndexRoute
  '/app/$tenantSlug/attendance/import/': typeof AuthgatedAppTenantSlugAttendanceImportIndexRoute
  '/app/$tenantSlug/hiring/candidates/': typeof AuthgatedAppTenantSlugHiringCandidatesIndexRoute
  '/app/$tenantSlug/hiring/requisitions/': typeof AuthgatedAppTenantSlugHiringRequisitionsIndexRoute
  '/app/$tenantSlug/hr/offboarding/': typeof AuthgatedAppTenantSlugHrOffboardingIndexRoute
  '/app/$tenantSlug/hr/onboarding/': typeof AuthgatedAppTenantSlugHrOnboardingIndexRoute
  '/app/$tenantSlug/me/account/': typeof AuthgatedAppTenantSlugMeAccountIndexRoute
  '/app/$tenantSlug/me/details/': typeof AuthgatedAppTenantSlugMeDetailsIndexRoute
  '/app/$tenantSlug/me/letters/': typeof AuthgatedAppTenantSlugMeLettersIndexRoute
  '/app/$tenantSlug/payroll/tax-declaration/': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute
  '/app/$tenantSlug/performance/cycles/': typeof AuthgatedAppTenantSlugPerformanceCyclesIndexRoute
  '/app/$tenantSlug/performance/goals/': typeof AuthgatedAppTenantSlugPerformanceGoalsIndexRoute
  '/app/$tenantSlug/performance/my-results/': typeof AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute
  '/app/$tenantSlug/performance/one-on-ones/': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute
  '/app/$tenantSlug/performance/reviews/': typeof AuthgatedAppTenantSlugPerformanceReviewsIndexRoute
  '/app/$tenantSlug/posh/complaints/': typeof AuthgatedAppTenantSlugPoshComplaintsIndexRoute
  '/app/$tenantSlug/posh/policy/': typeof AuthgatedAppTenantSlugPoshPolicyIndexRoute
  '/app/$tenantSlug/posh/reports/': typeof AuthgatedAppTenantSlugPoshReportsIndexRoute
  '/app/$tenantSlug/posh/training/': typeof AuthgatedAppTenantSlugPoshTrainingIndexRoute
  '/app/$tenantSlug/settings/checklists/': typeof AuthgatedAppTenantSlugSettingsChecklistsIndexRoute
  '/app/$tenantSlug/settings/tax-codes/': typeof AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute
  '/app/$tenantSlug/surveys/$id/': typeof AuthgatedAppTenantSlugSurveysIdIndexRoute
  '/app/$tenantSlug/accounting/money/payments/$id': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute
  '/app/$tenantSlug/accounting/money/payments/new': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute
  '/app/$tenantSlug/accounting/money/receipts/$id': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute
  '/app/$tenantSlug/accounting/money/receipts/new': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute
  '/app/$tenantSlug/accounting/sales/invoices/$id': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute
  '/app/$tenantSlug/accounting/sales/invoices/new': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute
  '/app/$tenantSlug/accounting/sales/quotes/$id': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute
  '/app/$tenantSlug/accounting/sales/quotes/new': typeof AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute
  '/app/$tenantSlug/hiring/requisitions/$id/pipeline': typeof AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute
  '/app/$tenantSlug/hiring/requisitions/$id/report': typeof AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute
  '/app/$tenantSlug/posh/complaints/$id/manage': typeof AuthgatedAppTenantSlugPoshComplaintsIdManageRoute
  '/app/$tenantSlug/posh/training/$moduleId/quiz': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute
  '/app/$tenantSlug/timesheet/admin/projects/$id': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute
  '/app/$tenantSlug/accounting/money/payments/': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute
  '/app/$tenantSlug/accounting/money/receipts/': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute
  '/app/$tenantSlug/accounting/sales/quotes/': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute
  '/app/$tenantSlug/hiring/requisitions/$id/': typeof AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute
  '/app/$tenantSlug/hr/offboarding/letters/': typeof AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute
  '/app/$tenantSlug/posh/complaints/$id/': typeof AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute
  '/app/$tenantSlug/posh/training/$moduleId/': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute
  '/app/$tenantSlug/timesheet/admin/projects/': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute
  '/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge': typeof AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/2fa-setup': typeof Auth2faSetupRoute
  '/2fa-verify': typeof Auth2faVerifyRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/forgot': typeof AuthForgotRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset': typeof AuthResetRoute
  '/select-workspace': typeof AuthSelectWorkspaceRoute
  '/join/$token': typeof JoinTokenRoute
  '/superadmin/audit': typeof AuthgatedSuperadminAuditRoute
  '/superadmin/funnel': typeof AuthgatedSuperadminFunnelRoute
  '/superadmin/plans': typeof AuthgatedSuperadminPlansRoute
  '/superadmin/users': typeof AuthgatedSuperadminUsersRoute
  '/superadmin': typeof AuthgatedSuperadminIndexRoute
  '/app/$tenantSlug/announcements': typeof AuthgatedAppTenantSlugAnnouncementsRoute
  '/app/$tenantSlug/approval-delegation': typeof AuthgatedAppTenantSlugApprovalDelegationRoute
  '/app/$tenantSlug/approvals': typeof AuthgatedAppTenantSlugApprovalsRoute
  '/app/$tenantSlug/calendar': typeof AuthgatedAppTenantSlugCalendarRoute
  '/app/$tenantSlug/comp-off': typeof AuthgatedAppTenantSlugCompOffRoute
  '/app/$tenantSlug/compliance': typeof AuthgatedAppTenantSlugComplianceRoute
  '/app/$tenantSlug/directory': typeof AuthgatedAppTenantSlugDirectoryRoute
  '/app/$tenantSlug/exit-tasks': typeof AuthgatedAppTenantSlugExitTasksRoute
  '/app/$tenantSlug/helpdesk': typeof AuthgatedAppTenantSlugHelpdeskRouteWithChildren
  '/app/$tenantSlug/holidays': typeof AuthgatedAppTenantSlugHolidaysRoute
  '/app/$tenantSlug/interviews': typeof AuthgatedAppTenantSlugInterviewsRoute
  '/app/$tenantSlug/my-time': typeof AuthgatedAppTenantSlugMyTimeRoute
  '/app/$tenantSlug/overview': typeof AuthgatedAppTenantSlugOverviewRoute
  '/app/$tenantSlug/referrals': typeof AuthgatedAppTenantSlugReferralsRoute
  '/app/$tenantSlug/skills': typeof AuthgatedAppTenantSlugSkillsRoute
  '/app/$tenantSlug/support-tickets': typeof AuthgatedAppTenantSlugSupportTicketsRouteWithChildren
  '/app/$tenantSlug/tasks': typeof AuthgatedAppTenantSlugTasksRoute
  '/superadmin/support/$id': typeof AuthgatedSuperadminSupportIdRoute
  '/superadmin/tenants/$id': typeof AuthgatedSuperadminTenantsIdRoute
  '/app/$tenantSlug': typeof AuthgatedAppTenantSlugIndexRoute
  '/superadmin/support': typeof AuthgatedSuperadminSupportIndexRoute
  '/superadmin/tenants': typeof AuthgatedSuperadminTenantsIndexRoute
  '/app/$tenantSlug/accounting/audit': typeof AuthgatedAppTenantSlugAccountingAuditRoute
  '/app/$tenantSlug/accounting/opening-balance': typeof AuthgatedAppTenantSlugAccountingOpeningBalanceRoute
  '/app/$tenantSlug/accounting/period-locks': typeof AuthgatedAppTenantSlugAccountingPeriodLocksRoute
  '/app/$tenantSlug/accounting/post-to-books': typeof AuthgatedAppTenantSlugAccountingPostToBooksRoute
  '/app/$tenantSlug/accounting/returns': typeof AuthgatedAppTenantSlugAccountingReturnsRoute
  '/app/$tenantSlug/attendance/approvals': typeof AuthgatedAppTenantSlugAttendanceApprovalsRoute
  '/app/$tenantSlug/attendance/monthly-summary': typeof AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute
  '/app/$tenantSlug/attendance/register': typeof AuthgatedAppTenantSlugAttendanceRegisterRoute
  '/app/$tenantSlug/attendance/regularize': typeof AuthgatedAppTenantSlugAttendanceRegularizeRoute
  '/app/$tenantSlug/attendance/team': typeof AuthgatedAppTenantSlugAttendanceTeamRoute
  '/app/$tenantSlug/bulk-imports/$id': typeof AuthgatedAppTenantSlugBulkImportsIdRoute
  '/app/$tenantSlug/bulk-imports/new': typeof AuthgatedAppTenantSlugBulkImportsNewRoute
  '/app/$tenantSlug/change-requests/$id': typeof AuthgatedAppTenantSlugChangeRequestsIdRoute
  '/app/$tenantSlug/change-requests/new': typeof AuthgatedAppTenantSlugChangeRequestsNewRoute
  '/app/$tenantSlug/expenses/$id': typeof AuthgatedAppTenantSlugExpensesIdRoute
  '/app/$tenantSlug/expenses/approvals': typeof AuthgatedAppTenantSlugExpensesApprovalsRoute
  '/app/$tenantSlug/expenses/batches': typeof AuthgatedAppTenantSlugExpensesBatchesRoute
  '/app/$tenantSlug/expenses/new': typeof AuthgatedAppTenantSlugExpensesNewRoute
  '/app/$tenantSlug/helpdesk/new': typeof AuthgatedAppTenantSlugHelpdeskNewRoute
  '/app/$tenantSlug/hiring/analytics': typeof AuthgatedAppTenantSlugHiringAnalyticsRoute
  '/app/$tenantSlug/hiring/costs': typeof AuthgatedAppTenantSlugHiringCostsRoute
  '/app/$tenantSlug/hiring/interviews': typeof AuthgatedAppTenantSlugHiringInterviewsRoute
  '/app/$tenantSlug/hiring/jobs': typeof AuthgatedAppTenantSlugHiringJobsRoute
  '/app/$tenantSlug/hiring/referrals': typeof AuthgatedAppTenantSlugHiringReferralsRoute
  '/app/$tenantSlug/hiring/reports': typeof AuthgatedAppTenantSlugHiringReportsRoute
  '/app/$tenantSlug/hr/assets': typeof AuthgatedAppTenantSlugHrAssetsRoute
  '/app/$tenantSlug/hr/documents': typeof AuthgatedAppTenantSlugHrDocumentsRoute
  '/app/$tenantSlug/leave/$id': typeof AuthgatedAppTenantSlugLeaveIdRoute
  '/app/$tenantSlug/leave/approvals': typeof AuthgatedAppTenantSlugLeaveApprovalsRoute
  '/app/$tenantSlug/leave/balances': typeof AuthgatedAppTenantSlugLeaveBalancesRoute
  '/app/$tenantSlug/leave/calendar': typeof AuthgatedAppTenantSlugLeaveCalendarRoute
  '/app/$tenantSlug/leave/comp-off': typeof AuthgatedAppTenantSlugLeaveCompOffRoute
  '/app/$tenantSlug/leave/holidays': typeof AuthgatedAppTenantSlugLeaveHolidaysRoute
  '/app/$tenantSlug/leave/new': typeof AuthgatedAppTenantSlugLeaveNewRoute
  '/app/$tenantSlug/loans/$loanId': typeof AuthgatedAppTenantSlugLoansLoanIdRoute
  '/app/$tenantSlug/loans/approvals': typeof AuthgatedAppTenantSlugLoansApprovalsRoute
  '/app/$tenantSlug/loans/manage': typeof AuthgatedAppTenantSlugLoansManageRoute
  '/app/$tenantSlug/loans/new': typeof AuthgatedAppTenantSlugLoansNewRoute
  '/app/$tenantSlug/maternity-cases/$id': typeof AuthgatedAppTenantSlugMaternityCasesIdRoute
  '/app/$tenantSlug/maternity-cases/new': typeof AuthgatedAppTenantSlugMaternityCasesNewRoute
  '/app/$tenantSlug/me/assets': typeof AuthgatedAppTenantSlugMeAssetsRoute
  '/app/$tenantSlug/me/documents': typeof AuthgatedAppTenantSlugMeDocumentsRoute
  '/app/$tenantSlug/me/exit': typeof AuthgatedAppTenantSlugMeExitRoute
  '/app/$tenantSlug/me/loans': typeof AuthgatedAppTenantSlugMeLoansRoute
  '/app/$tenantSlug/me/pay': typeof AuthgatedAppTenantSlugMePayRoute
  '/app/$tenantSlug/me/profile': typeof AuthgatedAppTenantSlugMeProfileRoute
  '/app/$tenantSlug/me/salary': typeof AuthgatedAppTenantSlugMeSalaryRoute
  '/app/$tenantSlug/me/security': typeof AuthgatedAppTenantSlugMeSecurityRoute
  '/app/$tenantSlug/me/surveys': typeof AuthgatedAppTenantSlugMeSurveysRouteWithChildren
  '/app/$tenantSlug/me/tax': typeof AuthgatedAppTenantSlugMeTaxRoute
  '/app/$tenantSlug/payroll/$id': typeof AuthgatedAppTenantSlugPayrollIdRoute
  '/app/$tenantSlug/payroll/filings': typeof AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren
  '/app/$tenantSlug/payroll/new': typeof AuthgatedAppTenantSlugPayrollNewRoute
  '/app/$tenantSlug/payroll/pf-ceiling': typeof AuthgatedAppTenantSlugPayrollPfCeilingRoute
  '/app/$tenantSlug/payroll/statutory': typeof AuthgatedAppTenantSlugPayrollStatutoryRoute
  '/app/$tenantSlug/payroll/statutory-bonus': typeof AuthgatedAppTenantSlugPayrollStatutoryBonusRoute
  '/app/$tenantSlug/people/$id': typeof AuthgatedAppTenantSlugPeopleIdRouteWithChildren
  '/app/$tenantSlug/people/new': typeof AuthgatedAppTenantSlugPeopleNewRoute
  '/app/$tenantSlug/people/org-chart': typeof AuthgatedAppTenantSlugPeopleOrgChartRoute
  '/app/$tenantSlug/people/preboarding': typeof AuthgatedAppTenantSlugPeoplePreboardingRoute
  '/app/$tenantSlug/performance/feedback': typeof AuthgatedAppTenantSlugPerformanceFeedbackRoute
  '/app/$tenantSlug/posh/about': typeof AuthgatedAppTenantSlugPoshAboutRoute
  '/app/$tenantSlug/posh/certificates': typeof AuthgatedAppTenantSlugPoshCertificatesRoute
  '/app/$tenantSlug/posh/compliance': typeof AuthgatedAppTenantSlugPoshComplianceRoute
  '/app/$tenantSlug/posh/icc': typeof AuthgatedAppTenantSlugPoshIccRoute
  '/app/$tenantSlug/reports/analytics': typeof AuthgatedAppTenantSlugReportsAnalyticsRoute
  '/app/$tenantSlug/reports/headcount': typeof AuthgatedAppTenantSlugReportsHeadcountRoute
  '/app/$tenantSlug/reports/payroll-cost': typeof AuthgatedAppTenantSlugReportsPayrollCostRoute
  '/app/$tenantSlug/reports/salary-register': typeof AuthgatedAppTenantSlugReportsSalaryRegisterRoute
  '/app/$tenantSlug/settings/analytics': typeof AuthgatedAppTenantSlugSettingsAnalyticsRoute
  '/app/$tenantSlug/settings/api-tokens': typeof AuthgatedAppTenantSlugSettingsApiTokensRoute
  '/app/$tenantSlug/settings/asset-types': typeof AuthgatedAppTenantSlugSettingsAssetTypesRoute
  '/app/$tenantSlug/settings/attendance': typeof AuthgatedAppTenantSlugSettingsAttendanceRoute
  '/app/$tenantSlug/settings/attendance-device-profiles': typeof AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute
  '/app/$tenantSlug/settings/attendance-devices': typeof AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute
  '/app/$tenantSlug/settings/audit-log': typeof AuthgatedAppTenantSlugSettingsAuditLogRoute
  '/app/$tenantSlug/settings/billing': typeof AuthgatedAppTenantSlugSettingsBillingRoute
  '/app/$tenantSlug/settings/careers-branding': typeof AuthgatedAppTenantSlugSettingsCareersBrandingRoute
  '/app/$tenantSlug/settings/coa': typeof AuthgatedAppTenantSlugSettingsCoaRoute
  '/app/$tenantSlug/settings/competencies': typeof AuthgatedAppTenantSlugSettingsCompetenciesRoute
  '/app/$tenantSlug/settings/custom-fields': typeof AuthgatedAppTenantSlugSettingsCustomFieldsRoute
  '/app/$tenantSlug/settings/departments': typeof AuthgatedAppTenantSlugSettingsDepartmentsRoute
  '/app/$tenantSlug/settings/entities': typeof AuthgatedAppTenantSlugSettingsEntitiesRoute
  '/app/$tenantSlug/settings/expense-categories': typeof AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute
  '/app/$tenantSlug/settings/hiring-approvals': typeof AuthgatedAppTenantSlugSettingsHiringApprovalsRoute
  '/app/$tenantSlug/settings/hiring-emails': typeof AuthgatedAppTenantSlugSettingsHiringEmailsRoute
  '/app/$tenantSlug/settings/holidays': typeof AuthgatedAppTenantSlugSettingsHolidaysRoute
  '/app/$tenantSlug/settings/jd-templates': typeof AuthgatedAppTenantSlugSettingsJdTemplatesRoute
  '/app/$tenantSlug/settings/leave-types': typeof AuthgatedAppTenantSlugSettingsLeaveTypesRoute
  '/app/$tenantSlug/settings/modules': typeof AuthgatedAppTenantSlugSettingsModulesRoute
  '/app/$tenantSlug/settings/notifications': typeof AuthgatedAppTenantSlugSettingsNotificationsRoute
  '/app/$tenantSlug/settings/onboarding-templates': typeof AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute
  '/app/$tenantSlug/settings/payment-accounts': typeof AuthgatedAppTenantSlugSettingsPaymentAccountsRoute
  '/app/$tenantSlug/settings/posting-accounts': typeof AuthgatedAppTenantSlugSettingsPostingAccountsRoute
  '/app/$tenantSlug/settings/roles': typeof AuthgatedAppTenantSlugSettingsRolesRoute
  '/app/$tenantSlug/settings/scorecard-templates': typeof AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute
  '/app/$tenantSlug/settings/security': typeof AuthgatedAppTenantSlugSettingsSecurityRoute
  '/app/$tenantSlug/settings/shifts': typeof AuthgatedAppTenantSlugSettingsShiftsRoute
  '/app/$tenantSlug/settings/skills': typeof AuthgatedAppTenantSlugSettingsSkillsRoute
  '/app/$tenantSlug/settings/tally-mappings': typeof AuthgatedAppTenantSlugSettingsTallyMappingsRoute
  '/app/$tenantSlug/settings/webhooks': typeof AuthgatedAppTenantSlugSettingsWebhooksRoute
  '/app/$tenantSlug/settings/workspace': typeof AuthgatedAppTenantSlugSettingsWorkspaceRoute
  '/app/$tenantSlug/shifts/roster': typeof AuthgatedAppTenantSlugShiftsRosterRoute
  '/app/$tenantSlug/shifts/swaps': typeof AuthgatedAppTenantSlugShiftsSwapsRoute
  '/app/$tenantSlug/support-tickets/new': typeof AuthgatedAppTenantSlugSupportTicketsNewRoute
  '/app/$tenantSlug/support-tickets/$id': typeof AuthgatedAppTenantSlugSupportTicketsIdRoute
  '/app/$tenantSlug/surveys/new': typeof AuthgatedAppTenantSlugSurveysNewRoute
  '/app/$tenantSlug/timesheet/inbox': typeof AuthgatedAppTenantSlugTimesheetInboxRoute
  '/app/$tenantSlug/travel-preapprovals/$id': typeof AuthgatedAppTenantSlugTravelPreapprovalsIdRoute
  '/app/$tenantSlug/travel-preapprovals/new': typeof AuthgatedAppTenantSlugTravelPreapprovalsNewRoute
  '/app/$tenantSlug/wfh/$id': typeof AuthgatedAppTenantSlugWfhIdRoute
  '/app/$tenantSlug/wfh/approvals': typeof AuthgatedAppTenantSlugWfhApprovalsRoute
  '/app/$tenantSlug/accounting': typeof AuthgatedAppTenantSlugAccountingIndexRoute
  '/app/$tenantSlug/attendance': typeof AuthgatedAppTenantSlugAttendanceIndexRoute
  '/app/$tenantSlug/bulk-imports': typeof AuthgatedAppTenantSlugBulkImportsIndexRoute
  '/app/$tenantSlug/change-requests': typeof AuthgatedAppTenantSlugChangeRequestsIndexRoute
  '/app/$tenantSlug/expenses': typeof AuthgatedAppTenantSlugExpensesIndexRoute
  '/app/$tenantSlug/hiring': typeof AuthgatedAppTenantSlugHiringIndexRoute
  '/app/$tenantSlug/hr': typeof AuthgatedAppTenantSlugHrIndexRoute
  '/app/$tenantSlug/leave': typeof AuthgatedAppTenantSlugLeaveIndexRoute
  '/app/$tenantSlug/loans': typeof AuthgatedAppTenantSlugLoansIndexRoute
  '/app/$tenantSlug/maternity-cases': typeof AuthgatedAppTenantSlugMaternityCasesIndexRoute
  '/app/$tenantSlug/payroll': typeof AuthgatedAppTenantSlugPayrollIndexRoute
  '/app/$tenantSlug/people': typeof AuthgatedAppTenantSlugPeopleIndexRoute
  '/app/$tenantSlug/performance': typeof AuthgatedAppTenantSlugPerformanceIndexRoute
  '/app/$tenantSlug/posh': typeof AuthgatedAppTenantSlugPoshIndexRoute
  '/app/$tenantSlug/reports': typeof AuthgatedAppTenantSlugReportsIndexRoute
  '/app/$tenantSlug/settings': typeof AuthgatedAppTenantSlugSettingsIndexRoute
  '/app/$tenantSlug/shifts': typeof AuthgatedAppTenantSlugShiftsIndexRoute
  '/app/$tenantSlug/surveys': typeof AuthgatedAppTenantSlugSurveysIndexRoute
  '/app/$tenantSlug/timesheet': typeof AuthgatedAppTenantSlugTimesheetIndexRoute
  '/app/$tenantSlug/travel-preapprovals': typeof AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute
  '/app/$tenantSlug/wfh': typeof AuthgatedAppTenantSlugWfhIndexRoute
  '/app/$tenantSlug/accounting/accounts/new': typeof AuthgatedAppTenantSlugAccountingAccountsNewRoute
  '/app/$tenantSlug/accounting/contacts/$id': typeof AuthgatedAppTenantSlugAccountingContactsIdRoute
  '/app/$tenantSlug/accounting/contacts/new': typeof AuthgatedAppTenantSlugAccountingContactsNewRoute
  '/app/$tenantSlug/accounting/items/$id': typeof AuthgatedAppTenantSlugAccountingItemsIdRoute
  '/app/$tenantSlug/accounting/items/new': typeof AuthgatedAppTenantSlugAccountingItemsNewRoute
  '/app/$tenantSlug/accounting/journals/$id': typeof AuthgatedAppTenantSlugAccountingJournalsIdRoute
  '/app/$tenantSlug/accounting/journals/new': typeof AuthgatedAppTenantSlugAccountingJournalsNewRoute
  '/app/$tenantSlug/accounting/ledger/$accountId': typeof AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute
  '/app/$tenantSlug/accounting/payroll-runs/$id': typeof AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute
  '/app/$tenantSlug/accounting/purchases/$id': typeof AuthgatedAppTenantSlugAccountingPurchasesIdRoute
  '/app/$tenantSlug/accounting/purchases/new': typeof AuthgatedAppTenantSlugAccountingPurchasesNewRoute
  '/app/$tenantSlug/accounting/reports/balance-sheet': typeof AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute
  '/app/$tenantSlug/accounting/reports/msme-overdue': typeof AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute
  '/app/$tenantSlug/accounting/reports/profit-and-loss': typeof AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute
  '/app/$tenantSlug/accounting/reports/tds-receivable': typeof AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute
  '/app/$tenantSlug/accounting/reports/trial-balance': typeof AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute
  '/app/$tenantSlug/attendance/import/runs': typeof AuthgatedAppTenantSlugAttendanceImportRunsRoute
  '/app/$tenantSlug/helpdesk/tickets/$id': typeof AuthgatedAppTenantSlugHelpdeskTicketsIdRoute
  '/app/$tenantSlug/hiring/candidates/$id': typeof AuthgatedAppTenantSlugHiringCandidatesIdRoute
  '/app/$tenantSlug/hiring/requisitions/new': typeof AuthgatedAppTenantSlugHiringRequisitionsNewRoute
  '/app/$tenantSlug/hr/offboarding/$id': typeof AuthgatedAppTenantSlugHrOffboardingIdRoute
  '/app/$tenantSlug/hr/offboarding/new': typeof AuthgatedAppTenantSlugHrOffboardingNewRoute
  '/app/$tenantSlug/hr/onboarding/$id': typeof AuthgatedAppTenantSlugHrOnboardingIdRoute
  '/app/$tenantSlug/me/account/notifications': typeof AuthgatedAppTenantSlugMeAccountNotificationsRoute
  '/app/$tenantSlug/me/account/security': typeof AuthgatedAppTenantSlugMeAccountSecurityRoute
  '/app/$tenantSlug/me/details/$itemId': typeof AuthgatedAppTenantSlugMeDetailsItemIdRoute
  '/app/$tenantSlug/me/letters/$id': typeof AuthgatedAppTenantSlugMeLettersIdRoute
  '/app/$tenantSlug/me/surveys/$id': typeof AuthgatedAppTenantSlugMeSurveysIdRoute
  '/app/$tenantSlug/payroll/filings/$id': typeof AuthgatedAppTenantSlugPayrollFilingsIdRoute
  '/app/$tenantSlug/payroll/tax-declaration/$declId': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute
  '/app/$tenantSlug/payroll/tax-declaration/queue': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute
  '/app/$tenantSlug/people/$id/edit': typeof AuthgatedAppTenantSlugPeopleIdEditRoute
  '/app/$tenantSlug/performance/cycles/$id': typeof AuthgatedAppTenantSlugPerformanceCyclesIdRoute
  '/app/$tenantSlug/performance/cycles/new': typeof AuthgatedAppTenantSlugPerformanceCyclesNewRoute
  '/app/$tenantSlug/performance/goals/$id': typeof AuthgatedAppTenantSlugPerformanceGoalsIdRoute
  '/app/$tenantSlug/performance/goals/new': typeof AuthgatedAppTenantSlugPerformanceGoalsNewRoute
  '/app/$tenantSlug/performance/my-results/$cycleId': typeof AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute
  '/app/$tenantSlug/performance/one-on-ones/$id': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute
  '/app/$tenantSlug/performance/one-on-ones/new': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute
  '/app/$tenantSlug/performance/reviews/$id': typeof AuthgatedAppTenantSlugPerformanceReviewsIdRoute
  '/app/$tenantSlug/performance/reviews/new': typeof AuthgatedAppTenantSlugPerformanceReviewsNewRoute
  '/app/$tenantSlug/posh/complaints/new': typeof AuthgatedAppTenantSlugPoshComplaintsNewRoute
  '/app/$tenantSlug/posh/policy/$id': typeof AuthgatedAppTenantSlugPoshPolicyIdRoute
  '/app/$tenantSlug/posh/reports/$id': typeof AuthgatedAppTenantSlugPoshReportsIdRoute
  '/app/$tenantSlug/settings/checklists/offboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute
  '/app/$tenantSlug/settings/checklists/onboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute
  '/app/$tenantSlug/settings/checklists/preboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute
  '/app/$tenantSlug/settings/tax-codes/new': typeof AuthgatedAppTenantSlugSettingsTaxCodesNewRoute
  '/app/$tenantSlug/surveys/$id/results': typeof AuthgatedAppTenantSlugSurveysIdResultsRoute
  '/app/$tenantSlug/timesheet/weeks/$weekStart': typeof AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute
  '/app/$tenantSlug/accounting/accounts': typeof AuthgatedAppTenantSlugAccountingAccountsIndexRoute
  '/app/$tenantSlug/accounting/contacts': typeof AuthgatedAppTenantSlugAccountingContactsIndexRoute
  '/app/$tenantSlug/accounting/items': typeof AuthgatedAppTenantSlugAccountingItemsIndexRoute
  '/app/$tenantSlug/accounting/journals': typeof AuthgatedAppTenantSlugAccountingJournalsIndexRoute
  '/app/$tenantSlug/accounting/money': typeof AuthgatedAppTenantSlugAccountingMoneyIndexRoute
  '/app/$tenantSlug/accounting/purchases': typeof AuthgatedAppTenantSlugAccountingPurchasesIndexRoute
  '/app/$tenantSlug/accounting/reports': typeof AuthgatedAppTenantSlugAccountingReportsIndexRoute
  '/app/$tenantSlug/accounting/sales': typeof AuthgatedAppTenantSlugAccountingSalesIndexRoute
  '/app/$tenantSlug/attendance/import': typeof AuthgatedAppTenantSlugAttendanceImportIndexRoute
  '/app/$tenantSlug/hiring/candidates': typeof AuthgatedAppTenantSlugHiringCandidatesIndexRoute
  '/app/$tenantSlug/hiring/requisitions': typeof AuthgatedAppTenantSlugHiringRequisitionsIndexRoute
  '/app/$tenantSlug/hr/offboarding': typeof AuthgatedAppTenantSlugHrOffboardingIndexRoute
  '/app/$tenantSlug/hr/onboarding': typeof AuthgatedAppTenantSlugHrOnboardingIndexRoute
  '/app/$tenantSlug/me/account': typeof AuthgatedAppTenantSlugMeAccountIndexRoute
  '/app/$tenantSlug/me/details': typeof AuthgatedAppTenantSlugMeDetailsIndexRoute
  '/app/$tenantSlug/me/letters': typeof AuthgatedAppTenantSlugMeLettersIndexRoute
  '/app/$tenantSlug/payroll/tax-declaration': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute
  '/app/$tenantSlug/performance/cycles': typeof AuthgatedAppTenantSlugPerformanceCyclesIndexRoute
  '/app/$tenantSlug/performance/goals': typeof AuthgatedAppTenantSlugPerformanceGoalsIndexRoute
  '/app/$tenantSlug/performance/my-results': typeof AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute
  '/app/$tenantSlug/performance/one-on-ones': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute
  '/app/$tenantSlug/performance/reviews': typeof AuthgatedAppTenantSlugPerformanceReviewsIndexRoute
  '/app/$tenantSlug/posh/complaints': typeof AuthgatedAppTenantSlugPoshComplaintsIndexRoute
  '/app/$tenantSlug/posh/policy': typeof AuthgatedAppTenantSlugPoshPolicyIndexRoute
  '/app/$tenantSlug/posh/reports': typeof AuthgatedAppTenantSlugPoshReportsIndexRoute
  '/app/$tenantSlug/posh/training': typeof AuthgatedAppTenantSlugPoshTrainingIndexRoute
  '/app/$tenantSlug/settings/checklists': typeof AuthgatedAppTenantSlugSettingsChecklistsIndexRoute
  '/app/$tenantSlug/settings/tax-codes': typeof AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute
  '/app/$tenantSlug/surveys/$id': typeof AuthgatedAppTenantSlugSurveysIdIndexRoute
  '/app/$tenantSlug/accounting/money/payments/$id': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute
  '/app/$tenantSlug/accounting/money/payments/new': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute
  '/app/$tenantSlug/accounting/money/receipts/$id': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute
  '/app/$tenantSlug/accounting/money/receipts/new': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute
  '/app/$tenantSlug/accounting/sales/invoices/$id': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute
  '/app/$tenantSlug/accounting/sales/invoices/new': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute
  '/app/$tenantSlug/accounting/sales/quotes/$id': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute
  '/app/$tenantSlug/accounting/sales/quotes/new': typeof AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute
  '/app/$tenantSlug/hiring/requisitions/$id/pipeline': typeof AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute
  '/app/$tenantSlug/hiring/requisitions/$id/report': typeof AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute
  '/app/$tenantSlug/posh/complaints/$id/manage': typeof AuthgatedAppTenantSlugPoshComplaintsIdManageRoute
  '/app/$tenantSlug/posh/training/$moduleId/quiz': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute
  '/app/$tenantSlug/timesheet/admin/projects/$id': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute
  '/app/$tenantSlug/accounting/money/payments': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute
  '/app/$tenantSlug/accounting/money/receipts': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute
  '/app/$tenantSlug/accounting/sales/quotes': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute
  '/app/$tenantSlug/hiring/requisitions/$id': typeof AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute
  '/app/$tenantSlug/hr/offboarding/letters': typeof AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute
  '/app/$tenantSlug/posh/complaints/$id': typeof AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute
  '/app/$tenantSlug/posh/training/$moduleId': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute
  '/app/$tenantSlug/timesheet/admin/projects': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute
  '/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge': typeof AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authgated': typeof AuthgatedRouteWithChildren
  '/_auth/2fa-setup': typeof Auth2faSetupRoute
  '/_auth/2fa-verify': typeof Auth2faVerifyRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/confirm-email': typeof AuthConfirmEmailRoute
  '/_auth/forgot': typeof AuthForgotRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset': typeof AuthResetRoute
  '/_auth/select-workspace': typeof AuthSelectWorkspaceRoute
  '/_authgated/superadmin': typeof AuthgatedSuperadminRouteWithChildren
  '/join/$token': typeof JoinTokenRoute
  '/_authgated/app/$tenantSlug': typeof AuthgatedAppTenantSlugRouteWithChildren
  '/_authgated/superadmin/audit': typeof AuthgatedSuperadminAuditRoute
  '/_authgated/superadmin/funnel': typeof AuthgatedSuperadminFunnelRoute
  '/_authgated/superadmin/plans': typeof AuthgatedSuperadminPlansRoute
  '/_authgated/superadmin/users': typeof AuthgatedSuperadminUsersRoute
  '/_authgated/superadmin/': typeof AuthgatedSuperadminIndexRoute
  '/_authgated/app/$tenantSlug/announcements': typeof AuthgatedAppTenantSlugAnnouncementsRoute
  '/_authgated/app/$tenantSlug/approval-delegation': typeof AuthgatedAppTenantSlugApprovalDelegationRoute
  '/_authgated/app/$tenantSlug/approvals': typeof AuthgatedAppTenantSlugApprovalsRoute
  '/_authgated/app/$tenantSlug/calendar': typeof AuthgatedAppTenantSlugCalendarRoute
  '/_authgated/app/$tenantSlug/comp-off': typeof AuthgatedAppTenantSlugCompOffRoute
  '/_authgated/app/$tenantSlug/compliance': typeof AuthgatedAppTenantSlugComplianceRoute
  '/_authgated/app/$tenantSlug/directory': typeof AuthgatedAppTenantSlugDirectoryRoute
  '/_authgated/app/$tenantSlug/exit-tasks': typeof AuthgatedAppTenantSlugExitTasksRoute
  '/_authgated/app/$tenantSlug/helpdesk': typeof AuthgatedAppTenantSlugHelpdeskRouteWithChildren
  '/_authgated/app/$tenantSlug/holidays': typeof AuthgatedAppTenantSlugHolidaysRoute
  '/_authgated/app/$tenantSlug/interviews': typeof AuthgatedAppTenantSlugInterviewsRoute
  '/_authgated/app/$tenantSlug/my-time': typeof AuthgatedAppTenantSlugMyTimeRoute
  '/_authgated/app/$tenantSlug/overview': typeof AuthgatedAppTenantSlugOverviewRoute
  '/_authgated/app/$tenantSlug/referrals': typeof AuthgatedAppTenantSlugReferralsRoute
  '/_authgated/app/$tenantSlug/skills': typeof AuthgatedAppTenantSlugSkillsRoute
  '/_authgated/app/$tenantSlug/support-tickets': typeof AuthgatedAppTenantSlugSupportTicketsRouteWithChildren
  '/_authgated/app/$tenantSlug/tasks': typeof AuthgatedAppTenantSlugTasksRoute
  '/_authgated/superadmin/support/$id': typeof AuthgatedSuperadminSupportIdRoute
  '/_authgated/superadmin/tenants/$id': typeof AuthgatedSuperadminTenantsIdRoute
  '/_authgated/app/$tenantSlug/': typeof AuthgatedAppTenantSlugIndexRoute
  '/_authgated/superadmin/support/': typeof AuthgatedSuperadminSupportIndexRoute
  '/_authgated/superadmin/tenants/': typeof AuthgatedSuperadminTenantsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/audit': typeof AuthgatedAppTenantSlugAccountingAuditRoute
  '/_authgated/app/$tenantSlug/accounting/opening-balance': typeof AuthgatedAppTenantSlugAccountingOpeningBalanceRoute
  '/_authgated/app/$tenantSlug/accounting/period-locks': typeof AuthgatedAppTenantSlugAccountingPeriodLocksRoute
  '/_authgated/app/$tenantSlug/accounting/post-to-books': typeof AuthgatedAppTenantSlugAccountingPostToBooksRoute
  '/_authgated/app/$tenantSlug/accounting/returns': typeof AuthgatedAppTenantSlugAccountingReturnsRoute
  '/_authgated/app/$tenantSlug/attendance/approvals': typeof AuthgatedAppTenantSlugAttendanceApprovalsRoute
  '/_authgated/app/$tenantSlug/attendance/monthly-summary': typeof AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute
  '/_authgated/app/$tenantSlug/attendance/register': typeof AuthgatedAppTenantSlugAttendanceRegisterRoute
  '/_authgated/app/$tenantSlug/attendance/regularize': typeof AuthgatedAppTenantSlugAttendanceRegularizeRoute
  '/_authgated/app/$tenantSlug/attendance/team': typeof AuthgatedAppTenantSlugAttendanceTeamRoute
  '/_authgated/app/$tenantSlug/bulk-imports/$id': typeof AuthgatedAppTenantSlugBulkImportsIdRoute
  '/_authgated/app/$tenantSlug/bulk-imports/new': typeof AuthgatedAppTenantSlugBulkImportsNewRoute
  '/_authgated/app/$tenantSlug/change-requests/$id': typeof AuthgatedAppTenantSlugChangeRequestsIdRoute
  '/_authgated/app/$tenantSlug/change-requests/new': typeof AuthgatedAppTenantSlugChangeRequestsNewRoute
  '/_authgated/app/$tenantSlug/expenses/$id': typeof AuthgatedAppTenantSlugExpensesIdRoute
  '/_authgated/app/$tenantSlug/expenses/approvals': typeof AuthgatedAppTenantSlugExpensesApprovalsRoute
  '/_authgated/app/$tenantSlug/expenses/batches': typeof AuthgatedAppTenantSlugExpensesBatchesRoute
  '/_authgated/app/$tenantSlug/expenses/new': typeof AuthgatedAppTenantSlugExpensesNewRoute
  '/_authgated/app/$tenantSlug/helpdesk/new': typeof AuthgatedAppTenantSlugHelpdeskNewRoute
  '/_authgated/app/$tenantSlug/hiring/analytics': typeof AuthgatedAppTenantSlugHiringAnalyticsRoute
  '/_authgated/app/$tenantSlug/hiring/costs': typeof AuthgatedAppTenantSlugHiringCostsRoute
  '/_authgated/app/$tenantSlug/hiring/interviews': typeof AuthgatedAppTenantSlugHiringInterviewsRoute
  '/_authgated/app/$tenantSlug/hiring/jobs': typeof AuthgatedAppTenantSlugHiringJobsRoute
  '/_authgated/app/$tenantSlug/hiring/referrals': typeof AuthgatedAppTenantSlugHiringReferralsRoute
  '/_authgated/app/$tenantSlug/hiring/reports': typeof AuthgatedAppTenantSlugHiringReportsRoute
  '/_authgated/app/$tenantSlug/hr/assets': typeof AuthgatedAppTenantSlugHrAssetsRoute
  '/_authgated/app/$tenantSlug/hr/documents': typeof AuthgatedAppTenantSlugHrDocumentsRoute
  '/_authgated/app/$tenantSlug/leave/$id': typeof AuthgatedAppTenantSlugLeaveIdRoute
  '/_authgated/app/$tenantSlug/leave/approvals': typeof AuthgatedAppTenantSlugLeaveApprovalsRoute
  '/_authgated/app/$tenantSlug/leave/balances': typeof AuthgatedAppTenantSlugLeaveBalancesRoute
  '/_authgated/app/$tenantSlug/leave/calendar': typeof AuthgatedAppTenantSlugLeaveCalendarRoute
  '/_authgated/app/$tenantSlug/leave/comp-off': typeof AuthgatedAppTenantSlugLeaveCompOffRoute
  '/_authgated/app/$tenantSlug/leave/holidays': typeof AuthgatedAppTenantSlugLeaveHolidaysRoute
  '/_authgated/app/$tenantSlug/leave/new': typeof AuthgatedAppTenantSlugLeaveNewRoute
  '/_authgated/app/$tenantSlug/loans/$loanId': typeof AuthgatedAppTenantSlugLoansLoanIdRoute
  '/_authgated/app/$tenantSlug/loans/approvals': typeof AuthgatedAppTenantSlugLoansApprovalsRoute
  '/_authgated/app/$tenantSlug/loans/manage': typeof AuthgatedAppTenantSlugLoansManageRoute
  '/_authgated/app/$tenantSlug/loans/new': typeof AuthgatedAppTenantSlugLoansNewRoute
  '/_authgated/app/$tenantSlug/maternity-cases/$id': typeof AuthgatedAppTenantSlugMaternityCasesIdRoute
  '/_authgated/app/$tenantSlug/maternity-cases/new': typeof AuthgatedAppTenantSlugMaternityCasesNewRoute
  '/_authgated/app/$tenantSlug/me/assets': typeof AuthgatedAppTenantSlugMeAssetsRoute
  '/_authgated/app/$tenantSlug/me/documents': typeof AuthgatedAppTenantSlugMeDocumentsRoute
  '/_authgated/app/$tenantSlug/me/exit': typeof AuthgatedAppTenantSlugMeExitRoute
  '/_authgated/app/$tenantSlug/me/loans': typeof AuthgatedAppTenantSlugMeLoansRoute
  '/_authgated/app/$tenantSlug/me/pay': typeof AuthgatedAppTenantSlugMePayRoute
  '/_authgated/app/$tenantSlug/me/profile': typeof AuthgatedAppTenantSlugMeProfileRoute
  '/_authgated/app/$tenantSlug/me/salary': typeof AuthgatedAppTenantSlugMeSalaryRoute
  '/_authgated/app/$tenantSlug/me/security': typeof AuthgatedAppTenantSlugMeSecurityRoute
  '/_authgated/app/$tenantSlug/me/surveys': typeof AuthgatedAppTenantSlugMeSurveysRouteWithChildren
  '/_authgated/app/$tenantSlug/me/tax': typeof AuthgatedAppTenantSlugMeTaxRoute
  '/_authgated/app/$tenantSlug/payroll/$id': typeof AuthgatedAppTenantSlugPayrollIdRoute
  '/_authgated/app/$tenantSlug/payroll/filings': typeof AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren
  '/_authgated/app/$tenantSlug/payroll/new': typeof AuthgatedAppTenantSlugPayrollNewRoute
  '/_authgated/app/$tenantSlug/payroll/pf-ceiling': typeof AuthgatedAppTenantSlugPayrollPfCeilingRoute
  '/_authgated/app/$tenantSlug/payroll/statutory': typeof AuthgatedAppTenantSlugPayrollStatutoryRoute
  '/_authgated/app/$tenantSlug/payroll/statutory-bonus': typeof AuthgatedAppTenantSlugPayrollStatutoryBonusRoute
  '/_authgated/app/$tenantSlug/people/$id': typeof AuthgatedAppTenantSlugPeopleIdRouteWithChildren
  '/_authgated/app/$tenantSlug/people/new': typeof AuthgatedAppTenantSlugPeopleNewRoute
  '/_authgated/app/$tenantSlug/people/org-chart': typeof AuthgatedAppTenantSlugPeopleOrgChartRoute
  '/_authgated/app/$tenantSlug/people/preboarding': typeof AuthgatedAppTenantSlugPeoplePreboardingRoute
  '/_authgated/app/$tenantSlug/performance/feedback': typeof AuthgatedAppTenantSlugPerformanceFeedbackRoute
  '/_authgated/app/$tenantSlug/posh/about': typeof AuthgatedAppTenantSlugPoshAboutRoute
  '/_authgated/app/$tenantSlug/posh/certificates': typeof AuthgatedAppTenantSlugPoshCertificatesRoute
  '/_authgated/app/$tenantSlug/posh/compliance': typeof AuthgatedAppTenantSlugPoshComplianceRoute
  '/_authgated/app/$tenantSlug/posh/icc': typeof AuthgatedAppTenantSlugPoshIccRoute
  '/_authgated/app/$tenantSlug/reports/analytics': typeof AuthgatedAppTenantSlugReportsAnalyticsRoute
  '/_authgated/app/$tenantSlug/reports/headcount': typeof AuthgatedAppTenantSlugReportsHeadcountRoute
  '/_authgated/app/$tenantSlug/reports/payroll-cost': typeof AuthgatedAppTenantSlugReportsPayrollCostRoute
  '/_authgated/app/$tenantSlug/reports/salary-register': typeof AuthgatedAppTenantSlugReportsSalaryRegisterRoute
  '/_authgated/app/$tenantSlug/settings/analytics': typeof AuthgatedAppTenantSlugSettingsAnalyticsRoute
  '/_authgated/app/$tenantSlug/settings/api-tokens': typeof AuthgatedAppTenantSlugSettingsApiTokensRoute
  '/_authgated/app/$tenantSlug/settings/asset-types': typeof AuthgatedAppTenantSlugSettingsAssetTypesRoute
  '/_authgated/app/$tenantSlug/settings/attendance': typeof AuthgatedAppTenantSlugSettingsAttendanceRoute
  '/_authgated/app/$tenantSlug/settings/attendance-device-profiles': typeof AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute
  '/_authgated/app/$tenantSlug/settings/attendance-devices': typeof AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute
  '/_authgated/app/$tenantSlug/settings/audit-log': typeof AuthgatedAppTenantSlugSettingsAuditLogRoute
  '/_authgated/app/$tenantSlug/settings/billing': typeof AuthgatedAppTenantSlugSettingsBillingRoute
  '/_authgated/app/$tenantSlug/settings/careers-branding': typeof AuthgatedAppTenantSlugSettingsCareersBrandingRoute
  '/_authgated/app/$tenantSlug/settings/coa': typeof AuthgatedAppTenantSlugSettingsCoaRoute
  '/_authgated/app/$tenantSlug/settings/competencies': typeof AuthgatedAppTenantSlugSettingsCompetenciesRoute
  '/_authgated/app/$tenantSlug/settings/custom-fields': typeof AuthgatedAppTenantSlugSettingsCustomFieldsRoute
  '/_authgated/app/$tenantSlug/settings/departments': typeof AuthgatedAppTenantSlugSettingsDepartmentsRoute
  '/_authgated/app/$tenantSlug/settings/entities': typeof AuthgatedAppTenantSlugSettingsEntitiesRoute
  '/_authgated/app/$tenantSlug/settings/expense-categories': typeof AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute
  '/_authgated/app/$tenantSlug/settings/hiring-approvals': typeof AuthgatedAppTenantSlugSettingsHiringApprovalsRoute
  '/_authgated/app/$tenantSlug/settings/hiring-emails': typeof AuthgatedAppTenantSlugSettingsHiringEmailsRoute
  '/_authgated/app/$tenantSlug/settings/holidays': typeof AuthgatedAppTenantSlugSettingsHolidaysRoute
  '/_authgated/app/$tenantSlug/settings/jd-templates': typeof AuthgatedAppTenantSlugSettingsJdTemplatesRoute
  '/_authgated/app/$tenantSlug/settings/leave-types': typeof AuthgatedAppTenantSlugSettingsLeaveTypesRoute
  '/_authgated/app/$tenantSlug/settings/modules': typeof AuthgatedAppTenantSlugSettingsModulesRoute
  '/_authgated/app/$tenantSlug/settings/notifications': typeof AuthgatedAppTenantSlugSettingsNotificationsRoute
  '/_authgated/app/$tenantSlug/settings/onboarding-templates': typeof AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute
  '/_authgated/app/$tenantSlug/settings/payment-accounts': typeof AuthgatedAppTenantSlugSettingsPaymentAccountsRoute
  '/_authgated/app/$tenantSlug/settings/posting-accounts': typeof AuthgatedAppTenantSlugSettingsPostingAccountsRoute
  '/_authgated/app/$tenantSlug/settings/roles': typeof AuthgatedAppTenantSlugSettingsRolesRoute
  '/_authgated/app/$tenantSlug/settings/scorecard-templates': typeof AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute
  '/_authgated/app/$tenantSlug/settings/security': typeof AuthgatedAppTenantSlugSettingsSecurityRoute
  '/_authgated/app/$tenantSlug/settings/shifts': typeof AuthgatedAppTenantSlugSettingsShiftsRoute
  '/_authgated/app/$tenantSlug/settings/skills': typeof AuthgatedAppTenantSlugSettingsSkillsRoute
  '/_authgated/app/$tenantSlug/settings/tally-mappings': typeof AuthgatedAppTenantSlugSettingsTallyMappingsRoute
  '/_authgated/app/$tenantSlug/settings/webhooks': typeof AuthgatedAppTenantSlugSettingsWebhooksRoute
  '/_authgated/app/$tenantSlug/settings/workspace': typeof AuthgatedAppTenantSlugSettingsWorkspaceRoute
  '/_authgated/app/$tenantSlug/shifts/roster': typeof AuthgatedAppTenantSlugShiftsRosterRoute
  '/_authgated/app/$tenantSlug/shifts/swaps': typeof AuthgatedAppTenantSlugShiftsSwapsRoute
  '/_authgated/app/$tenantSlug/support-tickets/new': typeof AuthgatedAppTenantSlugSupportTicketsNewRoute
  '/_authgated/app/$tenantSlug/support-tickets_/$id': typeof AuthgatedAppTenantSlugSupportTicketsIdRoute
  '/_authgated/app/$tenantSlug/surveys/new': typeof AuthgatedAppTenantSlugSurveysNewRoute
  '/_authgated/app/$tenantSlug/timesheet/inbox': typeof AuthgatedAppTenantSlugTimesheetInboxRoute
  '/_authgated/app/$tenantSlug/travel-preapprovals/$id': typeof AuthgatedAppTenantSlugTravelPreapprovalsIdRoute
  '/_authgated/app/$tenantSlug/travel-preapprovals/new': typeof AuthgatedAppTenantSlugTravelPreapprovalsNewRoute
  '/_authgated/app/$tenantSlug/wfh/$id': typeof AuthgatedAppTenantSlugWfhIdRoute
  '/_authgated/app/$tenantSlug/wfh/approvals': typeof AuthgatedAppTenantSlugWfhApprovalsRoute
  '/_authgated/app/$tenantSlug/accounting/': typeof AuthgatedAppTenantSlugAccountingIndexRoute
  '/_authgated/app/$tenantSlug/attendance/': typeof AuthgatedAppTenantSlugAttendanceIndexRoute
  '/_authgated/app/$tenantSlug/bulk-imports/': typeof AuthgatedAppTenantSlugBulkImportsIndexRoute
  '/_authgated/app/$tenantSlug/change-requests/': typeof AuthgatedAppTenantSlugChangeRequestsIndexRoute
  '/_authgated/app/$tenantSlug/expenses/': typeof AuthgatedAppTenantSlugExpensesIndexRoute
  '/_authgated/app/$tenantSlug/hiring/': typeof AuthgatedAppTenantSlugHiringIndexRoute
  '/_authgated/app/$tenantSlug/hr/': typeof AuthgatedAppTenantSlugHrIndexRoute
  '/_authgated/app/$tenantSlug/leave/': typeof AuthgatedAppTenantSlugLeaveIndexRoute
  '/_authgated/app/$tenantSlug/loans/': typeof AuthgatedAppTenantSlugLoansIndexRoute
  '/_authgated/app/$tenantSlug/maternity-cases/': typeof AuthgatedAppTenantSlugMaternityCasesIndexRoute
  '/_authgated/app/$tenantSlug/payroll/': typeof AuthgatedAppTenantSlugPayrollIndexRoute
  '/_authgated/app/$tenantSlug/people/': typeof AuthgatedAppTenantSlugPeopleIndexRoute
  '/_authgated/app/$tenantSlug/performance/': typeof AuthgatedAppTenantSlugPerformanceIndexRoute
  '/_authgated/app/$tenantSlug/posh/': typeof AuthgatedAppTenantSlugPoshIndexRoute
  '/_authgated/app/$tenantSlug/reports/': typeof AuthgatedAppTenantSlugReportsIndexRoute
  '/_authgated/app/$tenantSlug/settings/': typeof AuthgatedAppTenantSlugSettingsIndexRoute
  '/_authgated/app/$tenantSlug/shifts/': typeof AuthgatedAppTenantSlugShiftsIndexRoute
  '/_authgated/app/$tenantSlug/surveys/': typeof AuthgatedAppTenantSlugSurveysIndexRoute
  '/_authgated/app/$tenantSlug/timesheet/': typeof AuthgatedAppTenantSlugTimesheetIndexRoute
  '/_authgated/app/$tenantSlug/travel-preapprovals/': typeof AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute
  '/_authgated/app/$tenantSlug/wfh/': typeof AuthgatedAppTenantSlugWfhIndexRoute
  '/_authgated/app/$tenantSlug/accounting/accounts/new': typeof AuthgatedAppTenantSlugAccountingAccountsNewRoute
  '/_authgated/app/$tenantSlug/accounting/contacts/$id': typeof AuthgatedAppTenantSlugAccountingContactsIdRoute
  '/_authgated/app/$tenantSlug/accounting/contacts/new': typeof AuthgatedAppTenantSlugAccountingContactsNewRoute
  '/_authgated/app/$tenantSlug/accounting/items/$id': typeof AuthgatedAppTenantSlugAccountingItemsIdRoute
  '/_authgated/app/$tenantSlug/accounting/items/new': typeof AuthgatedAppTenantSlugAccountingItemsNewRoute
  '/_authgated/app/$tenantSlug/accounting/journals/$id': typeof AuthgatedAppTenantSlugAccountingJournalsIdRoute
  '/_authgated/app/$tenantSlug/accounting/journals/new': typeof AuthgatedAppTenantSlugAccountingJournalsNewRoute
  '/_authgated/app/$tenantSlug/accounting/ledger/$accountId': typeof AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute
  '/_authgated/app/$tenantSlug/accounting/payroll-runs/$id': typeof AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute
  '/_authgated/app/$tenantSlug/accounting/purchases/$id': typeof AuthgatedAppTenantSlugAccountingPurchasesIdRoute
  '/_authgated/app/$tenantSlug/accounting/purchases/new': typeof AuthgatedAppTenantSlugAccountingPurchasesNewRoute
  '/_authgated/app/$tenantSlug/accounting/reports/balance-sheet': typeof AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute
  '/_authgated/app/$tenantSlug/accounting/reports/msme-overdue': typeof AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute
  '/_authgated/app/$tenantSlug/accounting/reports/profit-and-loss': typeof AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute
  '/_authgated/app/$tenantSlug/accounting/reports/tds-receivable': typeof AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute
  '/_authgated/app/$tenantSlug/accounting/reports/trial-balance': typeof AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute
  '/_authgated/app/$tenantSlug/attendance/import/runs': typeof AuthgatedAppTenantSlugAttendanceImportRunsRoute
  '/_authgated/app/$tenantSlug/helpdesk_/tickets/$id': typeof AuthgatedAppTenantSlugHelpdeskTicketsIdRoute
  '/_authgated/app/$tenantSlug/hiring/candidates/$id': typeof AuthgatedAppTenantSlugHiringCandidatesIdRoute
  '/_authgated/app/$tenantSlug/hiring/requisitions/new': typeof AuthgatedAppTenantSlugHiringRequisitionsNewRoute
  '/_authgated/app/$tenantSlug/hr/offboarding/$id': typeof AuthgatedAppTenantSlugHrOffboardingIdRoute
  '/_authgated/app/$tenantSlug/hr/offboarding/new': typeof AuthgatedAppTenantSlugHrOffboardingNewRoute
  '/_authgated/app/$tenantSlug/hr/onboarding/$id': typeof AuthgatedAppTenantSlugHrOnboardingIdRoute
  '/_authgated/app/$tenantSlug/me/account/notifications': typeof AuthgatedAppTenantSlugMeAccountNotificationsRoute
  '/_authgated/app/$tenantSlug/me/account/security': typeof AuthgatedAppTenantSlugMeAccountSecurityRoute
  '/_authgated/app/$tenantSlug/me/details/$itemId': typeof AuthgatedAppTenantSlugMeDetailsItemIdRoute
  '/_authgated/app/$tenantSlug/me/letters/$id': typeof AuthgatedAppTenantSlugMeLettersIdRoute
  '/_authgated/app/$tenantSlug/me/surveys/$id': typeof AuthgatedAppTenantSlugMeSurveysIdRoute
  '/_authgated/app/$tenantSlug/payroll/filings/$id': typeof AuthgatedAppTenantSlugPayrollFilingsIdRoute
  '/_authgated/app/$tenantSlug/payroll/tax-declaration/$declId': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute
  '/_authgated/app/$tenantSlug/payroll/tax-declaration/queue': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute
  '/_authgated/app/$tenantSlug/people/$id/edit': typeof AuthgatedAppTenantSlugPeopleIdEditRoute
  '/_authgated/app/$tenantSlug/performance/cycles/$id': typeof AuthgatedAppTenantSlugPerformanceCyclesIdRoute
  '/_authgated/app/$tenantSlug/performance/cycles/new': typeof AuthgatedAppTenantSlugPerformanceCyclesNewRoute
  '/_authgated/app/$tenantSlug/performance/goals/$id': typeof AuthgatedAppTenantSlugPerformanceGoalsIdRoute
  '/_authgated/app/$tenantSlug/performance/goals/new': typeof AuthgatedAppTenantSlugPerformanceGoalsNewRoute
  '/_authgated/app/$tenantSlug/performance/my-results/$cycleId': typeof AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute
  '/_authgated/app/$tenantSlug/performance/one-on-ones/$id': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute
  '/_authgated/app/$tenantSlug/performance/one-on-ones/new': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute
  '/_authgated/app/$tenantSlug/performance/reviews/$id': typeof AuthgatedAppTenantSlugPerformanceReviewsIdRoute
  '/_authgated/app/$tenantSlug/performance/reviews/new': typeof AuthgatedAppTenantSlugPerformanceReviewsNewRoute
  '/_authgated/app/$tenantSlug/posh/complaints/new': typeof AuthgatedAppTenantSlugPoshComplaintsNewRoute
  '/_authgated/app/$tenantSlug/posh/policy/$id': typeof AuthgatedAppTenantSlugPoshPolicyIdRoute
  '/_authgated/app/$tenantSlug/posh/reports/$id': typeof AuthgatedAppTenantSlugPoshReportsIdRoute
  '/_authgated/app/$tenantSlug/settings/checklists/offboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute
  '/_authgated/app/$tenantSlug/settings/checklists/onboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute
  '/_authgated/app/$tenantSlug/settings/checklists/preboarding': typeof AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute
  '/_authgated/app/$tenantSlug/settings/tax-codes/new': typeof AuthgatedAppTenantSlugSettingsTaxCodesNewRoute
  '/_authgated/app/$tenantSlug/surveys/$id/results': typeof AuthgatedAppTenantSlugSurveysIdResultsRoute
  '/_authgated/app/$tenantSlug/timesheet/weeks/$weekStart': typeof AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute
  '/_authgated/app/$tenantSlug/accounting/accounts/': typeof AuthgatedAppTenantSlugAccountingAccountsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/contacts/': typeof AuthgatedAppTenantSlugAccountingContactsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/items/': typeof AuthgatedAppTenantSlugAccountingItemsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/journals/': typeof AuthgatedAppTenantSlugAccountingJournalsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/money/': typeof AuthgatedAppTenantSlugAccountingMoneyIndexRoute
  '/_authgated/app/$tenantSlug/accounting/purchases/': typeof AuthgatedAppTenantSlugAccountingPurchasesIndexRoute
  '/_authgated/app/$tenantSlug/accounting/reports/': typeof AuthgatedAppTenantSlugAccountingReportsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/sales/': typeof AuthgatedAppTenantSlugAccountingSalesIndexRoute
  '/_authgated/app/$tenantSlug/attendance/import/': typeof AuthgatedAppTenantSlugAttendanceImportIndexRoute
  '/_authgated/app/$tenantSlug/hiring/candidates/': typeof AuthgatedAppTenantSlugHiringCandidatesIndexRoute
  '/_authgated/app/$tenantSlug/hiring/requisitions/': typeof AuthgatedAppTenantSlugHiringRequisitionsIndexRoute
  '/_authgated/app/$tenantSlug/hr/offboarding/': typeof AuthgatedAppTenantSlugHrOffboardingIndexRoute
  '/_authgated/app/$tenantSlug/hr/onboarding/': typeof AuthgatedAppTenantSlugHrOnboardingIndexRoute
  '/_authgated/app/$tenantSlug/me/account/': typeof AuthgatedAppTenantSlugMeAccountIndexRoute
  '/_authgated/app/$tenantSlug/me/details/': typeof AuthgatedAppTenantSlugMeDetailsIndexRoute
  '/_authgated/app/$tenantSlug/me/letters/': typeof AuthgatedAppTenantSlugMeLettersIndexRoute
  '/_authgated/app/$tenantSlug/payroll/tax-declaration/': typeof AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute
  '/_authgated/app/$tenantSlug/performance/cycles/': typeof AuthgatedAppTenantSlugPerformanceCyclesIndexRoute
  '/_authgated/app/$tenantSlug/performance/goals/': typeof AuthgatedAppTenantSlugPerformanceGoalsIndexRoute
  '/_authgated/app/$tenantSlug/performance/my-results/': typeof AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute
  '/_authgated/app/$tenantSlug/performance/one-on-ones/': typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute
  '/_authgated/app/$tenantSlug/performance/reviews/': typeof AuthgatedAppTenantSlugPerformanceReviewsIndexRoute
  '/_authgated/app/$tenantSlug/posh/complaints/': typeof AuthgatedAppTenantSlugPoshComplaintsIndexRoute
  '/_authgated/app/$tenantSlug/posh/policy/': typeof AuthgatedAppTenantSlugPoshPolicyIndexRoute
  '/_authgated/app/$tenantSlug/posh/reports/': typeof AuthgatedAppTenantSlugPoshReportsIndexRoute
  '/_authgated/app/$tenantSlug/posh/training/': typeof AuthgatedAppTenantSlugPoshTrainingIndexRoute
  '/_authgated/app/$tenantSlug/settings/checklists/': typeof AuthgatedAppTenantSlugSettingsChecklistsIndexRoute
  '/_authgated/app/$tenantSlug/settings/tax-codes/': typeof AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute
  '/_authgated/app/$tenantSlug/surveys/$id/': typeof AuthgatedAppTenantSlugSurveysIdIndexRoute
  '/_authgated/app/$tenantSlug/accounting/money/payments/$id': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute
  '/_authgated/app/$tenantSlug/accounting/money/payments/new': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute
  '/_authgated/app/$tenantSlug/accounting/money/receipts/$id': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute
  '/_authgated/app/$tenantSlug/accounting/money/receipts/new': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute
  '/_authgated/app/$tenantSlug/accounting/sales/invoices/$id': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute
  '/_authgated/app/$tenantSlug/accounting/sales/invoices/new': typeof AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute
  '/_authgated/app/$tenantSlug/accounting/sales/quotes/$id': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute
  '/_authgated/app/$tenantSlug/accounting/sales/quotes/new': typeof AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute
  '/_authgated/app/$tenantSlug/hiring/requisitions/$id/pipeline': typeof AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute
  '/_authgated/app/$tenantSlug/hiring/requisitions/$id/report': typeof AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute
  '/_authgated/app/$tenantSlug/posh/complaints/$id/manage': typeof AuthgatedAppTenantSlugPoshComplaintsIdManageRoute
  '/_authgated/app/$tenantSlug/posh/training/$moduleId/quiz': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute
  '/_authgated/app/$tenantSlug/timesheet/admin/projects/$id': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute
  '/_authgated/app/$tenantSlug/accounting/money/payments/': typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/money/receipts/': typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute
  '/_authgated/app/$tenantSlug/accounting/sales/quotes/': typeof AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute
  '/_authgated/app/$tenantSlug/hiring/requisitions/$id/': typeof AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute
  '/_authgated/app/$tenantSlug/hr/offboarding/letters/': typeof AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute
  '/_authgated/app/$tenantSlug/posh/complaints/$id/': typeof AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute
  '/_authgated/app/$tenantSlug/posh/training/$moduleId/': typeof AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute
  '/_authgated/app/$tenantSlug/timesheet/admin/projects/': typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute
  '/_authgated/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge': typeof AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/2fa-setup'
    | '/2fa-verify'
    | '/change-password'
    | '/confirm-email'
    | '/forgot'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset'
    | '/select-workspace'
    | '/superadmin'
    | '/join/$token'
    | '/app/$tenantSlug'
    | '/superadmin/audit'
    | '/superadmin/funnel'
    | '/superadmin/plans'
    | '/superadmin/users'
    | '/superadmin/'
    | '/app/$tenantSlug/announcements'
    | '/app/$tenantSlug/approval-delegation'
    | '/app/$tenantSlug/approvals'
    | '/app/$tenantSlug/calendar'
    | '/app/$tenantSlug/comp-off'
    | '/app/$tenantSlug/compliance'
    | '/app/$tenantSlug/directory'
    | '/app/$tenantSlug/exit-tasks'
    | '/app/$tenantSlug/helpdesk'
    | '/app/$tenantSlug/holidays'
    | '/app/$tenantSlug/interviews'
    | '/app/$tenantSlug/my-time'
    | '/app/$tenantSlug/overview'
    | '/app/$tenantSlug/referrals'
    | '/app/$tenantSlug/skills'
    | '/app/$tenantSlug/support-tickets'
    | '/app/$tenantSlug/tasks'
    | '/superadmin/support/$id'
    | '/superadmin/tenants/$id'
    | '/app/$tenantSlug/'
    | '/superadmin/support/'
    | '/superadmin/tenants/'
    | '/app/$tenantSlug/accounting/audit'
    | '/app/$tenantSlug/accounting/opening-balance'
    | '/app/$tenantSlug/accounting/period-locks'
    | '/app/$tenantSlug/accounting/post-to-books'
    | '/app/$tenantSlug/accounting/returns'
    | '/app/$tenantSlug/attendance/approvals'
    | '/app/$tenantSlug/attendance/monthly-summary'
    | '/app/$tenantSlug/attendance/register'
    | '/app/$tenantSlug/attendance/regularize'
    | '/app/$tenantSlug/attendance/team'
    | '/app/$tenantSlug/bulk-imports/$id'
    | '/app/$tenantSlug/bulk-imports/new'
    | '/app/$tenantSlug/change-requests/$id'
    | '/app/$tenantSlug/change-requests/new'
    | '/app/$tenantSlug/expenses/$id'
    | '/app/$tenantSlug/expenses/approvals'
    | '/app/$tenantSlug/expenses/batches'
    | '/app/$tenantSlug/expenses/new'
    | '/app/$tenantSlug/helpdesk/new'
    | '/app/$tenantSlug/hiring/analytics'
    | '/app/$tenantSlug/hiring/costs'
    | '/app/$tenantSlug/hiring/interviews'
    | '/app/$tenantSlug/hiring/jobs'
    | '/app/$tenantSlug/hiring/referrals'
    | '/app/$tenantSlug/hiring/reports'
    | '/app/$tenantSlug/hr/assets'
    | '/app/$tenantSlug/hr/documents'
    | '/app/$tenantSlug/leave/$id'
    | '/app/$tenantSlug/leave/approvals'
    | '/app/$tenantSlug/leave/balances'
    | '/app/$tenantSlug/leave/calendar'
    | '/app/$tenantSlug/leave/comp-off'
    | '/app/$tenantSlug/leave/holidays'
    | '/app/$tenantSlug/leave/new'
    | '/app/$tenantSlug/loans/$loanId'
    | '/app/$tenantSlug/loans/approvals'
    | '/app/$tenantSlug/loans/manage'
    | '/app/$tenantSlug/loans/new'
    | '/app/$tenantSlug/maternity-cases/$id'
    | '/app/$tenantSlug/maternity-cases/new'
    | '/app/$tenantSlug/me/assets'
    | '/app/$tenantSlug/me/documents'
    | '/app/$tenantSlug/me/exit'
    | '/app/$tenantSlug/me/loans'
    | '/app/$tenantSlug/me/pay'
    | '/app/$tenantSlug/me/profile'
    | '/app/$tenantSlug/me/salary'
    | '/app/$tenantSlug/me/security'
    | '/app/$tenantSlug/me/surveys'
    | '/app/$tenantSlug/me/tax'
    | '/app/$tenantSlug/payroll/$id'
    | '/app/$tenantSlug/payroll/filings'
    | '/app/$tenantSlug/payroll/new'
    | '/app/$tenantSlug/payroll/pf-ceiling'
    | '/app/$tenantSlug/payroll/statutory'
    | '/app/$tenantSlug/payroll/statutory-bonus'
    | '/app/$tenantSlug/people/$id'
    | '/app/$tenantSlug/people/new'
    | '/app/$tenantSlug/people/org-chart'
    | '/app/$tenantSlug/people/preboarding'
    | '/app/$tenantSlug/performance/feedback'
    | '/app/$tenantSlug/posh/about'
    | '/app/$tenantSlug/posh/certificates'
    | '/app/$tenantSlug/posh/compliance'
    | '/app/$tenantSlug/posh/icc'
    | '/app/$tenantSlug/reports/analytics'
    | '/app/$tenantSlug/reports/headcount'
    | '/app/$tenantSlug/reports/payroll-cost'
    | '/app/$tenantSlug/reports/salary-register'
    | '/app/$tenantSlug/settings/analytics'
    | '/app/$tenantSlug/settings/api-tokens'
    | '/app/$tenantSlug/settings/asset-types'
    | '/app/$tenantSlug/settings/attendance'
    | '/app/$tenantSlug/settings/attendance-device-profiles'
    | '/app/$tenantSlug/settings/attendance-devices'
    | '/app/$tenantSlug/settings/audit-log'
    | '/app/$tenantSlug/settings/billing'
    | '/app/$tenantSlug/settings/careers-branding'
    | '/app/$tenantSlug/settings/coa'
    | '/app/$tenantSlug/settings/competencies'
    | '/app/$tenantSlug/settings/custom-fields'
    | '/app/$tenantSlug/settings/departments'
    | '/app/$tenantSlug/settings/entities'
    | '/app/$tenantSlug/settings/expense-categories'
    | '/app/$tenantSlug/settings/hiring-approvals'
    | '/app/$tenantSlug/settings/hiring-emails'
    | '/app/$tenantSlug/settings/holidays'
    | '/app/$tenantSlug/settings/jd-templates'
    | '/app/$tenantSlug/settings/leave-types'
    | '/app/$tenantSlug/settings/modules'
    | '/app/$tenantSlug/settings/notifications'
    | '/app/$tenantSlug/settings/onboarding-templates'
    | '/app/$tenantSlug/settings/payment-accounts'
    | '/app/$tenantSlug/settings/posting-accounts'
    | '/app/$tenantSlug/settings/roles'
    | '/app/$tenantSlug/settings/scorecard-templates'
    | '/app/$tenantSlug/settings/security'
    | '/app/$tenantSlug/settings/shifts'
    | '/app/$tenantSlug/settings/skills'
    | '/app/$tenantSlug/settings/tally-mappings'
    | '/app/$tenantSlug/settings/webhooks'
    | '/app/$tenantSlug/settings/workspace'
    | '/app/$tenantSlug/shifts/roster'
    | '/app/$tenantSlug/shifts/swaps'
    | '/app/$tenantSlug/support-tickets/new'
    | '/app/$tenantSlug/support-tickets/$id'
    | '/app/$tenantSlug/surveys/new'
    | '/app/$tenantSlug/timesheet/inbox'
    | '/app/$tenantSlug/travel-preapprovals/$id'
    | '/app/$tenantSlug/travel-preapprovals/new'
    | '/app/$tenantSlug/wfh/$id'
    | '/app/$tenantSlug/wfh/approvals'
    | '/app/$tenantSlug/accounting/'
    | '/app/$tenantSlug/attendance/'
    | '/app/$tenantSlug/bulk-imports/'
    | '/app/$tenantSlug/change-requests/'
    | '/app/$tenantSlug/expenses/'
    | '/app/$tenantSlug/hiring/'
    | '/app/$tenantSlug/hr/'
    | '/app/$tenantSlug/leave/'
    | '/app/$tenantSlug/loans/'
    | '/app/$tenantSlug/maternity-cases/'
    | '/app/$tenantSlug/payroll/'
    | '/app/$tenantSlug/people/'
    | '/app/$tenantSlug/performance/'
    | '/app/$tenantSlug/posh/'
    | '/app/$tenantSlug/reports/'
    | '/app/$tenantSlug/settings/'
    | '/app/$tenantSlug/shifts/'
    | '/app/$tenantSlug/surveys/'
    | '/app/$tenantSlug/timesheet/'
    | '/app/$tenantSlug/travel-preapprovals/'
    | '/app/$tenantSlug/wfh/'
    | '/app/$tenantSlug/accounting/accounts/new'
    | '/app/$tenantSlug/accounting/contacts/$id'
    | '/app/$tenantSlug/accounting/contacts/new'
    | '/app/$tenantSlug/accounting/items/$id'
    | '/app/$tenantSlug/accounting/items/new'
    | '/app/$tenantSlug/accounting/journals/$id'
    | '/app/$tenantSlug/accounting/journals/new'
    | '/app/$tenantSlug/accounting/ledger/$accountId'
    | '/app/$tenantSlug/accounting/payroll-runs/$id'
    | '/app/$tenantSlug/accounting/purchases/$id'
    | '/app/$tenantSlug/accounting/purchases/new'
    | '/app/$tenantSlug/accounting/reports/balance-sheet'
    | '/app/$tenantSlug/accounting/reports/msme-overdue'
    | '/app/$tenantSlug/accounting/reports/profit-and-loss'
    | '/app/$tenantSlug/accounting/reports/tds-receivable'
    | '/app/$tenantSlug/accounting/reports/trial-balance'
    | '/app/$tenantSlug/attendance/import/runs'
    | '/app/$tenantSlug/helpdesk/tickets/$id'
    | '/app/$tenantSlug/hiring/candidates/$id'
    | '/app/$tenantSlug/hiring/requisitions/new'
    | '/app/$tenantSlug/hr/offboarding/$id'
    | '/app/$tenantSlug/hr/offboarding/new'
    | '/app/$tenantSlug/hr/onboarding/$id'
    | '/app/$tenantSlug/me/account/notifications'
    | '/app/$tenantSlug/me/account/security'
    | '/app/$tenantSlug/me/details/$itemId'
    | '/app/$tenantSlug/me/letters/$id'
    | '/app/$tenantSlug/me/surveys/$id'
    | '/app/$tenantSlug/payroll/filings/$id'
    | '/app/$tenantSlug/payroll/tax-declaration/$declId'
    | '/app/$tenantSlug/payroll/tax-declaration/queue'
    | '/app/$tenantSlug/people/$id/edit'
    | '/app/$tenantSlug/performance/cycles/$id'
    | '/app/$tenantSlug/performance/cycles/new'
    | '/app/$tenantSlug/performance/goals/$id'
    | '/app/$tenantSlug/performance/goals/new'
    | '/app/$tenantSlug/performance/my-results/$cycleId'
    | '/app/$tenantSlug/performance/one-on-ones/$id'
    | '/app/$tenantSlug/performance/one-on-ones/new'
    | '/app/$tenantSlug/performance/reviews/$id'
    | '/app/$tenantSlug/performance/reviews/new'
    | '/app/$tenantSlug/posh/complaints/new'
    | '/app/$tenantSlug/posh/policy/$id'
    | '/app/$tenantSlug/posh/reports/$id'
    | '/app/$tenantSlug/settings/checklists/offboarding'
    | '/app/$tenantSlug/settings/checklists/onboarding'
    | '/app/$tenantSlug/settings/checklists/preboarding'
    | '/app/$tenantSlug/settings/tax-codes/new'
    | '/app/$tenantSlug/surveys/$id/results'
    | '/app/$tenantSlug/timesheet/weeks/$weekStart'
    | '/app/$tenantSlug/accounting/accounts/'
    | '/app/$tenantSlug/accounting/contacts/'
    | '/app/$tenantSlug/accounting/items/'
    | '/app/$tenantSlug/accounting/journals/'
    | '/app/$tenantSlug/accounting/money/'
    | '/app/$tenantSlug/accounting/purchases/'
    | '/app/$tenantSlug/accounting/reports/'
    | '/app/$tenantSlug/accounting/sales/'
    | '/app/$tenantSlug/attendance/import/'
    | '/app/$tenantSlug/hiring/candidates/'
    | '/app/$tenantSlug/hiring/requisitions/'
    | '/app/$tenantSlug/hr/offboarding/'
    | '/app/$tenantSlug/hr/onboarding/'
    | '/app/$tenantSlug/me/account/'
    | '/app/$tenantSlug/me/details/'
    | '/app/$tenantSlug/me/letters/'
    | '/app/$tenantSlug/payroll/tax-declaration/'
    | '/app/$tenantSlug/performance/cycles/'
    | '/app/$tenantSlug/performance/goals/'
    | '/app/$tenantSlug/performance/my-results/'
    | '/app/$tenantSlug/performance/one-on-ones/'
    | '/app/$tenantSlug/performance/reviews/'
    | '/app/$tenantSlug/posh/complaints/'
    | '/app/$tenantSlug/posh/policy/'
    | '/app/$tenantSlug/posh/reports/'
    | '/app/$tenantSlug/posh/training/'
    | '/app/$tenantSlug/settings/checklists/'
    | '/app/$tenantSlug/settings/tax-codes/'
    | '/app/$tenantSlug/surveys/$id/'
    | '/app/$tenantSlug/accounting/money/payments/$id'
    | '/app/$tenantSlug/accounting/money/payments/new'
    | '/app/$tenantSlug/accounting/money/receipts/$id'
    | '/app/$tenantSlug/accounting/money/receipts/new'
    | '/app/$tenantSlug/accounting/sales/invoices/$id'
    | '/app/$tenantSlug/accounting/sales/invoices/new'
    | '/app/$tenantSlug/accounting/sales/quotes/$id'
    | '/app/$tenantSlug/accounting/sales/quotes/new'
    | '/app/$tenantSlug/hiring/requisitions/$id/pipeline'
    | '/app/$tenantSlug/hiring/requisitions/$id/report'
    | '/app/$tenantSlug/posh/complaints/$id/manage'
    | '/app/$tenantSlug/posh/training/$moduleId/quiz'
    | '/app/$tenantSlug/timesheet/admin/projects/$id'
    | '/app/$tenantSlug/accounting/money/payments/'
    | '/app/$tenantSlug/accounting/money/receipts/'
    | '/app/$tenantSlug/accounting/sales/quotes/'
    | '/app/$tenantSlug/hiring/requisitions/$id/'
    | '/app/$tenantSlug/hr/offboarding/letters/'
    | '/app/$tenantSlug/posh/complaints/$id/'
    | '/app/$tenantSlug/posh/training/$moduleId/'
    | '/app/$tenantSlug/timesheet/admin/projects/'
    | '/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/2fa-setup'
    | '/2fa-verify'
    | '/change-password'
    | '/confirm-email'
    | '/forgot'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset'
    | '/select-workspace'
    | '/join/$token'
    | '/superadmin/audit'
    | '/superadmin/funnel'
    | '/superadmin/plans'
    | '/superadmin/users'
    | '/superadmin'
    | '/app/$tenantSlug/announcements'
    | '/app/$tenantSlug/approval-delegation'
    | '/app/$tenantSlug/approvals'
    | '/app/$tenantSlug/calendar'
    | '/app/$tenantSlug/comp-off'
    | '/app/$tenantSlug/compliance'
    | '/app/$tenantSlug/directory'
    | '/app/$tenantSlug/exit-tasks'
    | '/app/$tenantSlug/helpdesk'
    | '/app/$tenantSlug/holidays'
    | '/app/$tenantSlug/interviews'
    | '/app/$tenantSlug/my-time'
    | '/app/$tenantSlug/overview'
    | '/app/$tenantSlug/referrals'
    | '/app/$tenantSlug/skills'
    | '/app/$tenantSlug/support-tickets'
    | '/app/$tenantSlug/tasks'
    | '/superadmin/support/$id'
    | '/superadmin/tenants/$id'
    | '/app/$tenantSlug'
    | '/superadmin/support'
    | '/superadmin/tenants'
    | '/app/$tenantSlug/accounting/audit'
    | '/app/$tenantSlug/accounting/opening-balance'
    | '/app/$tenantSlug/accounting/period-locks'
    | '/app/$tenantSlug/accounting/post-to-books'
    | '/app/$tenantSlug/accounting/returns'
    | '/app/$tenantSlug/attendance/approvals'
    | '/app/$tenantSlug/attendance/monthly-summary'
    | '/app/$tenantSlug/attendance/register'
    | '/app/$tenantSlug/attendance/regularize'
    | '/app/$tenantSlug/attendance/team'
    | '/app/$tenantSlug/bulk-imports/$id'
    | '/app/$tenantSlug/bulk-imports/new'
    | '/app/$tenantSlug/change-requests/$id'
    | '/app/$tenantSlug/change-requests/new'
    | '/app/$tenantSlug/expenses/$id'
    | '/app/$tenantSlug/expenses/approvals'
    | '/app/$tenantSlug/expenses/batches'
    | '/app/$tenantSlug/expenses/new'
    | '/app/$tenantSlug/helpdesk/new'
    | '/app/$tenantSlug/hiring/analytics'
    | '/app/$tenantSlug/hiring/costs'
    | '/app/$tenantSlug/hiring/interviews'
    | '/app/$tenantSlug/hiring/jobs'
    | '/app/$tenantSlug/hiring/referrals'
    | '/app/$tenantSlug/hiring/reports'
    | '/app/$tenantSlug/hr/assets'
    | '/app/$tenantSlug/hr/documents'
    | '/app/$tenantSlug/leave/$id'
    | '/app/$tenantSlug/leave/approvals'
    | '/app/$tenantSlug/leave/balances'
    | '/app/$tenantSlug/leave/calendar'
    | '/app/$tenantSlug/leave/comp-off'
    | '/app/$tenantSlug/leave/holidays'
    | '/app/$tenantSlug/leave/new'
    | '/app/$tenantSlug/loans/$loanId'
    | '/app/$tenantSlug/loans/approvals'
    | '/app/$tenantSlug/loans/manage'
    | '/app/$tenantSlug/loans/new'
    | '/app/$tenantSlug/maternity-cases/$id'
    | '/app/$tenantSlug/maternity-cases/new'
    | '/app/$tenantSlug/me/assets'
    | '/app/$tenantSlug/me/documents'
    | '/app/$tenantSlug/me/exit'
    | '/app/$tenantSlug/me/loans'
    | '/app/$tenantSlug/me/pay'
    | '/app/$tenantSlug/me/profile'
    | '/app/$tenantSlug/me/salary'
    | '/app/$tenantSlug/me/security'
    | '/app/$tenantSlug/me/surveys'
    | '/app/$tenantSlug/me/tax'
    | '/app/$tenantSlug/payroll/$id'
    | '/app/$tenantSlug/payroll/filings'
    | '/app/$tenantSlug/payroll/new'
    | '/app/$tenantSlug/payroll/pf-ceiling'
    | '/app/$tenantSlug/payroll/statutory'
    | '/app/$tenantSlug/payroll/statutory-bonus'
    | '/app/$tenantSlug/people/$id'
    | '/app/$tenantSlug/people/new'
    | '/app/$tenantSlug/people/org-chart'
    | '/app/$tenantSlug/people/preboarding'
    | '/app/$tenantSlug/performance/feedback'
    | '/app/$tenantSlug/posh/about'
    | '/app/$tenantSlug/posh/certificates'
    | '/app/$tenantSlug/posh/compliance'
    | '/app/$tenantSlug/posh/icc'
    | '/app/$tenantSlug/reports/analytics'
    | '/app/$tenantSlug/reports/headcount'
    | '/app/$tenantSlug/reports/payroll-cost'
    | '/app/$tenantSlug/reports/salary-register'
    | '/app/$tenantSlug/settings/analytics'
    | '/app/$tenantSlug/settings/api-tokens'
    | '/app/$tenantSlug/settings/asset-types'
    | '/app/$tenantSlug/settings/attendance'
    | '/app/$tenantSlug/settings/attendance-device-profiles'
    | '/app/$tenantSlug/settings/attendance-devices'
    | '/app/$tenantSlug/settings/audit-log'
    | '/app/$tenantSlug/settings/billing'
    | '/app/$tenantSlug/settings/careers-branding'
    | '/app/$tenantSlug/settings/coa'
    | '/app/$tenantSlug/settings/competencies'
    | '/app/$tenantSlug/settings/custom-fields'
    | '/app/$tenantSlug/settings/departments'
    | '/app/$tenantSlug/settings/entities'
    | '/app/$tenantSlug/settings/expense-categories'
    | '/app/$tenantSlug/settings/hiring-approvals'
    | '/app/$tenantSlug/settings/hiring-emails'
    | '/app/$tenantSlug/settings/holidays'
    | '/app/$tenantSlug/settings/jd-templates'
    | '/app/$tenantSlug/settings/leave-types'
    | '/app/$tenantSlug/settings/modules'
    | '/app/$tenantSlug/settings/notifications'
    | '/app/$tenantSlug/settings/onboarding-templates'
    | '/app/$tenantSlug/settings/payment-accounts'
    | '/app/$tenantSlug/settings/posting-accounts'
    | '/app/$tenantSlug/settings/roles'
    | '/app/$tenantSlug/settings/scorecard-templates'
    | '/app/$tenantSlug/settings/security'
    | '/app/$tenantSlug/settings/shifts'
    | '/app/$tenantSlug/settings/skills'
    | '/app/$tenantSlug/settings/tally-mappings'
    | '/app/$tenantSlug/settings/webhooks'
    | '/app/$tenantSlug/settings/workspace'
    | '/app/$tenantSlug/shifts/roster'
    | '/app/$tenantSlug/shifts/swaps'
    | '/app/$tenantSlug/support-tickets/new'
    | '/app/$tenantSlug/support-tickets/$id'
    | '/app/$tenantSlug/surveys/new'
    | '/app/$tenantSlug/timesheet/inbox'
    | '/app/$tenantSlug/travel-preapprovals/$id'
    | '/app/$tenantSlug/travel-preapprovals/new'
    | '/app/$tenantSlug/wfh/$id'
    | '/app/$tenantSlug/wfh/approvals'
    | '/app/$tenantSlug/accounting'
    | '/app/$tenantSlug/attendance'
    | '/app/$tenantSlug/bulk-imports'
    | '/app/$tenantSlug/change-requests'
    | '/app/$tenantSlug/expenses'
    | '/app/$tenantSlug/hiring'
    | '/app/$tenantSlug/hr'
    | '/app/$tenantSlug/leave'
    | '/app/$tenantSlug/loans'
    | '/app/$tenantSlug/maternity-cases'
    | '/app/$tenantSlug/payroll'
    | '/app/$tenantSlug/people'
    | '/app/$tenantSlug/performance'
    | '/app/$tenantSlug/posh'
    | '/app/$tenantSlug/reports'
    | '/app/$tenantSlug/settings'
    | '/app/$tenantSlug/shifts'
    | '/app/$tenantSlug/surveys'
    | '/app/$tenantSlug/timesheet'
    | '/app/$tenantSlug/travel-preapprovals'
    | '/app/$tenantSlug/wfh'
    | '/app/$tenantSlug/accounting/accounts/new'
    | '/app/$tenantSlug/accounting/contacts/$id'
    | '/app/$tenantSlug/accounting/contacts/new'
    | '/app/$tenantSlug/accounting/items/$id'
    | '/app/$tenantSlug/accounting/items/new'
    | '/app/$tenantSlug/accounting/journals/$id'
    | '/app/$tenantSlug/accounting/journals/new'
    | '/app/$tenantSlug/accounting/ledger/$accountId'
    | '/app/$tenantSlug/accounting/payroll-runs/$id'
    | '/app/$tenantSlug/accounting/purchases/$id'
    | '/app/$tenantSlug/accounting/purchases/new'
    | '/app/$tenantSlug/accounting/reports/balance-sheet'
    | '/app/$tenantSlug/accounting/reports/msme-overdue'
    | '/app/$tenantSlug/accounting/reports/profit-and-loss'
    | '/app/$tenantSlug/accounting/reports/tds-receivable'
    | '/app/$tenantSlug/accounting/reports/trial-balance'
    | '/app/$tenantSlug/attendance/import/runs'
    | '/app/$tenantSlug/helpdesk/tickets/$id'
    | '/app/$tenantSlug/hiring/candidates/$id'
    | '/app/$tenantSlug/hiring/requisitions/new'
    | '/app/$tenantSlug/hr/offboarding/$id'
    | '/app/$tenantSlug/hr/offboarding/new'
    | '/app/$tenantSlug/hr/onboarding/$id'
    | '/app/$tenantSlug/me/account/notifications'
    | '/app/$tenantSlug/me/account/security'
    | '/app/$tenantSlug/me/details/$itemId'
    | '/app/$tenantSlug/me/letters/$id'
    | '/app/$tenantSlug/me/surveys/$id'
    | '/app/$tenantSlug/payroll/filings/$id'
    | '/app/$tenantSlug/payroll/tax-declaration/$declId'
    | '/app/$tenantSlug/payroll/tax-declaration/queue'
    | '/app/$tenantSlug/people/$id/edit'
    | '/app/$tenantSlug/performance/cycles/$id'
    | '/app/$tenantSlug/performance/cycles/new'
    | '/app/$tenantSlug/performance/goals/$id'
    | '/app/$tenantSlug/performance/goals/new'
    | '/app/$tenantSlug/performance/my-results/$cycleId'
    | '/app/$tenantSlug/performance/one-on-ones/$id'
    | '/app/$tenantSlug/performance/one-on-ones/new'
    | '/app/$tenantSlug/performance/reviews/$id'
    | '/app/$tenantSlug/performance/reviews/new'
    | '/app/$tenantSlug/posh/complaints/new'
    | '/app/$tenantSlug/posh/policy/$id'
    | '/app/$tenantSlug/posh/reports/$id'
    | '/app/$tenantSlug/settings/checklists/offboarding'
    | '/app/$tenantSlug/settings/checklists/onboarding'
    | '/app/$tenantSlug/settings/checklists/preboarding'
    | '/app/$tenantSlug/settings/tax-codes/new'
    | '/app/$tenantSlug/surveys/$id/results'
    | '/app/$tenantSlug/timesheet/weeks/$weekStart'
    | '/app/$tenantSlug/accounting/accounts'
    | '/app/$tenantSlug/accounting/contacts'
    | '/app/$tenantSlug/accounting/items'
    | '/app/$tenantSlug/accounting/journals'
    | '/app/$tenantSlug/accounting/money'
    | '/app/$tenantSlug/accounting/purchases'
    | '/app/$tenantSlug/accounting/reports'
    | '/app/$tenantSlug/accounting/sales'
    | '/app/$tenantSlug/attendance/import'
    | '/app/$tenantSlug/hiring/candidates'
    | '/app/$tenantSlug/hiring/requisitions'
    | '/app/$tenantSlug/hr/offboarding'
    | '/app/$tenantSlug/hr/onboarding'
    | '/app/$tenantSlug/me/account'
    | '/app/$tenantSlug/me/details'
    | '/app/$tenantSlug/me/letters'
    | '/app/$tenantSlug/payroll/tax-declaration'
    | '/app/$tenantSlug/performance/cycles'
    | '/app/$tenantSlug/performance/goals'
    | '/app/$tenantSlug/performance/my-results'
    | '/app/$tenantSlug/performance/one-on-ones'
    | '/app/$tenantSlug/performance/reviews'
    | '/app/$tenantSlug/posh/complaints'
    | '/app/$tenantSlug/posh/policy'
    | '/app/$tenantSlug/posh/reports'
    | '/app/$tenantSlug/posh/training'
    | '/app/$tenantSlug/settings/checklists'
    | '/app/$tenantSlug/settings/tax-codes'
    | '/app/$tenantSlug/surveys/$id'
    | '/app/$tenantSlug/accounting/money/payments/$id'
    | '/app/$tenantSlug/accounting/money/payments/new'
    | '/app/$tenantSlug/accounting/money/receipts/$id'
    | '/app/$tenantSlug/accounting/money/receipts/new'
    | '/app/$tenantSlug/accounting/sales/invoices/$id'
    | '/app/$tenantSlug/accounting/sales/invoices/new'
    | '/app/$tenantSlug/accounting/sales/quotes/$id'
    | '/app/$tenantSlug/accounting/sales/quotes/new'
    | '/app/$tenantSlug/hiring/requisitions/$id/pipeline'
    | '/app/$tenantSlug/hiring/requisitions/$id/report'
    | '/app/$tenantSlug/posh/complaints/$id/manage'
    | '/app/$tenantSlug/posh/training/$moduleId/quiz'
    | '/app/$tenantSlug/timesheet/admin/projects/$id'
    | '/app/$tenantSlug/accounting/money/payments'
    | '/app/$tenantSlug/accounting/money/receipts'
    | '/app/$tenantSlug/accounting/sales/quotes'
    | '/app/$tenantSlug/hiring/requisitions/$id'
    | '/app/$tenantSlug/hr/offboarding/letters'
    | '/app/$tenantSlug/posh/complaints/$id'
    | '/app/$tenantSlug/posh/training/$moduleId'
    | '/app/$tenantSlug/timesheet/admin/projects'
    | '/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authgated'
    | '/_auth/2fa-setup'
    | '/_auth/2fa-verify'
    | '/_auth/change-password'
    | '/_auth/confirm-email'
    | '/_auth/forgot'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset'
    | '/_auth/select-workspace'
    | '/_authgated/superadmin'
    | '/join/$token'
    | '/_authgated/app/$tenantSlug'
    | '/_authgated/superadmin/audit'
    | '/_authgated/superadmin/funnel'
    | '/_authgated/superadmin/plans'
    | '/_authgated/superadmin/users'
    | '/_authgated/superadmin/'
    | '/_authgated/app/$tenantSlug/announcements'
    | '/_authgated/app/$tenantSlug/approval-delegation'
    | '/_authgated/app/$tenantSlug/approvals'
    | '/_authgated/app/$tenantSlug/calendar'
    | '/_authgated/app/$tenantSlug/comp-off'
    | '/_authgated/app/$tenantSlug/compliance'
    | '/_authgated/app/$tenantSlug/directory'
    | '/_authgated/app/$tenantSlug/exit-tasks'
    | '/_authgated/app/$tenantSlug/helpdesk'
    | '/_authgated/app/$tenantSlug/holidays'
    | '/_authgated/app/$tenantSlug/interviews'
    | '/_authgated/app/$tenantSlug/my-time'
    | '/_authgated/app/$tenantSlug/overview'
    | '/_authgated/app/$tenantSlug/referrals'
    | '/_authgated/app/$tenantSlug/skills'
    | '/_authgated/app/$tenantSlug/support-tickets'
    | '/_authgated/app/$tenantSlug/tasks'
    | '/_authgated/superadmin/support/$id'
    | '/_authgated/superadmin/tenants/$id'
    | '/_authgated/app/$tenantSlug/'
    | '/_authgated/superadmin/support/'
    | '/_authgated/superadmin/tenants/'
    | '/_authgated/app/$tenantSlug/accounting/audit'
    | '/_authgated/app/$tenantSlug/accounting/opening-balance'
    | '/_authgated/app/$tenantSlug/accounting/period-locks'
    | '/_authgated/app/$tenantSlug/accounting/post-to-books'
    | '/_authgated/app/$tenantSlug/accounting/returns'
    | '/_authgated/app/$tenantSlug/attendance/approvals'
    | '/_authgated/app/$tenantSlug/attendance/monthly-summary'
    | '/_authgated/app/$tenantSlug/attendance/register'
    | '/_authgated/app/$tenantSlug/attendance/regularize'
    | '/_authgated/app/$tenantSlug/attendance/team'
    | '/_authgated/app/$tenantSlug/bulk-imports/$id'
    | '/_authgated/app/$tenantSlug/bulk-imports/new'
    | '/_authgated/app/$tenantSlug/change-requests/$id'
    | '/_authgated/app/$tenantSlug/change-requests/new'
    | '/_authgated/app/$tenantSlug/expenses/$id'
    | '/_authgated/app/$tenantSlug/expenses/approvals'
    | '/_authgated/app/$tenantSlug/expenses/batches'
    | '/_authgated/app/$tenantSlug/expenses/new'
    | '/_authgated/app/$tenantSlug/helpdesk/new'
    | '/_authgated/app/$tenantSlug/hiring/analytics'
    | '/_authgated/app/$tenantSlug/hiring/costs'
    | '/_authgated/app/$tenantSlug/hiring/interviews'
    | '/_authgated/app/$tenantSlug/hiring/jobs'
    | '/_authgated/app/$tenantSlug/hiring/referrals'
    | '/_authgated/app/$tenantSlug/hiring/reports'
    | '/_authgated/app/$tenantSlug/hr/assets'
    | '/_authgated/app/$tenantSlug/hr/documents'
    | '/_authgated/app/$tenantSlug/leave/$id'
    | '/_authgated/app/$tenantSlug/leave/approvals'
    | '/_authgated/app/$tenantSlug/leave/balances'
    | '/_authgated/app/$tenantSlug/leave/calendar'
    | '/_authgated/app/$tenantSlug/leave/comp-off'
    | '/_authgated/app/$tenantSlug/leave/holidays'
    | '/_authgated/app/$tenantSlug/leave/new'
    | '/_authgated/app/$tenantSlug/loans/$loanId'
    | '/_authgated/app/$tenantSlug/loans/approvals'
    | '/_authgated/app/$tenantSlug/loans/manage'
    | '/_authgated/app/$tenantSlug/loans/new'
    | '/_authgated/app/$tenantSlug/maternity-cases/$id'
    | '/_authgated/app/$tenantSlug/maternity-cases/new'
    | '/_authgated/app/$tenantSlug/me/assets'
    | '/_authgated/app/$tenantSlug/me/documents'
    | '/_authgated/app/$tenantSlug/me/exit'
    | '/_authgated/app/$tenantSlug/me/loans'
    | '/_authgated/app/$tenantSlug/me/pay'
    | '/_authgated/app/$tenantSlug/me/profile'
    | '/_authgated/app/$tenantSlug/me/salary'
    | '/_authgated/app/$tenantSlug/me/security'
    | '/_authgated/app/$tenantSlug/me/surveys'
    | '/_authgated/app/$tenantSlug/me/tax'
    | '/_authgated/app/$tenantSlug/payroll/$id'
    | '/_authgated/app/$tenantSlug/payroll/filings'
    | '/_authgated/app/$tenantSlug/payroll/new'
    | '/_authgated/app/$tenantSlug/payroll/pf-ceiling'
    | '/_authgated/app/$tenantSlug/payroll/statutory'
    | '/_authgated/app/$tenantSlug/payroll/statutory-bonus'
    | '/_authgated/app/$tenantSlug/people/$id'
    | '/_authgated/app/$tenantSlug/people/new'
    | '/_authgated/app/$tenantSlug/people/org-chart'
    | '/_authgated/app/$tenantSlug/people/preboarding'
    | '/_authgated/app/$tenantSlug/performance/feedback'
    | '/_authgated/app/$tenantSlug/posh/about'
    | '/_authgated/app/$tenantSlug/posh/certificates'
    | '/_authgated/app/$tenantSlug/posh/compliance'
    | '/_authgated/app/$tenantSlug/posh/icc'
    | '/_authgated/app/$tenantSlug/reports/analytics'
    | '/_authgated/app/$tenantSlug/reports/headcount'
    | '/_authgated/app/$tenantSlug/reports/payroll-cost'
    | '/_authgated/app/$tenantSlug/reports/salary-register'
    | '/_authgated/app/$tenantSlug/settings/analytics'
    | '/_authgated/app/$tenantSlug/settings/api-tokens'
    | '/_authgated/app/$tenantSlug/settings/asset-types'
    | '/_authgated/app/$tenantSlug/settings/attendance'
    | '/_authgated/app/$tenantSlug/settings/attendance-device-profiles'
    | '/_authgated/app/$tenantSlug/settings/attendance-devices'
    | '/_authgated/app/$tenantSlug/settings/audit-log'
    | '/_authgated/app/$tenantSlug/settings/billing'
    | '/_authgated/app/$tenantSlug/settings/careers-branding'
    | '/_authgated/app/$tenantSlug/settings/coa'
    | '/_authgated/app/$tenantSlug/settings/competencies'
    | '/_authgated/app/$tenantSlug/settings/custom-fields'
    | '/_authgated/app/$tenantSlug/settings/departments'
    | '/_authgated/app/$tenantSlug/settings/entities'
    | '/_authgated/app/$tenantSlug/settings/expense-categories'
    | '/_authgated/app/$tenantSlug/settings/hiring-approvals'
    | '/_authgated/app/$tenantSlug/settings/hiring-emails'
    | '/_authgated/app/$tenantSlug/settings/holidays'
    | '/_authgated/app/$tenantSlug/settings/jd-templates'
    | '/_authgated/app/$tenantSlug/settings/leave-types'
    | '/_authgated/app/$tenantSlug/settings/modules'
    | '/_authgated/app/$tenantSlug/settings/notifications'
    | '/_authgated/app/$tenantSlug/settings/onboarding-templates'
    | '/_authgated/app/$tenantSlug/settings/payment-accounts'
    | '/_authgated/app/$tenantSlug/settings/posting-accounts'
    | '/_authgated/app/$tenantSlug/settings/roles'
    | '/_authgated/app/$tenantSlug/settings/scorecard-templates'
    | '/_authgated/app/$tenantSlug/settings/security'
    | '/_authgated/app/$tenantSlug/settings/shifts'
    | '/_authgated/app/$tenantSlug/settings/skills'
    | '/_authgated/app/$tenantSlug/settings/tally-mappings'
    | '/_authgated/app/$tenantSlug/settings/webhooks'
    | '/_authgated/app/$tenantSlug/settings/workspace'
    | '/_authgated/app/$tenantSlug/shifts/roster'
    | '/_authgated/app/$tenantSlug/shifts/swaps'
    | '/_authgated/app/$tenantSlug/support-tickets/new'
    | '/_authgated/app/$tenantSlug/support-tickets_/$id'
    | '/_authgated/app/$tenantSlug/surveys/new'
    | '/_authgated/app/$tenantSlug/timesheet/inbox'
    | '/_authgated/app/$tenantSlug/travel-preapprovals/$id'
    | '/_authgated/app/$tenantSlug/travel-preapprovals/new'
    | '/_authgated/app/$tenantSlug/wfh/$id'
    | '/_authgated/app/$tenantSlug/wfh/approvals'
    | '/_authgated/app/$tenantSlug/accounting/'
    | '/_authgated/app/$tenantSlug/attendance/'
    | '/_authgated/app/$tenantSlug/bulk-imports/'
    | '/_authgated/app/$tenantSlug/change-requests/'
    | '/_authgated/app/$tenantSlug/expenses/'
    | '/_authgated/app/$tenantSlug/hiring/'
    | '/_authgated/app/$tenantSlug/hr/'
    | '/_authgated/app/$tenantSlug/leave/'
    | '/_authgated/app/$tenantSlug/loans/'
    | '/_authgated/app/$tenantSlug/maternity-cases/'
    | '/_authgated/app/$tenantSlug/payroll/'
    | '/_authgated/app/$tenantSlug/people/'
    | '/_authgated/app/$tenantSlug/performance/'
    | '/_authgated/app/$tenantSlug/posh/'
    | '/_authgated/app/$tenantSlug/reports/'
    | '/_authgated/app/$tenantSlug/settings/'
    | '/_authgated/app/$tenantSlug/shifts/'
    | '/_authgated/app/$tenantSlug/surveys/'
    | '/_authgated/app/$tenantSlug/timesheet/'
    | '/_authgated/app/$tenantSlug/travel-preapprovals/'
    | '/_authgated/app/$tenantSlug/wfh/'
    | '/_authgated/app/$tenantSlug/accounting/accounts/new'
    | '/_authgated/app/$tenantSlug/accounting/contacts/$id'
    | '/_authgated/app/$tenantSlug/accounting/contacts/new'
    | '/_authgated/app/$tenantSlug/accounting/items/$id'
    | '/_authgated/app/$tenantSlug/accounting/items/new'
    | '/_authgated/app/$tenantSlug/accounting/journals/$id'
    | '/_authgated/app/$tenantSlug/accounting/journals/new'
    | '/_authgated/app/$tenantSlug/accounting/ledger/$accountId'
    | '/_authgated/app/$tenantSlug/accounting/payroll-runs/$id'
    | '/_authgated/app/$tenantSlug/accounting/purchases/$id'
    | '/_authgated/app/$tenantSlug/accounting/purchases/new'
    | '/_authgated/app/$tenantSlug/accounting/reports/balance-sheet'
    | '/_authgated/app/$tenantSlug/accounting/reports/msme-overdue'
    | '/_authgated/app/$tenantSlug/accounting/reports/profit-and-loss'
    | '/_authgated/app/$tenantSlug/accounting/reports/tds-receivable'
    | '/_authgated/app/$tenantSlug/accounting/reports/trial-balance'
    | '/_authgated/app/$tenantSlug/attendance/import/runs'
    | '/_authgated/app/$tenantSlug/helpdesk_/tickets/$id'
    | '/_authgated/app/$tenantSlug/hiring/candidates/$id'
    | '/_authgated/app/$tenantSlug/hiring/requisitions/new'
    | '/_authgated/app/$tenantSlug/hr/offboarding/$id'
    | '/_authgated/app/$tenantSlug/hr/offboarding/new'
    | '/_authgated/app/$tenantSlug/hr/onboarding/$id'
    | '/_authgated/app/$tenantSlug/me/account/notifications'
    | '/_authgated/app/$tenantSlug/me/account/security'
    | '/_authgated/app/$tenantSlug/me/details/$itemId'
    | '/_authgated/app/$tenantSlug/me/letters/$id'
    | '/_authgated/app/$tenantSlug/me/surveys/$id'
    | '/_authgated/app/$tenantSlug/payroll/filings/$id'
    | '/_authgated/app/$tenantSlug/payroll/tax-declaration/$declId'
    | '/_authgated/app/$tenantSlug/payroll/tax-declaration/queue'
    | '/_authgated/app/$tenantSlug/people/$id/edit'
    | '/_authgated/app/$tenantSlug/performance/cycles/$id'
    | '/_authgated/app/$tenantSlug/performance/cycles/new'
    | '/_authgated/app/$tenantSlug/performance/goals/$id'
    | '/_authgated/app/$tenantSlug/performance/goals/new'
    | '/_authgated/app/$tenantSlug/performance/my-results/$cycleId'
    | '/_authgated/app/$tenantSlug/performance/one-on-ones/$id'
    | '/_authgated/app/$tenantSlug/performance/one-on-ones/new'
    | '/_authgated/app/$tenantSlug/performance/reviews/$id'
    | '/_authgated/app/$tenantSlug/performance/reviews/new'
    | '/_authgated/app/$tenantSlug/posh/complaints/new'
    | '/_authgated/app/$tenantSlug/posh/policy/$id'
    | '/_authgated/app/$tenantSlug/posh/reports/$id'
    | '/_authgated/app/$tenantSlug/settings/checklists/offboarding'
    | '/_authgated/app/$tenantSlug/settings/checklists/onboarding'
    | '/_authgated/app/$tenantSlug/settings/checklists/preboarding'
    | '/_authgated/app/$tenantSlug/settings/tax-codes/new'
    | '/_authgated/app/$tenantSlug/surveys/$id/results'
    | '/_authgated/app/$tenantSlug/timesheet/weeks/$weekStart'
    | '/_authgated/app/$tenantSlug/accounting/accounts/'
    | '/_authgated/app/$tenantSlug/accounting/contacts/'
    | '/_authgated/app/$tenantSlug/accounting/items/'
    | '/_authgated/app/$tenantSlug/accounting/journals/'
    | '/_authgated/app/$tenantSlug/accounting/money/'
    | '/_authgated/app/$tenantSlug/accounting/purchases/'
    | '/_authgated/app/$tenantSlug/accounting/reports/'
    | '/_authgated/app/$tenantSlug/accounting/sales/'
    | '/_authgated/app/$tenantSlug/attendance/import/'
    | '/_authgated/app/$tenantSlug/hiring/candidates/'
    | '/_authgated/app/$tenantSlug/hiring/requisitions/'
    | '/_authgated/app/$tenantSlug/hr/offboarding/'
    | '/_authgated/app/$tenantSlug/hr/onboarding/'
    | '/_authgated/app/$tenantSlug/me/account/'
    | '/_authgated/app/$tenantSlug/me/details/'
    | '/_authgated/app/$tenantSlug/me/letters/'
    | '/_authgated/app/$tenantSlug/payroll/tax-declaration/'
    | '/_authgated/app/$tenantSlug/performance/cycles/'
    | '/_authgated/app/$tenantSlug/performance/goals/'
    | '/_authgated/app/$tenantSlug/performance/my-results/'
    | '/_authgated/app/$tenantSlug/performance/one-on-ones/'
    | '/_authgated/app/$tenantSlug/performance/reviews/'
    | '/_authgated/app/$tenantSlug/posh/complaints/'
    | '/_authgated/app/$tenantSlug/posh/policy/'
    | '/_authgated/app/$tenantSlug/posh/reports/'
    | '/_authgated/app/$tenantSlug/posh/training/'
    | '/_authgated/app/$tenantSlug/settings/checklists/'
    | '/_authgated/app/$tenantSlug/settings/tax-codes/'
    | '/_authgated/app/$tenantSlug/surveys/$id/'
    | '/_authgated/app/$tenantSlug/accounting/money/payments/$id'
    | '/_authgated/app/$tenantSlug/accounting/money/payments/new'
    | '/_authgated/app/$tenantSlug/accounting/money/receipts/$id'
    | '/_authgated/app/$tenantSlug/accounting/money/receipts/new'
    | '/_authgated/app/$tenantSlug/accounting/sales/invoices/$id'
    | '/_authgated/app/$tenantSlug/accounting/sales/invoices/new'
    | '/_authgated/app/$tenantSlug/accounting/sales/quotes/$id'
    | '/_authgated/app/$tenantSlug/accounting/sales/quotes/new'
    | '/_authgated/app/$tenantSlug/hiring/requisitions/$id/pipeline'
    | '/_authgated/app/$tenantSlug/hiring/requisitions/$id/report'
    | '/_authgated/app/$tenantSlug/posh/complaints/$id/manage'
    | '/_authgated/app/$tenantSlug/posh/training/$moduleId/quiz'
    | '/_authgated/app/$tenantSlug/timesheet/admin/projects/$id'
    | '/_authgated/app/$tenantSlug/accounting/money/payments/'
    | '/_authgated/app/$tenantSlug/accounting/money/receipts/'
    | '/_authgated/app/$tenantSlug/accounting/sales/quotes/'
    | '/_authgated/app/$tenantSlug/hiring/requisitions/$id/'
    | '/_authgated/app/$tenantSlug/hr/offboarding/letters/'
    | '/_authgated/app/$tenantSlug/posh/complaints/$id/'
    | '/_authgated/app/$tenantSlug/posh/training/$moduleId/'
    | '/_authgated/app/$tenantSlug/timesheet/admin/projects/'
    | '/_authgated/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthgatedRoute: typeof AuthgatedRouteWithChildren
  JoinTokenRoute: typeof JoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authgated': {
      id: '/_authgated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthgatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authgated/superadmin': {
      id: '/_authgated/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof AuthgatedSuperadminRouteImport
      parentRoute: typeof AuthgatedRoute
    }
    '/_auth/select-workspace': {
      id: '/_auth/select-workspace'
      path: '/select-workspace'
      fullPath: '/select-workspace'
      preLoaderRoute: typeof AuthSelectWorkspaceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset': {
      id: '/_auth/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot': {
      id: '/_auth/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/confirm-email': {
      id: '/_auth/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof AuthConfirmEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/2fa-verify': {
      id: '/_auth/2fa-verify'
      path: '/2fa-verify'
      fullPath: '/2fa-verify'
      preLoaderRoute: typeof Auth2faVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/2fa-setup': {
      id: '/_auth/2fa-setup'
      path: '/2fa-setup'
      fullPath: '/2fa-setup'
      preLoaderRoute: typeof Auth2faSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authgated/superadmin/': {
      id: '/_authgated/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof AuthgatedSuperadminIndexRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/users': {
      id: '/_authgated/superadmin/users'
      path: '/users'
      fullPath: '/superadmin/users'
      preLoaderRoute: typeof AuthgatedSuperadminUsersRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/plans': {
      id: '/_authgated/superadmin/plans'
      path: '/plans'
      fullPath: '/superadmin/plans'
      preLoaderRoute: typeof AuthgatedSuperadminPlansRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/funnel': {
      id: '/_authgated/superadmin/funnel'
      path: '/funnel'
      fullPath: '/superadmin/funnel'
      preLoaderRoute: typeof AuthgatedSuperadminFunnelRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/audit': {
      id: '/_authgated/superadmin/audit'
      path: '/audit'
      fullPath: '/superadmin/audit'
      preLoaderRoute: typeof AuthgatedSuperadminAuditRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/app/$tenantSlug': {
      id: '/_authgated/app/$tenantSlug'
      path: '/app/$tenantSlug'
      fullPath: '/app/$tenantSlug'
      preLoaderRoute: typeof AuthgatedAppTenantSlugRouteImport
      parentRoute: typeof AuthgatedRoute
    }
    '/_authgated/superadmin/tenants/': {
      id: '/_authgated/superadmin/tenants/'
      path: '/tenants'
      fullPath: '/superadmin/tenants/'
      preLoaderRoute: typeof AuthgatedSuperadminTenantsIndexRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/support/': {
      id: '/_authgated/superadmin/support/'
      path: '/support'
      fullPath: '/superadmin/support/'
      preLoaderRoute: typeof AuthgatedSuperadminSupportIndexRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/app/$tenantSlug/': {
      id: '/_authgated/app/$tenantSlug/'
      path: '/'
      fullPath: '/app/$tenantSlug/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/superadmin/tenants/$id': {
      id: '/_authgated/superadmin/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/superadmin/tenants/$id'
      preLoaderRoute: typeof AuthgatedSuperadminTenantsIdRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/superadmin/support/$id': {
      id: '/_authgated/superadmin/support/$id'
      path: '/support/$id'
      fullPath: '/superadmin/support/$id'
      preLoaderRoute: typeof AuthgatedSuperadminSupportIdRouteImport
      parentRoute: typeof AuthgatedSuperadminRoute
    }
    '/_authgated/app/$tenantSlug/tasks': {
      id: '/_authgated/app/$tenantSlug/tasks'
      path: '/tasks'
      fullPath: '/app/$tenantSlug/tasks'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTasksRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/support-tickets': {
      id: '/_authgated/app/$tenantSlug/support-tickets'
      path: '/support-tickets'
      fullPath: '/app/$tenantSlug/support-tickets'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSupportTicketsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/skills': {
      id: '/_authgated/app/$tenantSlug/skills'
      path: '/skills'
      fullPath: '/app/$tenantSlug/skills'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSkillsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/referrals': {
      id: '/_authgated/app/$tenantSlug/referrals'
      path: '/referrals'
      fullPath: '/app/$tenantSlug/referrals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReferralsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/overview': {
      id: '/_authgated/app/$tenantSlug/overview'
      path: '/overview'
      fullPath: '/app/$tenantSlug/overview'
      preLoaderRoute: typeof AuthgatedAppTenantSlugOverviewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/my-time': {
      id: '/_authgated/app/$tenantSlug/my-time'
      path: '/my-time'
      fullPath: '/app/$tenantSlug/my-time'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMyTimeRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/interviews': {
      id: '/_authgated/app/$tenantSlug/interviews'
      path: '/interviews'
      fullPath: '/app/$tenantSlug/interviews'
      preLoaderRoute: typeof AuthgatedAppTenantSlugInterviewsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/holidays': {
      id: '/_authgated/app/$tenantSlug/holidays'
      path: '/holidays'
      fullPath: '/app/$tenantSlug/holidays'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHolidaysRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/helpdesk': {
      id: '/_authgated/app/$tenantSlug/helpdesk'
      path: '/helpdesk'
      fullPath: '/app/$tenantSlug/helpdesk'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHelpdeskRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/exit-tasks': {
      id: '/_authgated/app/$tenantSlug/exit-tasks'
      path: '/exit-tasks'
      fullPath: '/app/$tenantSlug/exit-tasks'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExitTasksRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/directory': {
      id: '/_authgated/app/$tenantSlug/directory'
      path: '/directory'
      fullPath: '/app/$tenantSlug/directory'
      preLoaderRoute: typeof AuthgatedAppTenantSlugDirectoryRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/compliance': {
      id: '/_authgated/app/$tenantSlug/compliance'
      path: '/compliance'
      fullPath: '/app/$tenantSlug/compliance'
      preLoaderRoute: typeof AuthgatedAppTenantSlugComplianceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/comp-off': {
      id: '/_authgated/app/$tenantSlug/comp-off'
      path: '/comp-off'
      fullPath: '/app/$tenantSlug/comp-off'
      preLoaderRoute: typeof AuthgatedAppTenantSlugCompOffRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/calendar': {
      id: '/_authgated/app/$tenantSlug/calendar'
      path: '/calendar'
      fullPath: '/app/$tenantSlug/calendar'
      preLoaderRoute: typeof AuthgatedAppTenantSlugCalendarRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/approvals': {
      id: '/_authgated/app/$tenantSlug/approvals'
      path: '/approvals'
      fullPath: '/app/$tenantSlug/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/approval-delegation': {
      id: '/_authgated/app/$tenantSlug/approval-delegation'
      path: '/approval-delegation'
      fullPath: '/app/$tenantSlug/approval-delegation'
      preLoaderRoute: typeof AuthgatedAppTenantSlugApprovalDelegationRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/announcements': {
      id: '/_authgated/app/$tenantSlug/announcements'
      path: '/announcements'
      fullPath: '/app/$tenantSlug/announcements'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAnnouncementsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/wfh/': {
      id: '/_authgated/app/$tenantSlug/wfh/'
      path: '/wfh'
      fullPath: '/app/$tenantSlug/wfh/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugWfhIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/travel-preapprovals/': {
      id: '/_authgated/app/$tenantSlug/travel-preapprovals/'
      path: '/travel-preapprovals'
      fullPath: '/app/$tenantSlug/travel-preapprovals/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/timesheet/': {
      id: '/_authgated/app/$tenantSlug/timesheet/'
      path: '/timesheet'
      fullPath: '/app/$tenantSlug/timesheet/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTimesheetIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/surveys/': {
      id: '/_authgated/app/$tenantSlug/surveys/'
      path: '/surveys'
      fullPath: '/app/$tenantSlug/surveys/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSurveysIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/shifts/': {
      id: '/_authgated/app/$tenantSlug/shifts/'
      path: '/shifts'
      fullPath: '/app/$tenantSlug/shifts/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugShiftsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/': {
      id: '/_authgated/app/$tenantSlug/settings/'
      path: '/settings'
      fullPath: '/app/$tenantSlug/settings/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/reports/': {
      id: '/_authgated/app/$tenantSlug/reports/'
      path: '/reports'
      fullPath: '/app/$tenantSlug/reports/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReportsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/': {
      id: '/_authgated/app/$tenantSlug/posh/'
      path: '/posh'
      fullPath: '/app/$tenantSlug/posh/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/': {
      id: '/_authgated/app/$tenantSlug/performance/'
      path: '/performance'
      fullPath: '/app/$tenantSlug/performance/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/': {
      id: '/_authgated/app/$tenantSlug/people/'
      path: '/people'
      fullPath: '/app/$tenantSlug/people/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeopleIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/': {
      id: '/_authgated/app/$tenantSlug/payroll/'
      path: '/payroll'
      fullPath: '/app/$tenantSlug/payroll/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/maternity-cases/': {
      id: '/_authgated/app/$tenantSlug/maternity-cases/'
      path: '/maternity-cases'
      fullPath: '/app/$tenantSlug/maternity-cases/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMaternityCasesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/loans/': {
      id: '/_authgated/app/$tenantSlug/loans/'
      path: '/loans'
      fullPath: '/app/$tenantSlug/loans/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLoansIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/': {
      id: '/_authgated/app/$tenantSlug/leave/'
      path: '/leave'
      fullPath: '/app/$tenantSlug/leave/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/': {
      id: '/_authgated/app/$tenantSlug/hr/'
      path: '/hr'
      fullPath: '/app/$tenantSlug/hr/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/': {
      id: '/_authgated/app/$tenantSlug/hiring/'
      path: '/hiring'
      fullPath: '/app/$tenantSlug/hiring/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/expenses/': {
      id: '/_authgated/app/$tenantSlug/expenses/'
      path: '/expenses'
      fullPath: '/app/$tenantSlug/expenses/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExpensesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/change-requests/': {
      id: '/_authgated/app/$tenantSlug/change-requests/'
      path: '/change-requests'
      fullPath: '/app/$tenantSlug/change-requests/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugChangeRequestsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/bulk-imports/': {
      id: '/_authgated/app/$tenantSlug/bulk-imports/'
      path: '/bulk-imports'
      fullPath: '/app/$tenantSlug/bulk-imports/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugBulkImportsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/': {
      id: '/_authgated/app/$tenantSlug/attendance/'
      path: '/attendance'
      fullPath: '/app/$tenantSlug/attendance/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/': {
      id: '/_authgated/app/$tenantSlug/accounting/'
      path: '/accounting'
      fullPath: '/app/$tenantSlug/accounting/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/wfh/approvals': {
      id: '/_authgated/app/$tenantSlug/wfh/approvals'
      path: '/wfh/approvals'
      fullPath: '/app/$tenantSlug/wfh/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugWfhApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/wfh/$id': {
      id: '/_authgated/app/$tenantSlug/wfh/$id'
      path: '/wfh/$id'
      fullPath: '/app/$tenantSlug/wfh/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugWfhIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/travel-preapprovals/new': {
      id: '/_authgated/app/$tenantSlug/travel-preapprovals/new'
      path: '/travel-preapprovals/new'
      fullPath: '/app/$tenantSlug/travel-preapprovals/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/travel-preapprovals/$id': {
      id: '/_authgated/app/$tenantSlug/travel-preapprovals/$id'
      path: '/travel-preapprovals/$id'
      fullPath: '/app/$tenantSlug/travel-preapprovals/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/timesheet/inbox': {
      id: '/_authgated/app/$tenantSlug/timesheet/inbox'
      path: '/timesheet/inbox'
      fullPath: '/app/$tenantSlug/timesheet/inbox'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTimesheetInboxRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/surveys/new': {
      id: '/_authgated/app/$tenantSlug/surveys/new'
      path: '/surveys/new'
      fullPath: '/app/$tenantSlug/surveys/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSurveysNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/support-tickets_/$id': {
      id: '/_authgated/app/$tenantSlug/support-tickets_/$id'
      path: '/support-tickets/$id'
      fullPath: '/app/$tenantSlug/support-tickets/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSupportTicketsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/support-tickets/new': {
      id: '/_authgated/app/$tenantSlug/support-tickets/new'
      path: '/new'
      fullPath: '/app/$tenantSlug/support-tickets/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSupportTicketsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugSupportTicketsRoute
    }
    '/_authgated/app/$tenantSlug/shifts/swaps': {
      id: '/_authgated/app/$tenantSlug/shifts/swaps'
      path: '/shifts/swaps'
      fullPath: '/app/$tenantSlug/shifts/swaps'
      preLoaderRoute: typeof AuthgatedAppTenantSlugShiftsSwapsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/shifts/roster': {
      id: '/_authgated/app/$tenantSlug/shifts/roster'
      path: '/shifts/roster'
      fullPath: '/app/$tenantSlug/shifts/roster'
      preLoaderRoute: typeof AuthgatedAppTenantSlugShiftsRosterRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/workspace': {
      id: '/_authgated/app/$tenantSlug/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/app/$tenantSlug/settings/workspace'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsWorkspaceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/webhooks': {
      id: '/_authgated/app/$tenantSlug/settings/webhooks'
      path: '/settings/webhooks'
      fullPath: '/app/$tenantSlug/settings/webhooks'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsWebhooksRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/tally-mappings': {
      id: '/_authgated/app/$tenantSlug/settings/tally-mappings'
      path: '/settings/tally-mappings'
      fullPath: '/app/$tenantSlug/settings/tally-mappings'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsTallyMappingsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/skills': {
      id: '/_authgated/app/$tenantSlug/settings/skills'
      path: '/settings/skills'
      fullPath: '/app/$tenantSlug/settings/skills'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsSkillsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/shifts': {
      id: '/_authgated/app/$tenantSlug/settings/shifts'
      path: '/settings/shifts'
      fullPath: '/app/$tenantSlug/settings/shifts'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsShiftsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/security': {
      id: '/_authgated/app/$tenantSlug/settings/security'
      path: '/settings/security'
      fullPath: '/app/$tenantSlug/settings/security'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsSecurityRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/scorecard-templates': {
      id: '/_authgated/app/$tenantSlug/settings/scorecard-templates'
      path: '/settings/scorecard-templates'
      fullPath: '/app/$tenantSlug/settings/scorecard-templates'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsScorecardTemplatesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/roles': {
      id: '/_authgated/app/$tenantSlug/settings/roles'
      path: '/settings/roles'
      fullPath: '/app/$tenantSlug/settings/roles'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsRolesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/posting-accounts': {
      id: '/_authgated/app/$tenantSlug/settings/posting-accounts'
      path: '/settings/posting-accounts'
      fullPath: '/app/$tenantSlug/settings/posting-accounts'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsPostingAccountsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/payment-accounts': {
      id: '/_authgated/app/$tenantSlug/settings/payment-accounts'
      path: '/settings/payment-accounts'
      fullPath: '/app/$tenantSlug/settings/payment-accounts'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsPaymentAccountsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/onboarding-templates': {
      id: '/_authgated/app/$tenantSlug/settings/onboarding-templates'
      path: '/settings/onboarding-templates'
      fullPath: '/app/$tenantSlug/settings/onboarding-templates'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsOnboardingTemplatesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/notifications': {
      id: '/_authgated/app/$tenantSlug/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/app/$tenantSlug/settings/notifications'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsNotificationsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/modules': {
      id: '/_authgated/app/$tenantSlug/settings/modules'
      path: '/settings/modules'
      fullPath: '/app/$tenantSlug/settings/modules'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsModulesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/leave-types': {
      id: '/_authgated/app/$tenantSlug/settings/leave-types'
      path: '/settings/leave-types'
      fullPath: '/app/$tenantSlug/settings/leave-types'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsLeaveTypesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/jd-templates': {
      id: '/_authgated/app/$tenantSlug/settings/jd-templates'
      path: '/settings/jd-templates'
      fullPath: '/app/$tenantSlug/settings/jd-templates'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsJdTemplatesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/holidays': {
      id: '/_authgated/app/$tenantSlug/settings/holidays'
      path: '/settings/holidays'
      fullPath: '/app/$tenantSlug/settings/holidays'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsHolidaysRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/hiring-emails': {
      id: '/_authgated/app/$tenantSlug/settings/hiring-emails'
      path: '/settings/hiring-emails'
      fullPath: '/app/$tenantSlug/settings/hiring-emails'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsHiringEmailsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/hiring-approvals': {
      id: '/_authgated/app/$tenantSlug/settings/hiring-approvals'
      path: '/settings/hiring-approvals'
      fullPath: '/app/$tenantSlug/settings/hiring-approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsHiringApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/expense-categories': {
      id: '/_authgated/app/$tenantSlug/settings/expense-categories'
      path: '/settings/expense-categories'
      fullPath: '/app/$tenantSlug/settings/expense-categories'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsExpenseCategoriesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/entities': {
      id: '/_authgated/app/$tenantSlug/settings/entities'
      path: '/settings/entities'
      fullPath: '/app/$tenantSlug/settings/entities'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsEntitiesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/departments': {
      id: '/_authgated/app/$tenantSlug/settings/departments'
      path: '/settings/departments'
      fullPath: '/app/$tenantSlug/settings/departments'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsDepartmentsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/custom-fields': {
      id: '/_authgated/app/$tenantSlug/settings/custom-fields'
      path: '/settings/custom-fields'
      fullPath: '/app/$tenantSlug/settings/custom-fields'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsCustomFieldsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/competencies': {
      id: '/_authgated/app/$tenantSlug/settings/competencies'
      path: '/settings/competencies'
      fullPath: '/app/$tenantSlug/settings/competencies'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsCompetenciesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/coa': {
      id: '/_authgated/app/$tenantSlug/settings/coa'
      path: '/settings/coa'
      fullPath: '/app/$tenantSlug/settings/coa'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsCoaRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/careers-branding': {
      id: '/_authgated/app/$tenantSlug/settings/careers-branding'
      path: '/settings/careers-branding'
      fullPath: '/app/$tenantSlug/settings/careers-branding'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsCareersBrandingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/billing': {
      id: '/_authgated/app/$tenantSlug/settings/billing'
      path: '/settings/billing'
      fullPath: '/app/$tenantSlug/settings/billing'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsBillingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/audit-log': {
      id: '/_authgated/app/$tenantSlug/settings/audit-log'
      path: '/settings/audit-log'
      fullPath: '/app/$tenantSlug/settings/audit-log'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAuditLogRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/attendance-devices': {
      id: '/_authgated/app/$tenantSlug/settings/attendance-devices'
      path: '/settings/attendance-devices'
      fullPath: '/app/$tenantSlug/settings/attendance-devices'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceDevicesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/attendance-device-profiles': {
      id: '/_authgated/app/$tenantSlug/settings/attendance-device-profiles'
      path: '/settings/attendance-device-profiles'
      fullPath: '/app/$tenantSlug/settings/attendance-device-profiles'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/attendance': {
      id: '/_authgated/app/$tenantSlug/settings/attendance'
      path: '/settings/attendance'
      fullPath: '/app/$tenantSlug/settings/attendance'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/asset-types': {
      id: '/_authgated/app/$tenantSlug/settings/asset-types'
      path: '/settings/asset-types'
      fullPath: '/app/$tenantSlug/settings/asset-types'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAssetTypesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/api-tokens': {
      id: '/_authgated/app/$tenantSlug/settings/api-tokens'
      path: '/settings/api-tokens'
      fullPath: '/app/$tenantSlug/settings/api-tokens'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsApiTokensRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/analytics': {
      id: '/_authgated/app/$tenantSlug/settings/analytics'
      path: '/settings/analytics'
      fullPath: '/app/$tenantSlug/settings/analytics'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsAnalyticsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/reports/salary-register': {
      id: '/_authgated/app/$tenantSlug/reports/salary-register'
      path: '/reports/salary-register'
      fullPath: '/app/$tenantSlug/reports/salary-register'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReportsSalaryRegisterRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/reports/payroll-cost': {
      id: '/_authgated/app/$tenantSlug/reports/payroll-cost'
      path: '/reports/payroll-cost'
      fullPath: '/app/$tenantSlug/reports/payroll-cost'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReportsPayrollCostRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/reports/headcount': {
      id: '/_authgated/app/$tenantSlug/reports/headcount'
      path: '/reports/headcount'
      fullPath: '/app/$tenantSlug/reports/headcount'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReportsHeadcountRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/reports/analytics': {
      id: '/_authgated/app/$tenantSlug/reports/analytics'
      path: '/reports/analytics'
      fullPath: '/app/$tenantSlug/reports/analytics'
      preLoaderRoute: typeof AuthgatedAppTenantSlugReportsAnalyticsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/icc': {
      id: '/_authgated/app/$tenantSlug/posh/icc'
      path: '/posh/icc'
      fullPath: '/app/$tenantSlug/posh/icc'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshIccRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/compliance': {
      id: '/_authgated/app/$tenantSlug/posh/compliance'
      path: '/posh/compliance'
      fullPath: '/app/$tenantSlug/posh/compliance'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshComplianceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/certificates': {
      id: '/_authgated/app/$tenantSlug/posh/certificates'
      path: '/posh/certificates'
      fullPath: '/app/$tenantSlug/posh/certificates'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshCertificatesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/about': {
      id: '/_authgated/app/$tenantSlug/posh/about'
      path: '/posh/about'
      fullPath: '/app/$tenantSlug/posh/about'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshAboutRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/feedback': {
      id: '/_authgated/app/$tenantSlug/performance/feedback'
      path: '/performance/feedback'
      fullPath: '/app/$tenantSlug/performance/feedback'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceFeedbackRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/preboarding': {
      id: '/_authgated/app/$tenantSlug/people/preboarding'
      path: '/people/preboarding'
      fullPath: '/app/$tenantSlug/people/preboarding'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeoplePreboardingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/org-chart': {
      id: '/_authgated/app/$tenantSlug/people/org-chart'
      path: '/people/org-chart'
      fullPath: '/app/$tenantSlug/people/org-chart'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeopleOrgChartRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/new': {
      id: '/_authgated/app/$tenantSlug/people/new'
      path: '/people/new'
      fullPath: '/app/$tenantSlug/people/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeopleNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/$id': {
      id: '/_authgated/app/$tenantSlug/people/$id'
      path: '/people/$id'
      fullPath: '/app/$tenantSlug/people/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeopleIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/statutory-bonus': {
      id: '/_authgated/app/$tenantSlug/payroll/statutory-bonus'
      path: '/payroll/statutory-bonus'
      fullPath: '/app/$tenantSlug/payroll/statutory-bonus'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollStatutoryBonusRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/statutory': {
      id: '/_authgated/app/$tenantSlug/payroll/statutory'
      path: '/payroll/statutory'
      fullPath: '/app/$tenantSlug/payroll/statutory'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollStatutoryRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/pf-ceiling': {
      id: '/_authgated/app/$tenantSlug/payroll/pf-ceiling'
      path: '/payroll/pf-ceiling'
      fullPath: '/app/$tenantSlug/payroll/pf-ceiling'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollPfCeilingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/new': {
      id: '/_authgated/app/$tenantSlug/payroll/new'
      path: '/payroll/new'
      fullPath: '/app/$tenantSlug/payroll/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/filings': {
      id: '/_authgated/app/$tenantSlug/payroll/filings'
      path: '/payroll/filings'
      fullPath: '/app/$tenantSlug/payroll/filings'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollFilingsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/$id': {
      id: '/_authgated/app/$tenantSlug/payroll/$id'
      path: '/payroll/$id'
      fullPath: '/app/$tenantSlug/payroll/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/tax': {
      id: '/_authgated/app/$tenantSlug/me/tax'
      path: '/me/tax'
      fullPath: '/app/$tenantSlug/me/tax'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeTaxRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/surveys': {
      id: '/_authgated/app/$tenantSlug/me/surveys'
      path: '/me/surveys'
      fullPath: '/app/$tenantSlug/me/surveys'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeSurveysRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/security': {
      id: '/_authgated/app/$tenantSlug/me/security'
      path: '/me/security'
      fullPath: '/app/$tenantSlug/me/security'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeSecurityRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/salary': {
      id: '/_authgated/app/$tenantSlug/me/salary'
      path: '/me/salary'
      fullPath: '/app/$tenantSlug/me/salary'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeSalaryRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/profile': {
      id: '/_authgated/app/$tenantSlug/me/profile'
      path: '/me/profile'
      fullPath: '/app/$tenantSlug/me/profile'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeProfileRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/pay': {
      id: '/_authgated/app/$tenantSlug/me/pay'
      path: '/me/pay'
      fullPath: '/app/$tenantSlug/me/pay'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMePayRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/loans': {
      id: '/_authgated/app/$tenantSlug/me/loans'
      path: '/me/loans'
      fullPath: '/app/$tenantSlug/me/loans'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeLoansRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/exit': {
      id: '/_authgated/app/$tenantSlug/me/exit'
      path: '/me/exit'
      fullPath: '/app/$tenantSlug/me/exit'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeExitRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/documents': {
      id: '/_authgated/app/$tenantSlug/me/documents'
      path: '/me/documents'
      fullPath: '/app/$tenantSlug/me/documents'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeDocumentsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/assets': {
      id: '/_authgated/app/$tenantSlug/me/assets'
      path: '/me/assets'
      fullPath: '/app/$tenantSlug/me/assets'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeAssetsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/maternity-cases/new': {
      id: '/_authgated/app/$tenantSlug/maternity-cases/new'
      path: '/maternity-cases/new'
      fullPath: '/app/$tenantSlug/maternity-cases/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMaternityCasesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/maternity-cases/$id': {
      id: '/_authgated/app/$tenantSlug/maternity-cases/$id'
      path: '/maternity-cases/$id'
      fullPath: '/app/$tenantSlug/maternity-cases/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMaternityCasesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/loans/new': {
      id: '/_authgated/app/$tenantSlug/loans/new'
      path: '/loans/new'
      fullPath: '/app/$tenantSlug/loans/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLoansNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/loans/manage': {
      id: '/_authgated/app/$tenantSlug/loans/manage'
      path: '/loans/manage'
      fullPath: '/app/$tenantSlug/loans/manage'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLoansManageRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/loans/approvals': {
      id: '/_authgated/app/$tenantSlug/loans/approvals'
      path: '/loans/approvals'
      fullPath: '/app/$tenantSlug/loans/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLoansApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/loans/$loanId': {
      id: '/_authgated/app/$tenantSlug/loans/$loanId'
      path: '/loans/$loanId'
      fullPath: '/app/$tenantSlug/loans/$loanId'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLoansLoanIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/new': {
      id: '/_authgated/app/$tenantSlug/leave/new'
      path: '/leave/new'
      fullPath: '/app/$tenantSlug/leave/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/holidays': {
      id: '/_authgated/app/$tenantSlug/leave/holidays'
      path: '/leave/holidays'
      fullPath: '/app/$tenantSlug/leave/holidays'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveHolidaysRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/comp-off': {
      id: '/_authgated/app/$tenantSlug/leave/comp-off'
      path: '/leave/comp-off'
      fullPath: '/app/$tenantSlug/leave/comp-off'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveCompOffRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/calendar': {
      id: '/_authgated/app/$tenantSlug/leave/calendar'
      path: '/leave/calendar'
      fullPath: '/app/$tenantSlug/leave/calendar'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveCalendarRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/balances': {
      id: '/_authgated/app/$tenantSlug/leave/balances'
      path: '/leave/balances'
      fullPath: '/app/$tenantSlug/leave/balances'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveBalancesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/approvals': {
      id: '/_authgated/app/$tenantSlug/leave/approvals'
      path: '/leave/approvals'
      fullPath: '/app/$tenantSlug/leave/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/leave/$id': {
      id: '/_authgated/app/$tenantSlug/leave/$id'
      path: '/leave/$id'
      fullPath: '/app/$tenantSlug/leave/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugLeaveIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/documents': {
      id: '/_authgated/app/$tenantSlug/hr/documents'
      path: '/hr/documents'
      fullPath: '/app/$tenantSlug/hr/documents'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrDocumentsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/assets': {
      id: '/_authgated/app/$tenantSlug/hr/assets'
      path: '/hr/assets'
      fullPath: '/app/$tenantSlug/hr/assets'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrAssetsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/reports': {
      id: '/_authgated/app/$tenantSlug/hiring/reports'
      path: '/hiring/reports'
      fullPath: '/app/$tenantSlug/hiring/reports'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringReportsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/referrals': {
      id: '/_authgated/app/$tenantSlug/hiring/referrals'
      path: '/hiring/referrals'
      fullPath: '/app/$tenantSlug/hiring/referrals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringReferralsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/jobs': {
      id: '/_authgated/app/$tenantSlug/hiring/jobs'
      path: '/hiring/jobs'
      fullPath: '/app/$tenantSlug/hiring/jobs'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringJobsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/interviews': {
      id: '/_authgated/app/$tenantSlug/hiring/interviews'
      path: '/hiring/interviews'
      fullPath: '/app/$tenantSlug/hiring/interviews'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringInterviewsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/costs': {
      id: '/_authgated/app/$tenantSlug/hiring/costs'
      path: '/hiring/costs'
      fullPath: '/app/$tenantSlug/hiring/costs'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringCostsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/analytics': {
      id: '/_authgated/app/$tenantSlug/hiring/analytics'
      path: '/hiring/analytics'
      fullPath: '/app/$tenantSlug/hiring/analytics'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringAnalyticsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/helpdesk/new': {
      id: '/_authgated/app/$tenantSlug/helpdesk/new'
      path: '/new'
      fullPath: '/app/$tenantSlug/helpdesk/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHelpdeskNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugHelpdeskRoute
    }
    '/_authgated/app/$tenantSlug/expenses/new': {
      id: '/_authgated/app/$tenantSlug/expenses/new'
      path: '/expenses/new'
      fullPath: '/app/$tenantSlug/expenses/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExpensesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/expenses/batches': {
      id: '/_authgated/app/$tenantSlug/expenses/batches'
      path: '/expenses/batches'
      fullPath: '/app/$tenantSlug/expenses/batches'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExpensesBatchesRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/expenses/approvals': {
      id: '/_authgated/app/$tenantSlug/expenses/approvals'
      path: '/expenses/approvals'
      fullPath: '/app/$tenantSlug/expenses/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExpensesApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/expenses/$id': {
      id: '/_authgated/app/$tenantSlug/expenses/$id'
      path: '/expenses/$id'
      fullPath: '/app/$tenantSlug/expenses/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugExpensesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/change-requests/new': {
      id: '/_authgated/app/$tenantSlug/change-requests/new'
      path: '/change-requests/new'
      fullPath: '/app/$tenantSlug/change-requests/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugChangeRequestsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/change-requests/$id': {
      id: '/_authgated/app/$tenantSlug/change-requests/$id'
      path: '/change-requests/$id'
      fullPath: '/app/$tenantSlug/change-requests/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugChangeRequestsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/bulk-imports/new': {
      id: '/_authgated/app/$tenantSlug/bulk-imports/new'
      path: '/bulk-imports/new'
      fullPath: '/app/$tenantSlug/bulk-imports/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugBulkImportsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/bulk-imports/$id': {
      id: '/_authgated/app/$tenantSlug/bulk-imports/$id'
      path: '/bulk-imports/$id'
      fullPath: '/app/$tenantSlug/bulk-imports/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugBulkImportsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/team': {
      id: '/_authgated/app/$tenantSlug/attendance/team'
      path: '/attendance/team'
      fullPath: '/app/$tenantSlug/attendance/team'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceTeamRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/regularize': {
      id: '/_authgated/app/$tenantSlug/attendance/regularize'
      path: '/attendance/regularize'
      fullPath: '/app/$tenantSlug/attendance/regularize'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceRegularizeRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/register': {
      id: '/_authgated/app/$tenantSlug/attendance/register'
      path: '/attendance/register'
      fullPath: '/app/$tenantSlug/attendance/register'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceRegisterRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/monthly-summary': {
      id: '/_authgated/app/$tenantSlug/attendance/monthly-summary'
      path: '/attendance/monthly-summary'
      fullPath: '/app/$tenantSlug/attendance/monthly-summary'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceMonthlySummaryRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/approvals': {
      id: '/_authgated/app/$tenantSlug/attendance/approvals'
      path: '/attendance/approvals'
      fullPath: '/app/$tenantSlug/attendance/approvals'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceApprovalsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/returns': {
      id: '/_authgated/app/$tenantSlug/accounting/returns'
      path: '/accounting/returns'
      fullPath: '/app/$tenantSlug/accounting/returns'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReturnsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/post-to-books': {
      id: '/_authgated/app/$tenantSlug/accounting/post-to-books'
      path: '/accounting/post-to-books'
      fullPath: '/app/$tenantSlug/accounting/post-to-books'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPostToBooksRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/period-locks': {
      id: '/_authgated/app/$tenantSlug/accounting/period-locks'
      path: '/accounting/period-locks'
      fullPath: '/app/$tenantSlug/accounting/period-locks'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPeriodLocksRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/opening-balance': {
      id: '/_authgated/app/$tenantSlug/accounting/opening-balance'
      path: '/accounting/opening-balance'
      fullPath: '/app/$tenantSlug/accounting/opening-balance'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingOpeningBalanceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/audit': {
      id: '/_authgated/app/$tenantSlug/accounting/audit'
      path: '/accounting/audit'
      fullPath: '/app/$tenantSlug/accounting/audit'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingAuditRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/surveys/$id/': {
      id: '/_authgated/app/$tenantSlug/surveys/$id/'
      path: '/surveys/$id'
      fullPath: '/app/$tenantSlug/surveys/$id/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSurveysIdIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/tax-codes/': {
      id: '/_authgated/app/$tenantSlug/settings/tax-codes/'
      path: '/settings/tax-codes'
      fullPath: '/app/$tenantSlug/settings/tax-codes/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsTaxCodesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/checklists/': {
      id: '/_authgated/app/$tenantSlug/settings/checklists/'
      path: '/settings/checklists'
      fullPath: '/app/$tenantSlug/settings/checklists/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/training/': {
      id: '/_authgated/app/$tenantSlug/posh/training/'
      path: '/posh/training'
      fullPath: '/app/$tenantSlug/posh/training/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshTrainingIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/reports/': {
      id: '/_authgated/app/$tenantSlug/posh/reports/'
      path: '/posh/reports'
      fullPath: '/app/$tenantSlug/posh/reports/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshReportsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/policy/': {
      id: '/_authgated/app/$tenantSlug/posh/policy/'
      path: '/posh/policy'
      fullPath: '/app/$tenantSlug/posh/policy/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshPolicyIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/complaints/': {
      id: '/_authgated/app/$tenantSlug/posh/complaints/'
      path: '/posh/complaints'
      fullPath: '/app/$tenantSlug/posh/complaints/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/reviews/': {
      id: '/_authgated/app/$tenantSlug/performance/reviews/'
      path: '/performance/reviews'
      fullPath: '/app/$tenantSlug/performance/reviews/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/one-on-ones/': {
      id: '/_authgated/app/$tenantSlug/performance/one-on-ones/'
      path: '/performance/one-on-ones'
      fullPath: '/app/$tenantSlug/performance/one-on-ones/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/my-results/': {
      id: '/_authgated/app/$tenantSlug/performance/my-results/'
      path: '/performance/my-results'
      fullPath: '/app/$tenantSlug/performance/my-results/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceMyResultsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/goals/': {
      id: '/_authgated/app/$tenantSlug/performance/goals/'
      path: '/performance/goals'
      fullPath: '/app/$tenantSlug/performance/goals/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/cycles/': {
      id: '/_authgated/app/$tenantSlug/performance/cycles/'
      path: '/performance/cycles'
      fullPath: '/app/$tenantSlug/performance/cycles/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/tax-declaration/': {
      id: '/_authgated/app/$tenantSlug/payroll/tax-declaration/'
      path: '/payroll/tax-declaration'
      fullPath: '/app/$tenantSlug/payroll/tax-declaration/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/letters/': {
      id: '/_authgated/app/$tenantSlug/me/letters/'
      path: '/me/letters'
      fullPath: '/app/$tenantSlug/me/letters/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeLettersIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/details/': {
      id: '/_authgated/app/$tenantSlug/me/details/'
      path: '/me/details'
      fullPath: '/app/$tenantSlug/me/details/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeDetailsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/account/': {
      id: '/_authgated/app/$tenantSlug/me/account/'
      path: '/me/account'
      fullPath: '/app/$tenantSlug/me/account/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeAccountIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/onboarding/': {
      id: '/_authgated/app/$tenantSlug/hr/onboarding/'
      path: '/hr/onboarding'
      fullPath: '/app/$tenantSlug/hr/onboarding/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOnboardingIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/offboarding/': {
      id: '/_authgated/app/$tenantSlug/hr/offboarding/'
      path: '/hr/offboarding'
      fullPath: '/app/$tenantSlug/hr/offboarding/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOffboardingIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/requisitions/': {
      id: '/_authgated/app/$tenantSlug/hiring/requisitions/'
      path: '/hiring/requisitions'
      fullPath: '/app/$tenantSlug/hiring/requisitions/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/candidates/': {
      id: '/_authgated/app/$tenantSlug/hiring/candidates/'
      path: '/hiring/candidates'
      fullPath: '/app/$tenantSlug/hiring/candidates/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringCandidatesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/import/': {
      id: '/_authgated/app/$tenantSlug/attendance/import/'
      path: '/attendance/import'
      fullPath: '/app/$tenantSlug/attendance/import/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceImportIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/'
      path: '/accounting/sales'
      fullPath: '/app/$tenantSlug/accounting/sales/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/'
      path: '/accounting/reports'
      fullPath: '/app/$tenantSlug/accounting/reports/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/purchases/': {
      id: '/_authgated/app/$tenantSlug/accounting/purchases/'
      path: '/accounting/purchases'
      fullPath: '/app/$tenantSlug/accounting/purchases/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/': {
      id: '/_authgated/app/$tenantSlug/accounting/money/'
      path: '/accounting/money'
      fullPath: '/app/$tenantSlug/accounting/money/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/journals/': {
      id: '/_authgated/app/$tenantSlug/accounting/journals/'
      path: '/accounting/journals'
      fullPath: '/app/$tenantSlug/accounting/journals/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingJournalsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/items/': {
      id: '/_authgated/app/$tenantSlug/accounting/items/'
      path: '/accounting/items'
      fullPath: '/app/$tenantSlug/accounting/items/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingItemsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/contacts/': {
      id: '/_authgated/app/$tenantSlug/accounting/contacts/'
      path: '/accounting/contacts'
      fullPath: '/app/$tenantSlug/accounting/contacts/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingContactsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/accounts/': {
      id: '/_authgated/app/$tenantSlug/accounting/accounts/'
      path: '/accounting/accounts'
      fullPath: '/app/$tenantSlug/accounting/accounts/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingAccountsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/timesheet/weeks/$weekStart': {
      id: '/_authgated/app/$tenantSlug/timesheet/weeks/$weekStart'
      path: '/timesheet/weeks/$weekStart'
      fullPath: '/app/$tenantSlug/timesheet/weeks/$weekStart'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTimesheetWeeksWeekStartRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/surveys/$id/results': {
      id: '/_authgated/app/$tenantSlug/surveys/$id/results'
      path: '/surveys/$id/results'
      fullPath: '/app/$tenantSlug/surveys/$id/results'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSurveysIdResultsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/tax-codes/new': {
      id: '/_authgated/app/$tenantSlug/settings/tax-codes/new'
      path: '/settings/tax-codes/new'
      fullPath: '/app/$tenantSlug/settings/tax-codes/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsTaxCodesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/checklists/preboarding': {
      id: '/_authgated/app/$tenantSlug/settings/checklists/preboarding'
      path: '/settings/checklists/preboarding'
      fullPath: '/app/$tenantSlug/settings/checklists/preboarding'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsPreboardingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/checklists/onboarding': {
      id: '/_authgated/app/$tenantSlug/settings/checklists/onboarding'
      path: '/settings/checklists/onboarding'
      fullPath: '/app/$tenantSlug/settings/checklists/onboarding'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsOnboardingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/settings/checklists/offboarding': {
      id: '/_authgated/app/$tenantSlug/settings/checklists/offboarding'
      path: '/settings/checklists/offboarding'
      fullPath: '/app/$tenantSlug/settings/checklists/offboarding'
      preLoaderRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsOffboardingRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/reports/$id': {
      id: '/_authgated/app/$tenantSlug/posh/reports/$id'
      path: '/posh/reports/$id'
      fullPath: '/app/$tenantSlug/posh/reports/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshReportsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/policy/$id': {
      id: '/_authgated/app/$tenantSlug/posh/policy/$id'
      path: '/posh/policy/$id'
      fullPath: '/app/$tenantSlug/posh/policy/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshPolicyIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/complaints/new': {
      id: '/_authgated/app/$tenantSlug/posh/complaints/new'
      path: '/posh/complaints/new'
      fullPath: '/app/$tenantSlug/posh/complaints/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshComplaintsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/reviews/new': {
      id: '/_authgated/app/$tenantSlug/performance/reviews/new'
      path: '/performance/reviews/new'
      fullPath: '/app/$tenantSlug/performance/reviews/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/reviews/$id': {
      id: '/_authgated/app/$tenantSlug/performance/reviews/$id'
      path: '/performance/reviews/$id'
      fullPath: '/app/$tenantSlug/performance/reviews/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/one-on-ones/new': {
      id: '/_authgated/app/$tenantSlug/performance/one-on-ones/new'
      path: '/performance/one-on-ones/new'
      fullPath: '/app/$tenantSlug/performance/one-on-ones/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/one-on-ones/$id': {
      id: '/_authgated/app/$tenantSlug/performance/one-on-ones/$id'
      path: '/performance/one-on-ones/$id'
      fullPath: '/app/$tenantSlug/performance/one-on-ones/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/my-results/$cycleId': {
      id: '/_authgated/app/$tenantSlug/performance/my-results/$cycleId'
      path: '/performance/my-results/$cycleId'
      fullPath: '/app/$tenantSlug/performance/my-results/$cycleId'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/goals/new': {
      id: '/_authgated/app/$tenantSlug/performance/goals/new'
      path: '/performance/goals/new'
      fullPath: '/app/$tenantSlug/performance/goals/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/goals/$id': {
      id: '/_authgated/app/$tenantSlug/performance/goals/$id'
      path: '/performance/goals/$id'
      fullPath: '/app/$tenantSlug/performance/goals/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/cycles/new': {
      id: '/_authgated/app/$tenantSlug/performance/cycles/new'
      path: '/performance/cycles/new'
      fullPath: '/app/$tenantSlug/performance/cycles/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/performance/cycles/$id': {
      id: '/_authgated/app/$tenantSlug/performance/cycles/$id'
      path: '/performance/cycles/$id'
      fullPath: '/app/$tenantSlug/performance/cycles/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/people/$id/edit': {
      id: '/_authgated/app/$tenantSlug/people/$id/edit'
      path: '/edit'
      fullPath: '/app/$tenantSlug/people/$id/edit'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPeopleIdEditRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugPeopleIdRoute
    }
    '/_authgated/app/$tenantSlug/payroll/tax-declaration/queue': {
      id: '/_authgated/app/$tenantSlug/payroll/tax-declaration/queue'
      path: '/payroll/tax-declaration/queue'
      fullPath: '/app/$tenantSlug/payroll/tax-declaration/queue'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/tax-declaration/$declId': {
      id: '/_authgated/app/$tenantSlug/payroll/tax-declaration/$declId'
      path: '/payroll/tax-declaration/$declId'
      fullPath: '/app/$tenantSlug/payroll/tax-declaration/$declId'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/payroll/filings/$id': {
      id: '/_authgated/app/$tenantSlug/payroll/filings/$id'
      path: '/$id'
      fullPath: '/app/$tenantSlug/payroll/filings/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPayrollFilingsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugPayrollFilingsRoute
    }
    '/_authgated/app/$tenantSlug/me/surveys/$id': {
      id: '/_authgated/app/$tenantSlug/me/surveys/$id'
      path: '/$id'
      fullPath: '/app/$tenantSlug/me/surveys/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeSurveysIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugMeSurveysRoute
    }
    '/_authgated/app/$tenantSlug/me/letters/$id': {
      id: '/_authgated/app/$tenantSlug/me/letters/$id'
      path: '/me/letters/$id'
      fullPath: '/app/$tenantSlug/me/letters/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeLettersIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/details/$itemId': {
      id: '/_authgated/app/$tenantSlug/me/details/$itemId'
      path: '/me/details/$itemId'
      fullPath: '/app/$tenantSlug/me/details/$itemId'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeDetailsItemIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/account/security': {
      id: '/_authgated/app/$tenantSlug/me/account/security'
      path: '/me/account/security'
      fullPath: '/app/$tenantSlug/me/account/security'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeAccountSecurityRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/me/account/notifications': {
      id: '/_authgated/app/$tenantSlug/me/account/notifications'
      path: '/me/account/notifications'
      fullPath: '/app/$tenantSlug/me/account/notifications'
      preLoaderRoute: typeof AuthgatedAppTenantSlugMeAccountNotificationsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/onboarding/$id': {
      id: '/_authgated/app/$tenantSlug/hr/onboarding/$id'
      path: '/hr/onboarding/$id'
      fullPath: '/app/$tenantSlug/hr/onboarding/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOnboardingIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/offboarding/new': {
      id: '/_authgated/app/$tenantSlug/hr/offboarding/new'
      path: '/hr/offboarding/new'
      fullPath: '/app/$tenantSlug/hr/offboarding/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOffboardingNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/offboarding/$id': {
      id: '/_authgated/app/$tenantSlug/hr/offboarding/$id'
      path: '/hr/offboarding/$id'
      fullPath: '/app/$tenantSlug/hr/offboarding/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOffboardingIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/requisitions/new': {
      id: '/_authgated/app/$tenantSlug/hiring/requisitions/new'
      path: '/hiring/requisitions/new'
      fullPath: '/app/$tenantSlug/hiring/requisitions/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/candidates/$id': {
      id: '/_authgated/app/$tenantSlug/hiring/candidates/$id'
      path: '/hiring/candidates/$id'
      fullPath: '/app/$tenantSlug/hiring/candidates/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringCandidatesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/helpdesk_/tickets/$id': {
      id: '/_authgated/app/$tenantSlug/helpdesk_/tickets/$id'
      path: '/helpdesk/tickets/$id'
      fullPath: '/app/$tenantSlug/helpdesk/tickets/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHelpdeskTicketsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/attendance/import/runs': {
      id: '/_authgated/app/$tenantSlug/attendance/import/runs'
      path: '/attendance/import/runs'
      fullPath: '/app/$tenantSlug/attendance/import/runs'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAttendanceImportRunsRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/trial-balance': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/trial-balance'
      path: '/accounting/reports/trial-balance'
      fullPath: '/app/$tenantSlug/accounting/reports/trial-balance'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsTrialBalanceRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/tds-receivable': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/tds-receivable'
      path: '/accounting/reports/tds-receivable'
      fullPath: '/app/$tenantSlug/accounting/reports/tds-receivable'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsTdsReceivableRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/profit-and-loss': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/profit-and-loss'
      path: '/accounting/reports/profit-and-loss'
      fullPath: '/app/$tenantSlug/accounting/reports/profit-and-loss'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsProfitAndLossRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/msme-overdue': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/msme-overdue'
      path: '/accounting/reports/msme-overdue'
      fullPath: '/app/$tenantSlug/accounting/reports/msme-overdue'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/reports/balance-sheet': {
      id: '/_authgated/app/$tenantSlug/accounting/reports/balance-sheet'
      path: '/accounting/reports/balance-sheet'
      fullPath: '/app/$tenantSlug/accounting/reports/balance-sheet'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingReportsBalanceSheetRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/purchases/new': {
      id: '/_authgated/app/$tenantSlug/accounting/purchases/new'
      path: '/accounting/purchases/new'
      fullPath: '/app/$tenantSlug/accounting/purchases/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/purchases/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/purchases/$id'
      path: '/accounting/purchases/$id'
      fullPath: '/app/$tenantSlug/accounting/purchases/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/payroll-runs/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/payroll-runs/$id'
      path: '/accounting/payroll-runs/$id'
      fullPath: '/app/$tenantSlug/accounting/payroll-runs/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingPayrollRunsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/ledger/$accountId': {
      id: '/_authgated/app/$tenantSlug/accounting/ledger/$accountId'
      path: '/accounting/ledger/$accountId'
      fullPath: '/app/$tenantSlug/accounting/ledger/$accountId'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingLedgerAccountIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/journals/new': {
      id: '/_authgated/app/$tenantSlug/accounting/journals/new'
      path: '/accounting/journals/new'
      fullPath: '/app/$tenantSlug/accounting/journals/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingJournalsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/journals/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/journals/$id'
      path: '/accounting/journals/$id'
      fullPath: '/app/$tenantSlug/accounting/journals/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingJournalsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/items/new': {
      id: '/_authgated/app/$tenantSlug/accounting/items/new'
      path: '/accounting/items/new'
      fullPath: '/app/$tenantSlug/accounting/items/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingItemsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/items/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/items/$id'
      path: '/accounting/items/$id'
      fullPath: '/app/$tenantSlug/accounting/items/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingItemsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/contacts/new': {
      id: '/_authgated/app/$tenantSlug/accounting/contacts/new'
      path: '/accounting/contacts/new'
      fullPath: '/app/$tenantSlug/accounting/contacts/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingContactsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/contacts/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/contacts/$id'
      path: '/accounting/contacts/$id'
      fullPath: '/app/$tenantSlug/accounting/contacts/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingContactsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/accounts/new': {
      id: '/_authgated/app/$tenantSlug/accounting/accounts/new'
      path: '/accounting/accounts/new'
      fullPath: '/app/$tenantSlug/accounting/accounts/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingAccountsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/timesheet/admin/projects/': {
      id: '/_authgated/app/$tenantSlug/timesheet/admin/projects/'
      path: '/timesheet/admin/projects'
      fullPath: '/app/$tenantSlug/timesheet/admin/projects/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/training/$moduleId/': {
      id: '/_authgated/app/$tenantSlug/posh/training/$moduleId/'
      path: '/posh/training/$moduleId'
      fullPath: '/app/$tenantSlug/posh/training/$moduleId/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/complaints/$id/': {
      id: '/_authgated/app/$tenantSlug/posh/complaints/$id/'
      path: '/posh/complaints/$id'
      fullPath: '/app/$tenantSlug/posh/complaints/$id/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIdIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/offboarding/letters/': {
      id: '/_authgated/app/$tenantSlug/hr/offboarding/letters/'
      path: '/hr/offboarding/letters'
      fullPath: '/app/$tenantSlug/hr/offboarding/letters/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOffboardingLettersIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/requisitions/$id/': {
      id: '/_authgated/app/$tenantSlug/hiring/requisitions/$id/'
      path: '/hiring/requisitions/$id'
      fullPath: '/app/$tenantSlug/hiring/requisitions/$id/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/quotes/': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/quotes/'
      path: '/accounting/sales/quotes'
      fullPath: '/app/$tenantSlug/accounting/sales/quotes/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/receipts/': {
      id: '/_authgated/app/$tenantSlug/accounting/money/receipts/'
      path: '/accounting/money/receipts'
      fullPath: '/app/$tenantSlug/accounting/money/receipts/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/payments/': {
      id: '/_authgated/app/$tenantSlug/accounting/money/payments/'
      path: '/accounting/money/payments'
      fullPath: '/app/$tenantSlug/accounting/money/payments/'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/timesheet/admin/projects/$id': {
      id: '/_authgated/app/$tenantSlug/timesheet/admin/projects/$id'
      path: '/timesheet/admin/projects/$id'
      fullPath: '/app/$tenantSlug/timesheet/admin/projects/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/training/$moduleId/quiz': {
      id: '/_authgated/app/$tenantSlug/posh/training/$moduleId/quiz'
      path: '/posh/training/$moduleId/quiz'
      fullPath: '/app/$tenantSlug/posh/training/$moduleId/quiz'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/posh/complaints/$id/manage': {
      id: '/_authgated/app/$tenantSlug/posh/complaints/$id/manage'
      path: '/posh/complaints/$id/manage'
      fullPath: '/app/$tenantSlug/posh/complaints/$id/manage'
      preLoaderRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIdManageRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/requisitions/$id/report': {
      id: '/_authgated/app/$tenantSlug/hiring/requisitions/$id/report'
      path: '/hiring/requisitions/$id/report'
      fullPath: '/app/$tenantSlug/hiring/requisitions/$id/report'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdReportRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hiring/requisitions/$id/pipeline': {
      id: '/_authgated/app/$tenantSlug/hiring/requisitions/$id/pipeline'
      path: '/hiring/requisitions/$id/pipeline'
      fullPath: '/app/$tenantSlug/hiring/requisitions/$id/pipeline'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/quotes/new': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/quotes/new'
      path: '/accounting/sales/quotes/new'
      fullPath: '/app/$tenantSlug/accounting/sales/quotes/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/quotes/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/quotes/$id'
      path: '/accounting/sales/quotes/$id'
      fullPath: '/app/$tenantSlug/accounting/sales/quotes/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/invoices/new': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/invoices/new'
      path: '/accounting/sales/invoices/new'
      fullPath: '/app/$tenantSlug/accounting/sales/invoices/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesInvoicesNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/sales/invoices/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/sales/invoices/$id'
      path: '/accounting/sales/invoices/$id'
      fullPath: '/app/$tenantSlug/accounting/sales/invoices/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingSalesInvoicesIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/receipts/new': {
      id: '/_authgated/app/$tenantSlug/accounting/money/receipts/new'
      path: '/accounting/money/receipts/new'
      fullPath: '/app/$tenantSlug/accounting/money/receipts/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/receipts/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/money/receipts/$id'
      path: '/accounting/money/receipts/$id'
      fullPath: '/app/$tenantSlug/accounting/money/receipts/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/payments/new': {
      id: '/_authgated/app/$tenantSlug/accounting/money/payments/new'
      path: '/accounting/money/payments/new'
      fullPath: '/app/$tenantSlug/accounting/money/payments/new'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/accounting/money/payments/$id': {
      id: '/_authgated/app/$tenantSlug/accounting/money/payments/$id'
      path: '/accounting/money/payments/$id'
      fullPath: '/app/$tenantSlug/accounting/money/payments/$id'
      preLoaderRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
    '/_authgated/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge': {
      id: '/_authgated/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge'
      path: '/hr/offboarding/letters/$id/acknowledge'
      fullPath: '/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge'
      preLoaderRoute: typeof AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRouteImport
      parentRoute: typeof AuthgatedAppTenantSlugRoute
    }
  }
}

interface AuthRouteChildren {
  Auth2faSetupRoute: typeof Auth2faSetupRoute
  Auth2faVerifyRoute: typeof Auth2faVerifyRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthConfirmEmailRoute: typeof AuthConfirmEmailRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetRoute: typeof AuthResetRoute
  AuthSelectWorkspaceRoute: typeof AuthSelectWorkspaceRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faSetupRoute: Auth2faSetupRoute,
  Auth2faVerifyRoute: Auth2faVerifyRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthConfirmEmailRoute: AuthConfirmEmailRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetRoute: AuthResetRoute,
  AuthSelectWorkspaceRoute: AuthSelectWorkspaceRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthgatedSuperadminRouteChildren {
  AuthgatedSuperadminAuditRoute: typeof AuthgatedSuperadminAuditRoute
  AuthgatedSuperadminFunnelRoute: typeof AuthgatedSuperadminFunnelRoute
  AuthgatedSuperadminPlansRoute: typeof AuthgatedSuperadminPlansRoute
  AuthgatedSuperadminUsersRoute: typeof AuthgatedSuperadminUsersRoute
  AuthgatedSuperadminIndexRoute: typeof AuthgatedSuperadminIndexRoute
  AuthgatedSuperadminSupportIdRoute: typeof AuthgatedSuperadminSupportIdRoute
  AuthgatedSuperadminTenantsIdRoute: typeof AuthgatedSuperadminTenantsIdRoute
  AuthgatedSuperadminSupportIndexRoute: typeof AuthgatedSuperadminSupportIndexRoute
  AuthgatedSuperadminTenantsIndexRoute: typeof AuthgatedSuperadminTenantsIndexRoute
}

const AuthgatedSuperadminRouteChildren: AuthgatedSuperadminRouteChildren = {
  AuthgatedSuperadminAuditRoute: AuthgatedSuperadminAuditRoute,
  AuthgatedSuperadminFunnelRoute: AuthgatedSuperadminFunnelRoute,
  AuthgatedSuperadminPlansRoute: AuthgatedSuperadminPlansRoute,
  AuthgatedSuperadminUsersRoute: AuthgatedSuperadminUsersRoute,
  AuthgatedSuperadminIndexRoute: AuthgatedSuperadminIndexRoute,
  AuthgatedSuperadminSupportIdRoute: AuthgatedSuperadminSupportIdRoute,
  AuthgatedSuperadminTenantsIdRoute: AuthgatedSuperadminTenantsIdRoute,
  AuthgatedSuperadminSupportIndexRoute: AuthgatedSuperadminSupportIndexRoute,
  AuthgatedSuperadminTenantsIndexRoute: AuthgatedSuperadminTenantsIndexRoute,
}

const AuthgatedSuperadminRouteWithChildren =
  AuthgatedSuperadminRoute._addFileChildren(AuthgatedSuperadminRouteChildren)

interface AuthgatedAppTenantSlugHelpdeskRouteChildren {
  AuthgatedAppTenantSlugHelpdeskNewRoute: typeof AuthgatedAppTenantSlugHelpdeskNewRoute
}

const AuthgatedAppTenantSlugHelpdeskRouteChildren: AuthgatedAppTenantSlugHelpdeskRouteChildren =
  {
    AuthgatedAppTenantSlugHelpdeskNewRoute:
      AuthgatedAppTenantSlugHelpdeskNewRoute,
  }

const AuthgatedAppTenantSlugHelpdeskRouteWithChildren =
  AuthgatedAppTenantSlugHelpdeskRoute._addFileChildren(
    AuthgatedAppTenantSlugHelpdeskRouteChildren,
  )

interface AuthgatedAppTenantSlugSupportTicketsRouteChildren {
  AuthgatedAppTenantSlugSupportTicketsNewRoute: typeof AuthgatedAppTenantSlugSupportTicketsNewRoute
}

const AuthgatedAppTenantSlugSupportTicketsRouteChildren: AuthgatedAppTenantSlugSupportTicketsRouteChildren =
  {
    AuthgatedAppTenantSlugSupportTicketsNewRoute:
      AuthgatedAppTenantSlugSupportTicketsNewRoute,
  }

const AuthgatedAppTenantSlugSupportTicketsRouteWithChildren =
  AuthgatedAppTenantSlugSupportTicketsRoute._addFileChildren(
    AuthgatedAppTenantSlugSupportTicketsRouteChildren,
  )

interface AuthgatedAppTenantSlugMeSurveysRouteChildren {
  AuthgatedAppTenantSlugMeSurveysIdRoute: typeof AuthgatedAppTenantSlugMeSurveysIdRoute
}

const AuthgatedAppTenantSlugMeSurveysRouteChildren: AuthgatedAppTenantSlugMeSurveysRouteChildren =
  {
    AuthgatedAppTenantSlugMeSurveysIdRoute:
      AuthgatedAppTenantSlugMeSurveysIdRoute,
  }

const AuthgatedAppTenantSlugMeSurveysRouteWithChildren =
  AuthgatedAppTenantSlugMeSurveysRoute._addFileChildren(
    AuthgatedAppTenantSlugMeSurveysRouteChildren,
  )

interface AuthgatedAppTenantSlugPayrollFilingsRouteChildren {
  AuthgatedAppTenantSlugPayrollFilingsIdRoute: typeof AuthgatedAppTenantSlugPayrollFilingsIdRoute
}

const AuthgatedAppTenantSlugPayrollFilingsRouteChildren: AuthgatedAppTenantSlugPayrollFilingsRouteChildren =
  {
    AuthgatedAppTenantSlugPayrollFilingsIdRoute:
      AuthgatedAppTenantSlugPayrollFilingsIdRoute,
  }

const AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren =
  AuthgatedAppTenantSlugPayrollFilingsRoute._addFileChildren(
    AuthgatedAppTenantSlugPayrollFilingsRouteChildren,
  )

interface AuthgatedAppTenantSlugPeopleIdRouteChildren {
  AuthgatedAppTenantSlugPeopleIdEditRoute: typeof AuthgatedAppTenantSlugPeopleIdEditRoute
}

const AuthgatedAppTenantSlugPeopleIdRouteChildren: AuthgatedAppTenantSlugPeopleIdRouteChildren =
  {
    AuthgatedAppTenantSlugPeopleIdEditRoute:
      AuthgatedAppTenantSlugPeopleIdEditRoute,
  }

const AuthgatedAppTenantSlugPeopleIdRouteWithChildren =
  AuthgatedAppTenantSlugPeopleIdRoute._addFileChildren(
    AuthgatedAppTenantSlugPeopleIdRouteChildren,
  )

interface AuthgatedAppTenantSlugRouteChildren {
  AuthgatedAppTenantSlugAnnouncementsRoute: typeof AuthgatedAppTenantSlugAnnouncementsRoute
  AuthgatedAppTenantSlugApprovalDelegationRoute: typeof AuthgatedAppTenantSlugApprovalDelegationRoute
  AuthgatedAppTenantSlugApprovalsRoute: typeof AuthgatedAppTenantSlugApprovalsRoute
  AuthgatedAppTenantSlugCalendarRoute: typeof AuthgatedAppTenantSlugCalendarRoute
  AuthgatedAppTenantSlugCompOffRoute: typeof AuthgatedAppTenantSlugCompOffRoute
  AuthgatedAppTenantSlugComplianceRoute: typeof AuthgatedAppTenantSlugComplianceRoute
  AuthgatedAppTenantSlugDirectoryRoute: typeof AuthgatedAppTenantSlugDirectoryRoute
  AuthgatedAppTenantSlugExitTasksRoute: typeof AuthgatedAppTenantSlugExitTasksRoute
  AuthgatedAppTenantSlugHelpdeskRoute: typeof AuthgatedAppTenantSlugHelpdeskRouteWithChildren
  AuthgatedAppTenantSlugHolidaysRoute: typeof AuthgatedAppTenantSlugHolidaysRoute
  AuthgatedAppTenantSlugInterviewsRoute: typeof AuthgatedAppTenantSlugInterviewsRoute
  AuthgatedAppTenantSlugMyTimeRoute: typeof AuthgatedAppTenantSlugMyTimeRoute
  AuthgatedAppTenantSlugOverviewRoute: typeof AuthgatedAppTenantSlugOverviewRoute
  AuthgatedAppTenantSlugReferralsRoute: typeof AuthgatedAppTenantSlugReferralsRoute
  AuthgatedAppTenantSlugSkillsRoute: typeof AuthgatedAppTenantSlugSkillsRoute
  AuthgatedAppTenantSlugSupportTicketsRoute: typeof AuthgatedAppTenantSlugSupportTicketsRouteWithChildren
  AuthgatedAppTenantSlugTasksRoute: typeof AuthgatedAppTenantSlugTasksRoute
  AuthgatedAppTenantSlugIndexRoute: typeof AuthgatedAppTenantSlugIndexRoute
  AuthgatedAppTenantSlugAccountingAuditRoute: typeof AuthgatedAppTenantSlugAccountingAuditRoute
  AuthgatedAppTenantSlugAccountingOpeningBalanceRoute: typeof AuthgatedAppTenantSlugAccountingOpeningBalanceRoute
  AuthgatedAppTenantSlugAccountingPeriodLocksRoute: typeof AuthgatedAppTenantSlugAccountingPeriodLocksRoute
  AuthgatedAppTenantSlugAccountingPostToBooksRoute: typeof AuthgatedAppTenantSlugAccountingPostToBooksRoute
  AuthgatedAppTenantSlugAccountingReturnsRoute: typeof AuthgatedAppTenantSlugAccountingReturnsRoute
  AuthgatedAppTenantSlugAttendanceApprovalsRoute: typeof AuthgatedAppTenantSlugAttendanceApprovalsRoute
  AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute: typeof AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute
  AuthgatedAppTenantSlugAttendanceRegisterRoute: typeof AuthgatedAppTenantSlugAttendanceRegisterRoute
  AuthgatedAppTenantSlugAttendanceRegularizeRoute: typeof AuthgatedAppTenantSlugAttendanceRegularizeRoute
  AuthgatedAppTenantSlugAttendanceTeamRoute: typeof AuthgatedAppTenantSlugAttendanceTeamRoute
  AuthgatedAppTenantSlugBulkImportsIdRoute: typeof AuthgatedAppTenantSlugBulkImportsIdRoute
  AuthgatedAppTenantSlugBulkImportsNewRoute: typeof AuthgatedAppTenantSlugBulkImportsNewRoute
  AuthgatedAppTenantSlugChangeRequestsIdRoute: typeof AuthgatedAppTenantSlugChangeRequestsIdRoute
  AuthgatedAppTenantSlugChangeRequestsNewRoute: typeof AuthgatedAppTenantSlugChangeRequestsNewRoute
  AuthgatedAppTenantSlugExpensesIdRoute: typeof AuthgatedAppTenantSlugExpensesIdRoute
  AuthgatedAppTenantSlugExpensesApprovalsRoute: typeof AuthgatedAppTenantSlugExpensesApprovalsRoute
  AuthgatedAppTenantSlugExpensesBatchesRoute: typeof AuthgatedAppTenantSlugExpensesBatchesRoute
  AuthgatedAppTenantSlugExpensesNewRoute: typeof AuthgatedAppTenantSlugExpensesNewRoute
  AuthgatedAppTenantSlugHiringAnalyticsRoute: typeof AuthgatedAppTenantSlugHiringAnalyticsRoute
  AuthgatedAppTenantSlugHiringCostsRoute: typeof AuthgatedAppTenantSlugHiringCostsRoute
  AuthgatedAppTenantSlugHiringInterviewsRoute: typeof AuthgatedAppTenantSlugHiringInterviewsRoute
  AuthgatedAppTenantSlugHiringJobsRoute: typeof AuthgatedAppTenantSlugHiringJobsRoute
  AuthgatedAppTenantSlugHiringReferralsRoute: typeof AuthgatedAppTenantSlugHiringReferralsRoute
  AuthgatedAppTenantSlugHiringReportsRoute: typeof AuthgatedAppTenantSlugHiringReportsRoute
  AuthgatedAppTenantSlugHrAssetsRoute: typeof AuthgatedAppTenantSlugHrAssetsRoute
  AuthgatedAppTenantSlugHrDocumentsRoute: typeof AuthgatedAppTenantSlugHrDocumentsRoute
  AuthgatedAppTenantSlugLeaveIdRoute: typeof AuthgatedAppTenantSlugLeaveIdRoute
  AuthgatedAppTenantSlugLeaveApprovalsRoute: typeof AuthgatedAppTenantSlugLeaveApprovalsRoute
  AuthgatedAppTenantSlugLeaveBalancesRoute: typeof AuthgatedAppTenantSlugLeaveBalancesRoute
  AuthgatedAppTenantSlugLeaveCalendarRoute: typeof AuthgatedAppTenantSlugLeaveCalendarRoute
  AuthgatedAppTenantSlugLeaveCompOffRoute: typeof AuthgatedAppTenantSlugLeaveCompOffRoute
  AuthgatedAppTenantSlugLeaveHolidaysRoute: typeof AuthgatedAppTenantSlugLeaveHolidaysRoute
  AuthgatedAppTenantSlugLeaveNewRoute: typeof AuthgatedAppTenantSlugLeaveNewRoute
  AuthgatedAppTenantSlugLoansLoanIdRoute: typeof AuthgatedAppTenantSlugLoansLoanIdRoute
  AuthgatedAppTenantSlugLoansApprovalsRoute: typeof AuthgatedAppTenantSlugLoansApprovalsRoute
  AuthgatedAppTenantSlugLoansManageRoute: typeof AuthgatedAppTenantSlugLoansManageRoute
  AuthgatedAppTenantSlugLoansNewRoute: typeof AuthgatedAppTenantSlugLoansNewRoute
  AuthgatedAppTenantSlugMaternityCasesIdRoute: typeof AuthgatedAppTenantSlugMaternityCasesIdRoute
  AuthgatedAppTenantSlugMaternityCasesNewRoute: typeof AuthgatedAppTenantSlugMaternityCasesNewRoute
  AuthgatedAppTenantSlugMeAssetsRoute: typeof AuthgatedAppTenantSlugMeAssetsRoute
  AuthgatedAppTenantSlugMeDocumentsRoute: typeof AuthgatedAppTenantSlugMeDocumentsRoute
  AuthgatedAppTenantSlugMeExitRoute: typeof AuthgatedAppTenantSlugMeExitRoute
  AuthgatedAppTenantSlugMeLoansRoute: typeof AuthgatedAppTenantSlugMeLoansRoute
  AuthgatedAppTenantSlugMePayRoute: typeof AuthgatedAppTenantSlugMePayRoute
  AuthgatedAppTenantSlugMeProfileRoute: typeof AuthgatedAppTenantSlugMeProfileRoute
  AuthgatedAppTenantSlugMeSalaryRoute: typeof AuthgatedAppTenantSlugMeSalaryRoute
  AuthgatedAppTenantSlugMeSecurityRoute: typeof AuthgatedAppTenantSlugMeSecurityRoute
  AuthgatedAppTenantSlugMeSurveysRoute: typeof AuthgatedAppTenantSlugMeSurveysRouteWithChildren
  AuthgatedAppTenantSlugMeTaxRoute: typeof AuthgatedAppTenantSlugMeTaxRoute
  AuthgatedAppTenantSlugPayrollIdRoute: typeof AuthgatedAppTenantSlugPayrollIdRoute
  AuthgatedAppTenantSlugPayrollFilingsRoute: typeof AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren
  AuthgatedAppTenantSlugPayrollNewRoute: typeof AuthgatedAppTenantSlugPayrollNewRoute
  AuthgatedAppTenantSlugPayrollPfCeilingRoute: typeof AuthgatedAppTenantSlugPayrollPfCeilingRoute
  AuthgatedAppTenantSlugPayrollStatutoryRoute: typeof AuthgatedAppTenantSlugPayrollStatutoryRoute
  AuthgatedAppTenantSlugPayrollStatutoryBonusRoute: typeof AuthgatedAppTenantSlugPayrollStatutoryBonusRoute
  AuthgatedAppTenantSlugPeopleIdRoute: typeof AuthgatedAppTenantSlugPeopleIdRouteWithChildren
  AuthgatedAppTenantSlugPeopleNewRoute: typeof AuthgatedAppTenantSlugPeopleNewRoute
  AuthgatedAppTenantSlugPeopleOrgChartRoute: typeof AuthgatedAppTenantSlugPeopleOrgChartRoute
  AuthgatedAppTenantSlugPeoplePreboardingRoute: typeof AuthgatedAppTenantSlugPeoplePreboardingRoute
  AuthgatedAppTenantSlugPerformanceFeedbackRoute: typeof AuthgatedAppTenantSlugPerformanceFeedbackRoute
  AuthgatedAppTenantSlugPoshAboutRoute: typeof AuthgatedAppTenantSlugPoshAboutRoute
  AuthgatedAppTenantSlugPoshCertificatesRoute: typeof AuthgatedAppTenantSlugPoshCertificatesRoute
  AuthgatedAppTenantSlugPoshComplianceRoute: typeof AuthgatedAppTenantSlugPoshComplianceRoute
  AuthgatedAppTenantSlugPoshIccRoute: typeof AuthgatedAppTenantSlugPoshIccRoute
  AuthgatedAppTenantSlugReportsAnalyticsRoute: typeof AuthgatedAppTenantSlugReportsAnalyticsRoute
  AuthgatedAppTenantSlugReportsHeadcountRoute: typeof AuthgatedAppTenantSlugReportsHeadcountRoute
  AuthgatedAppTenantSlugReportsPayrollCostRoute: typeof AuthgatedAppTenantSlugReportsPayrollCostRoute
  AuthgatedAppTenantSlugReportsSalaryRegisterRoute: typeof AuthgatedAppTenantSlugReportsSalaryRegisterRoute
  AuthgatedAppTenantSlugSettingsAnalyticsRoute: typeof AuthgatedAppTenantSlugSettingsAnalyticsRoute
  AuthgatedAppTenantSlugSettingsApiTokensRoute: typeof AuthgatedAppTenantSlugSettingsApiTokensRoute
  AuthgatedAppTenantSlugSettingsAssetTypesRoute: typeof AuthgatedAppTenantSlugSettingsAssetTypesRoute
  AuthgatedAppTenantSlugSettingsAttendanceRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceRoute
  AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute
  AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute: typeof AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute
  AuthgatedAppTenantSlugSettingsAuditLogRoute: typeof AuthgatedAppTenantSlugSettingsAuditLogRoute
  AuthgatedAppTenantSlugSettingsBillingRoute: typeof AuthgatedAppTenantSlugSettingsBillingRoute
  AuthgatedAppTenantSlugSettingsCareersBrandingRoute: typeof AuthgatedAppTenantSlugSettingsCareersBrandingRoute
  AuthgatedAppTenantSlugSettingsCoaRoute: typeof AuthgatedAppTenantSlugSettingsCoaRoute
  AuthgatedAppTenantSlugSettingsCompetenciesRoute: typeof AuthgatedAppTenantSlugSettingsCompetenciesRoute
  AuthgatedAppTenantSlugSettingsCustomFieldsRoute: typeof AuthgatedAppTenantSlugSettingsCustomFieldsRoute
  AuthgatedAppTenantSlugSettingsDepartmentsRoute: typeof AuthgatedAppTenantSlugSettingsDepartmentsRoute
  AuthgatedAppTenantSlugSettingsEntitiesRoute: typeof AuthgatedAppTenantSlugSettingsEntitiesRoute
  AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute: typeof AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute
  AuthgatedAppTenantSlugSettingsHiringApprovalsRoute: typeof AuthgatedAppTenantSlugSettingsHiringApprovalsRoute
  AuthgatedAppTenantSlugSettingsHiringEmailsRoute: typeof AuthgatedAppTenantSlugSettingsHiringEmailsRoute
  AuthgatedAppTenantSlugSettingsHolidaysRoute: typeof AuthgatedAppTenantSlugSettingsHolidaysRoute
  AuthgatedAppTenantSlugSettingsJdTemplatesRoute: typeof AuthgatedAppTenantSlugSettingsJdTemplatesRoute
  AuthgatedAppTenantSlugSettingsLeaveTypesRoute: typeof AuthgatedAppTenantSlugSettingsLeaveTypesRoute
  AuthgatedAppTenantSlugSettingsModulesRoute: typeof AuthgatedAppTenantSlugSettingsModulesRoute
  AuthgatedAppTenantSlugSettingsNotificationsRoute: typeof AuthgatedAppTenantSlugSettingsNotificationsRoute
  AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute: typeof AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute
  AuthgatedAppTenantSlugSettingsPaymentAccountsRoute: typeof AuthgatedAppTenantSlugSettingsPaymentAccountsRoute
  AuthgatedAppTenantSlugSettingsPostingAccountsRoute: typeof AuthgatedAppTenantSlugSettingsPostingAccountsRoute
  AuthgatedAppTenantSlugSettingsRolesRoute: typeof AuthgatedAppTenantSlugSettingsRolesRoute
  AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute: typeof AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute
  AuthgatedAppTenantSlugSettingsSecurityRoute: typeof AuthgatedAppTenantSlugSettingsSecurityRoute
  AuthgatedAppTenantSlugSettingsShiftsRoute: typeof AuthgatedAppTenantSlugSettingsShiftsRoute
  AuthgatedAppTenantSlugSettingsSkillsRoute: typeof AuthgatedAppTenantSlugSettingsSkillsRoute
  AuthgatedAppTenantSlugSettingsTallyMappingsRoute: typeof AuthgatedAppTenantSlugSettingsTallyMappingsRoute
  AuthgatedAppTenantSlugSettingsWebhooksRoute: typeof AuthgatedAppTenantSlugSettingsWebhooksRoute
  AuthgatedAppTenantSlugSettingsWorkspaceRoute: typeof AuthgatedAppTenantSlugSettingsWorkspaceRoute
  AuthgatedAppTenantSlugShiftsRosterRoute: typeof AuthgatedAppTenantSlugShiftsRosterRoute
  AuthgatedAppTenantSlugShiftsSwapsRoute: typeof AuthgatedAppTenantSlugShiftsSwapsRoute
  AuthgatedAppTenantSlugSupportTicketsIdRoute: typeof AuthgatedAppTenantSlugSupportTicketsIdRoute
  AuthgatedAppTenantSlugSurveysNewRoute: typeof AuthgatedAppTenantSlugSurveysNewRoute
  AuthgatedAppTenantSlugTimesheetInboxRoute: typeof AuthgatedAppTenantSlugTimesheetInboxRoute
  AuthgatedAppTenantSlugTravelPreapprovalsIdRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsIdRoute
  AuthgatedAppTenantSlugTravelPreapprovalsNewRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsNewRoute
  AuthgatedAppTenantSlugWfhIdRoute: typeof AuthgatedAppTenantSlugWfhIdRoute
  AuthgatedAppTenantSlugWfhApprovalsRoute: typeof AuthgatedAppTenantSlugWfhApprovalsRoute
  AuthgatedAppTenantSlugAccountingIndexRoute: typeof AuthgatedAppTenantSlugAccountingIndexRoute
  AuthgatedAppTenantSlugAttendanceIndexRoute: typeof AuthgatedAppTenantSlugAttendanceIndexRoute
  AuthgatedAppTenantSlugBulkImportsIndexRoute: typeof AuthgatedAppTenantSlugBulkImportsIndexRoute
  AuthgatedAppTenantSlugChangeRequestsIndexRoute: typeof AuthgatedAppTenantSlugChangeRequestsIndexRoute
  AuthgatedAppTenantSlugExpensesIndexRoute: typeof AuthgatedAppTenantSlugExpensesIndexRoute
  AuthgatedAppTenantSlugHiringIndexRoute: typeof AuthgatedAppTenantSlugHiringIndexRoute
  AuthgatedAppTenantSlugHrIndexRoute: typeof AuthgatedAppTenantSlugHrIndexRoute
  AuthgatedAppTenantSlugLeaveIndexRoute: typeof AuthgatedAppTenantSlugLeaveIndexRoute
  AuthgatedAppTenantSlugLoansIndexRoute: typeof AuthgatedAppTenantSlugLoansIndexRoute
  AuthgatedAppTenantSlugMaternityCasesIndexRoute: typeof AuthgatedAppTenantSlugMaternityCasesIndexRoute
  AuthgatedAppTenantSlugPayrollIndexRoute: typeof AuthgatedAppTenantSlugPayrollIndexRoute
  AuthgatedAppTenantSlugPeopleIndexRoute: typeof AuthgatedAppTenantSlugPeopleIndexRoute
  AuthgatedAppTenantSlugPerformanceIndexRoute: typeof AuthgatedAppTenantSlugPerformanceIndexRoute
  AuthgatedAppTenantSlugPoshIndexRoute: typeof AuthgatedAppTenantSlugPoshIndexRoute
  AuthgatedAppTenantSlugReportsIndexRoute: typeof AuthgatedAppTenantSlugReportsIndexRoute
  AuthgatedAppTenantSlugSettingsIndexRoute: typeof AuthgatedAppTenantSlugSettingsIndexRoute
  AuthgatedAppTenantSlugShiftsIndexRoute: typeof AuthgatedAppTenantSlugShiftsIndexRoute
  AuthgatedAppTenantSlugSurveysIndexRoute: typeof AuthgatedAppTenantSlugSurveysIndexRoute
  AuthgatedAppTenantSlugTimesheetIndexRoute: typeof AuthgatedAppTenantSlugTimesheetIndexRoute
  AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute: typeof AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute
  AuthgatedAppTenantSlugWfhIndexRoute: typeof AuthgatedAppTenantSlugWfhIndexRoute
  AuthgatedAppTenantSlugAccountingAccountsNewRoute: typeof AuthgatedAppTenantSlugAccountingAccountsNewRoute
  AuthgatedAppTenantSlugAccountingContactsIdRoute: typeof AuthgatedAppTenantSlugAccountingContactsIdRoute
  AuthgatedAppTenantSlugAccountingContactsNewRoute: typeof AuthgatedAppTenantSlugAccountingContactsNewRoute
  AuthgatedAppTenantSlugAccountingItemsIdRoute: typeof AuthgatedAppTenantSlugAccountingItemsIdRoute
  AuthgatedAppTenantSlugAccountingItemsNewRoute: typeof AuthgatedAppTenantSlugAccountingItemsNewRoute
  AuthgatedAppTenantSlugAccountingJournalsIdRoute: typeof AuthgatedAppTenantSlugAccountingJournalsIdRoute
  AuthgatedAppTenantSlugAccountingJournalsNewRoute: typeof AuthgatedAppTenantSlugAccountingJournalsNewRoute
  AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute: typeof AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute
  AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute: typeof AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute
  AuthgatedAppTenantSlugAccountingPurchasesIdRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesIdRoute
  AuthgatedAppTenantSlugAccountingPurchasesNewRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesNewRoute
  AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute: typeof AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute
  AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute: typeof AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute
  AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute: typeof AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute
  AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute: typeof AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute
  AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute: typeof AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute
  AuthgatedAppTenantSlugAttendanceImportRunsRoute: typeof AuthgatedAppTenantSlugAttendanceImportRunsRoute
  AuthgatedAppTenantSlugHelpdeskTicketsIdRoute: typeof AuthgatedAppTenantSlugHelpdeskTicketsIdRoute
  AuthgatedAppTenantSlugHiringCandidatesIdRoute: typeof AuthgatedAppTenantSlugHiringCandidatesIdRoute
  AuthgatedAppTenantSlugHiringRequisitionsNewRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsNewRoute
  AuthgatedAppTenantSlugHrOffboardingIdRoute: typeof AuthgatedAppTenantSlugHrOffboardingIdRoute
  AuthgatedAppTenantSlugHrOffboardingNewRoute: typeof AuthgatedAppTenantSlugHrOffboardingNewRoute
  AuthgatedAppTenantSlugHrOnboardingIdRoute: typeof AuthgatedAppTenantSlugHrOnboardingIdRoute
  AuthgatedAppTenantSlugMeAccountNotificationsRoute: typeof AuthgatedAppTenantSlugMeAccountNotificationsRoute
  AuthgatedAppTenantSlugMeAccountSecurityRoute: typeof AuthgatedAppTenantSlugMeAccountSecurityRoute
  AuthgatedAppTenantSlugMeDetailsItemIdRoute: typeof AuthgatedAppTenantSlugMeDetailsItemIdRoute
  AuthgatedAppTenantSlugMeLettersIdRoute: typeof AuthgatedAppTenantSlugMeLettersIdRoute
  AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute
  AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute
  AuthgatedAppTenantSlugPerformanceCyclesIdRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesIdRoute
  AuthgatedAppTenantSlugPerformanceCyclesNewRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesNewRoute
  AuthgatedAppTenantSlugPerformanceGoalsIdRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsIdRoute
  AuthgatedAppTenantSlugPerformanceGoalsNewRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsNewRoute
  AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute: typeof AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute
  AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute
  AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute
  AuthgatedAppTenantSlugPerformanceReviewsIdRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsIdRoute
  AuthgatedAppTenantSlugPerformanceReviewsNewRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsNewRoute
  AuthgatedAppTenantSlugPoshComplaintsNewRoute: typeof AuthgatedAppTenantSlugPoshComplaintsNewRoute
  AuthgatedAppTenantSlugPoshPolicyIdRoute: typeof AuthgatedAppTenantSlugPoshPolicyIdRoute
  AuthgatedAppTenantSlugPoshReportsIdRoute: typeof AuthgatedAppTenantSlugPoshReportsIdRoute
  AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute
  AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute
  AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute
  AuthgatedAppTenantSlugSettingsTaxCodesNewRoute: typeof AuthgatedAppTenantSlugSettingsTaxCodesNewRoute
  AuthgatedAppTenantSlugSurveysIdResultsRoute: typeof AuthgatedAppTenantSlugSurveysIdResultsRoute
  AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute: typeof AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute
  AuthgatedAppTenantSlugAccountingAccountsIndexRoute: typeof AuthgatedAppTenantSlugAccountingAccountsIndexRoute
  AuthgatedAppTenantSlugAccountingContactsIndexRoute: typeof AuthgatedAppTenantSlugAccountingContactsIndexRoute
  AuthgatedAppTenantSlugAccountingItemsIndexRoute: typeof AuthgatedAppTenantSlugAccountingItemsIndexRoute
  AuthgatedAppTenantSlugAccountingJournalsIndexRoute: typeof AuthgatedAppTenantSlugAccountingJournalsIndexRoute
  AuthgatedAppTenantSlugAccountingMoneyIndexRoute: typeof AuthgatedAppTenantSlugAccountingMoneyIndexRoute
  AuthgatedAppTenantSlugAccountingPurchasesIndexRoute: typeof AuthgatedAppTenantSlugAccountingPurchasesIndexRoute
  AuthgatedAppTenantSlugAccountingReportsIndexRoute: typeof AuthgatedAppTenantSlugAccountingReportsIndexRoute
  AuthgatedAppTenantSlugAccountingSalesIndexRoute: typeof AuthgatedAppTenantSlugAccountingSalesIndexRoute
  AuthgatedAppTenantSlugAttendanceImportIndexRoute: typeof AuthgatedAppTenantSlugAttendanceImportIndexRoute
  AuthgatedAppTenantSlugHiringCandidatesIndexRoute: typeof AuthgatedAppTenantSlugHiringCandidatesIndexRoute
  AuthgatedAppTenantSlugHiringRequisitionsIndexRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIndexRoute
  AuthgatedAppTenantSlugHrOffboardingIndexRoute: typeof AuthgatedAppTenantSlugHrOffboardingIndexRoute
  AuthgatedAppTenantSlugHrOnboardingIndexRoute: typeof AuthgatedAppTenantSlugHrOnboardingIndexRoute
  AuthgatedAppTenantSlugMeAccountIndexRoute: typeof AuthgatedAppTenantSlugMeAccountIndexRoute
  AuthgatedAppTenantSlugMeDetailsIndexRoute: typeof AuthgatedAppTenantSlugMeDetailsIndexRoute
  AuthgatedAppTenantSlugMeLettersIndexRoute: typeof AuthgatedAppTenantSlugMeLettersIndexRoute
  AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute: typeof AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute
  AuthgatedAppTenantSlugPerformanceCyclesIndexRoute: typeof AuthgatedAppTenantSlugPerformanceCyclesIndexRoute
  AuthgatedAppTenantSlugPerformanceGoalsIndexRoute: typeof AuthgatedAppTenantSlugPerformanceGoalsIndexRoute
  AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute: typeof AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute
  AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute: typeof AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute
  AuthgatedAppTenantSlugPerformanceReviewsIndexRoute: typeof AuthgatedAppTenantSlugPerformanceReviewsIndexRoute
  AuthgatedAppTenantSlugPoshComplaintsIndexRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIndexRoute
  AuthgatedAppTenantSlugPoshPolicyIndexRoute: typeof AuthgatedAppTenantSlugPoshPolicyIndexRoute
  AuthgatedAppTenantSlugPoshReportsIndexRoute: typeof AuthgatedAppTenantSlugPoshReportsIndexRoute
  AuthgatedAppTenantSlugPoshTrainingIndexRoute: typeof AuthgatedAppTenantSlugPoshTrainingIndexRoute
  AuthgatedAppTenantSlugSettingsChecklistsIndexRoute: typeof AuthgatedAppTenantSlugSettingsChecklistsIndexRoute
  AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute: typeof AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute
  AuthgatedAppTenantSlugSurveysIdIndexRoute: typeof AuthgatedAppTenantSlugSurveysIdIndexRoute
  AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute
  AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute
  AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute
  AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute
  AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute: typeof AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute
  AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute: typeof AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute
  AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute
  AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute
  AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute
  AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute
  AuthgatedAppTenantSlugPoshComplaintsIdManageRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIdManageRoute
  AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute: typeof AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute
  AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute: typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute
  AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute: typeof AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute
  AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute: typeof AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute
  AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute: typeof AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute
  AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute: typeof AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute
  AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute: typeof AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute
  AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute: typeof AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute
  AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute: typeof AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute
  AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute: typeof AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute
  AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute: typeof AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute
}

const AuthgatedAppTenantSlugRouteChildren: AuthgatedAppTenantSlugRouteChildren =
  {
    AuthgatedAppTenantSlugAnnouncementsRoute:
      AuthgatedAppTenantSlugAnnouncementsRoute,
    AuthgatedAppTenantSlugApprovalDelegationRoute:
      AuthgatedAppTenantSlugApprovalDelegationRoute,
    AuthgatedAppTenantSlugApprovalsRoute: AuthgatedAppTenantSlugApprovalsRoute,
    AuthgatedAppTenantSlugCalendarRoute: AuthgatedAppTenantSlugCalendarRoute,
    AuthgatedAppTenantSlugCompOffRoute: AuthgatedAppTenantSlugCompOffRoute,
    AuthgatedAppTenantSlugComplianceRoute:
      AuthgatedAppTenantSlugComplianceRoute,
    AuthgatedAppTenantSlugDirectoryRoute: AuthgatedAppTenantSlugDirectoryRoute,
    AuthgatedAppTenantSlugExitTasksRoute: AuthgatedAppTenantSlugExitTasksRoute,
    AuthgatedAppTenantSlugHelpdeskRoute:
      AuthgatedAppTenantSlugHelpdeskRouteWithChildren,
    AuthgatedAppTenantSlugHolidaysRoute: AuthgatedAppTenantSlugHolidaysRoute,
    AuthgatedAppTenantSlugInterviewsRoute:
      AuthgatedAppTenantSlugInterviewsRoute,
    AuthgatedAppTenantSlugMyTimeRoute: AuthgatedAppTenantSlugMyTimeRoute,
    AuthgatedAppTenantSlugOverviewRoute: AuthgatedAppTenantSlugOverviewRoute,
    AuthgatedAppTenantSlugReferralsRoute: AuthgatedAppTenantSlugReferralsRoute,
    AuthgatedAppTenantSlugSkillsRoute: AuthgatedAppTenantSlugSkillsRoute,
    AuthgatedAppTenantSlugSupportTicketsRoute:
      AuthgatedAppTenantSlugSupportTicketsRouteWithChildren,
    AuthgatedAppTenantSlugTasksRoute: AuthgatedAppTenantSlugTasksRoute,
    AuthgatedAppTenantSlugIndexRoute: AuthgatedAppTenantSlugIndexRoute,
    AuthgatedAppTenantSlugAccountingAuditRoute:
      AuthgatedAppTenantSlugAccountingAuditRoute,
    AuthgatedAppTenantSlugAccountingOpeningBalanceRoute:
      AuthgatedAppTenantSlugAccountingOpeningBalanceRoute,
    AuthgatedAppTenantSlugAccountingPeriodLocksRoute:
      AuthgatedAppTenantSlugAccountingPeriodLocksRoute,
    AuthgatedAppTenantSlugAccountingPostToBooksRoute:
      AuthgatedAppTenantSlugAccountingPostToBooksRoute,
    AuthgatedAppTenantSlugAccountingReturnsRoute:
      AuthgatedAppTenantSlugAccountingReturnsRoute,
    AuthgatedAppTenantSlugAttendanceApprovalsRoute:
      AuthgatedAppTenantSlugAttendanceApprovalsRoute,
    AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute:
      AuthgatedAppTenantSlugAttendanceMonthlySummaryRoute,
    AuthgatedAppTenantSlugAttendanceRegisterRoute:
      AuthgatedAppTenantSlugAttendanceRegisterRoute,
    AuthgatedAppTenantSlugAttendanceRegularizeRoute:
      AuthgatedAppTenantSlugAttendanceRegularizeRoute,
    AuthgatedAppTenantSlugAttendanceTeamRoute:
      AuthgatedAppTenantSlugAttendanceTeamRoute,
    AuthgatedAppTenantSlugBulkImportsIdRoute:
      AuthgatedAppTenantSlugBulkImportsIdRoute,
    AuthgatedAppTenantSlugBulkImportsNewRoute:
      AuthgatedAppTenantSlugBulkImportsNewRoute,
    AuthgatedAppTenantSlugChangeRequestsIdRoute:
      AuthgatedAppTenantSlugChangeRequestsIdRoute,
    AuthgatedAppTenantSlugChangeRequestsNewRoute:
      AuthgatedAppTenantSlugChangeRequestsNewRoute,
    AuthgatedAppTenantSlugExpensesIdRoute:
      AuthgatedAppTenantSlugExpensesIdRoute,
    AuthgatedAppTenantSlugExpensesApprovalsRoute:
      AuthgatedAppTenantSlugExpensesApprovalsRoute,
    AuthgatedAppTenantSlugExpensesBatchesRoute:
      AuthgatedAppTenantSlugExpensesBatchesRoute,
    AuthgatedAppTenantSlugExpensesNewRoute:
      AuthgatedAppTenantSlugExpensesNewRoute,
    AuthgatedAppTenantSlugHiringAnalyticsRoute:
      AuthgatedAppTenantSlugHiringAnalyticsRoute,
    AuthgatedAppTenantSlugHiringCostsRoute:
      AuthgatedAppTenantSlugHiringCostsRoute,
    AuthgatedAppTenantSlugHiringInterviewsRoute:
      AuthgatedAppTenantSlugHiringInterviewsRoute,
    AuthgatedAppTenantSlugHiringJobsRoute:
      AuthgatedAppTenantSlugHiringJobsRoute,
    AuthgatedAppTenantSlugHiringReferralsRoute:
      AuthgatedAppTenantSlugHiringReferralsRoute,
    AuthgatedAppTenantSlugHiringReportsRoute:
      AuthgatedAppTenantSlugHiringReportsRoute,
    AuthgatedAppTenantSlugHrAssetsRoute: AuthgatedAppTenantSlugHrAssetsRoute,
    AuthgatedAppTenantSlugHrDocumentsRoute:
      AuthgatedAppTenantSlugHrDocumentsRoute,
    AuthgatedAppTenantSlugLeaveIdRoute: AuthgatedAppTenantSlugLeaveIdRoute,
    AuthgatedAppTenantSlugLeaveApprovalsRoute:
      AuthgatedAppTenantSlugLeaveApprovalsRoute,
    AuthgatedAppTenantSlugLeaveBalancesRoute:
      AuthgatedAppTenantSlugLeaveBalancesRoute,
    AuthgatedAppTenantSlugLeaveCalendarRoute:
      AuthgatedAppTenantSlugLeaveCalendarRoute,
    AuthgatedAppTenantSlugLeaveCompOffRoute:
      AuthgatedAppTenantSlugLeaveCompOffRoute,
    AuthgatedAppTenantSlugLeaveHolidaysRoute:
      AuthgatedAppTenantSlugLeaveHolidaysRoute,
    AuthgatedAppTenantSlugLeaveNewRoute: AuthgatedAppTenantSlugLeaveNewRoute,
    AuthgatedAppTenantSlugLoansLoanIdRoute:
      AuthgatedAppTenantSlugLoansLoanIdRoute,
    AuthgatedAppTenantSlugLoansApprovalsRoute:
      AuthgatedAppTenantSlugLoansApprovalsRoute,
    AuthgatedAppTenantSlugLoansManageRoute:
      AuthgatedAppTenantSlugLoansManageRoute,
    AuthgatedAppTenantSlugLoansNewRoute: AuthgatedAppTenantSlugLoansNewRoute,
    AuthgatedAppTenantSlugMaternityCasesIdRoute:
      AuthgatedAppTenantSlugMaternityCasesIdRoute,
    AuthgatedAppTenantSlugMaternityCasesNewRoute:
      AuthgatedAppTenantSlugMaternityCasesNewRoute,
    AuthgatedAppTenantSlugMeAssetsRoute: AuthgatedAppTenantSlugMeAssetsRoute,
    AuthgatedAppTenantSlugMeDocumentsRoute:
      AuthgatedAppTenantSlugMeDocumentsRoute,
    AuthgatedAppTenantSlugMeExitRoute: AuthgatedAppTenantSlugMeExitRoute,
    AuthgatedAppTenantSlugMeLoansRoute: AuthgatedAppTenantSlugMeLoansRoute,
    AuthgatedAppTenantSlugMePayRoute: AuthgatedAppTenantSlugMePayRoute,
    AuthgatedAppTenantSlugMeProfileRoute: AuthgatedAppTenantSlugMeProfileRoute,
    AuthgatedAppTenantSlugMeSalaryRoute: AuthgatedAppTenantSlugMeSalaryRoute,
    AuthgatedAppTenantSlugMeSecurityRoute:
      AuthgatedAppTenantSlugMeSecurityRoute,
    AuthgatedAppTenantSlugMeSurveysRoute:
      AuthgatedAppTenantSlugMeSurveysRouteWithChildren,
    AuthgatedAppTenantSlugMeTaxRoute: AuthgatedAppTenantSlugMeTaxRoute,
    AuthgatedAppTenantSlugPayrollIdRoute: AuthgatedAppTenantSlugPayrollIdRoute,
    AuthgatedAppTenantSlugPayrollFilingsRoute:
      AuthgatedAppTenantSlugPayrollFilingsRouteWithChildren,
    AuthgatedAppTenantSlugPayrollNewRoute:
      AuthgatedAppTenantSlugPayrollNewRoute,
    AuthgatedAppTenantSlugPayrollPfCeilingRoute:
      AuthgatedAppTenantSlugPayrollPfCeilingRoute,
    AuthgatedAppTenantSlugPayrollStatutoryRoute:
      AuthgatedAppTenantSlugPayrollStatutoryRoute,
    AuthgatedAppTenantSlugPayrollStatutoryBonusRoute:
      AuthgatedAppTenantSlugPayrollStatutoryBonusRoute,
    AuthgatedAppTenantSlugPeopleIdRoute:
      AuthgatedAppTenantSlugPeopleIdRouteWithChildren,
    AuthgatedAppTenantSlugPeopleNewRoute: AuthgatedAppTenantSlugPeopleNewRoute,
    AuthgatedAppTenantSlugPeopleOrgChartRoute:
      AuthgatedAppTenantSlugPeopleOrgChartRoute,
    AuthgatedAppTenantSlugPeoplePreboardingRoute:
      AuthgatedAppTenantSlugPeoplePreboardingRoute,
    AuthgatedAppTenantSlugPerformanceFeedbackRoute:
      AuthgatedAppTenantSlugPerformanceFeedbackRoute,
    AuthgatedAppTenantSlugPoshAboutRoute: AuthgatedAppTenantSlugPoshAboutRoute,
    AuthgatedAppTenantSlugPoshCertificatesRoute:
      AuthgatedAppTenantSlugPoshCertificatesRoute,
    AuthgatedAppTenantSlugPoshComplianceRoute:
      AuthgatedAppTenantSlugPoshComplianceRoute,
    AuthgatedAppTenantSlugPoshIccRoute: AuthgatedAppTenantSlugPoshIccRoute,
    AuthgatedAppTenantSlugReportsAnalyticsRoute:
      AuthgatedAppTenantSlugReportsAnalyticsRoute,
    AuthgatedAppTenantSlugReportsHeadcountRoute:
      AuthgatedAppTenantSlugReportsHeadcountRoute,
    AuthgatedAppTenantSlugReportsPayrollCostRoute:
      AuthgatedAppTenantSlugReportsPayrollCostRoute,
    AuthgatedAppTenantSlugReportsSalaryRegisterRoute:
      AuthgatedAppTenantSlugReportsSalaryRegisterRoute,
    AuthgatedAppTenantSlugSettingsAnalyticsRoute:
      AuthgatedAppTenantSlugSettingsAnalyticsRoute,
    AuthgatedAppTenantSlugSettingsApiTokensRoute:
      AuthgatedAppTenantSlugSettingsApiTokensRoute,
    AuthgatedAppTenantSlugSettingsAssetTypesRoute:
      AuthgatedAppTenantSlugSettingsAssetTypesRoute,
    AuthgatedAppTenantSlugSettingsAttendanceRoute:
      AuthgatedAppTenantSlugSettingsAttendanceRoute,
    AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute:
      AuthgatedAppTenantSlugSettingsAttendanceDeviceProfilesRoute,
    AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute:
      AuthgatedAppTenantSlugSettingsAttendanceDevicesRoute,
    AuthgatedAppTenantSlugSettingsAuditLogRoute:
      AuthgatedAppTenantSlugSettingsAuditLogRoute,
    AuthgatedAppTenantSlugSettingsBillingRoute:
      AuthgatedAppTenantSlugSettingsBillingRoute,
    AuthgatedAppTenantSlugSettingsCareersBrandingRoute:
      AuthgatedAppTenantSlugSettingsCareersBrandingRoute,
    AuthgatedAppTenantSlugSettingsCoaRoute:
      AuthgatedAppTenantSlugSettingsCoaRoute,
    AuthgatedAppTenantSlugSettingsCompetenciesRoute:
      AuthgatedAppTenantSlugSettingsCompetenciesRoute,
    AuthgatedAppTenantSlugSettingsCustomFieldsRoute:
      AuthgatedAppTenantSlugSettingsCustomFieldsRoute,
    AuthgatedAppTenantSlugSettingsDepartmentsRoute:
      AuthgatedAppTenantSlugSettingsDepartmentsRoute,
    AuthgatedAppTenantSlugSettingsEntitiesRoute:
      AuthgatedAppTenantSlugSettingsEntitiesRoute,
    AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute:
      AuthgatedAppTenantSlugSettingsExpenseCategoriesRoute,
    AuthgatedAppTenantSlugSettingsHiringApprovalsRoute:
      AuthgatedAppTenantSlugSettingsHiringApprovalsRoute,
    AuthgatedAppTenantSlugSettingsHiringEmailsRoute:
      AuthgatedAppTenantSlugSettingsHiringEmailsRoute,
    AuthgatedAppTenantSlugSettingsHolidaysRoute:
      AuthgatedAppTenantSlugSettingsHolidaysRoute,
    AuthgatedAppTenantSlugSettingsJdTemplatesRoute:
      AuthgatedAppTenantSlugSettingsJdTemplatesRoute,
    AuthgatedAppTenantSlugSettingsLeaveTypesRoute:
      AuthgatedAppTenantSlugSettingsLeaveTypesRoute,
    AuthgatedAppTenantSlugSettingsModulesRoute:
      AuthgatedAppTenantSlugSettingsModulesRoute,
    AuthgatedAppTenantSlugSettingsNotificationsRoute:
      AuthgatedAppTenantSlugSettingsNotificationsRoute,
    AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute:
      AuthgatedAppTenantSlugSettingsOnboardingTemplatesRoute,
    AuthgatedAppTenantSlugSettingsPaymentAccountsRoute:
      AuthgatedAppTenantSlugSettingsPaymentAccountsRoute,
    AuthgatedAppTenantSlugSettingsPostingAccountsRoute:
      AuthgatedAppTenantSlugSettingsPostingAccountsRoute,
    AuthgatedAppTenantSlugSettingsRolesRoute:
      AuthgatedAppTenantSlugSettingsRolesRoute,
    AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute:
      AuthgatedAppTenantSlugSettingsScorecardTemplatesRoute,
    AuthgatedAppTenantSlugSettingsSecurityRoute:
      AuthgatedAppTenantSlugSettingsSecurityRoute,
    AuthgatedAppTenantSlugSettingsShiftsRoute:
      AuthgatedAppTenantSlugSettingsShiftsRoute,
    AuthgatedAppTenantSlugSettingsSkillsRoute:
      AuthgatedAppTenantSlugSettingsSkillsRoute,
    AuthgatedAppTenantSlugSettingsTallyMappingsRoute:
      AuthgatedAppTenantSlugSettingsTallyMappingsRoute,
    AuthgatedAppTenantSlugSettingsWebhooksRoute:
      AuthgatedAppTenantSlugSettingsWebhooksRoute,
    AuthgatedAppTenantSlugSettingsWorkspaceRoute:
      AuthgatedAppTenantSlugSettingsWorkspaceRoute,
    AuthgatedAppTenantSlugShiftsRosterRoute:
      AuthgatedAppTenantSlugShiftsRosterRoute,
    AuthgatedAppTenantSlugShiftsSwapsRoute:
      AuthgatedAppTenantSlugShiftsSwapsRoute,
    AuthgatedAppTenantSlugSupportTicketsIdRoute:
      AuthgatedAppTenantSlugSupportTicketsIdRoute,
    AuthgatedAppTenantSlugSurveysNewRoute:
      AuthgatedAppTenantSlugSurveysNewRoute,
    AuthgatedAppTenantSlugTimesheetInboxRoute:
      AuthgatedAppTenantSlugTimesheetInboxRoute,
    AuthgatedAppTenantSlugTravelPreapprovalsIdRoute:
      AuthgatedAppTenantSlugTravelPreapprovalsIdRoute,
    AuthgatedAppTenantSlugTravelPreapprovalsNewRoute:
      AuthgatedAppTenantSlugTravelPreapprovalsNewRoute,
    AuthgatedAppTenantSlugWfhIdRoute: AuthgatedAppTenantSlugWfhIdRoute,
    AuthgatedAppTenantSlugWfhApprovalsRoute:
      AuthgatedAppTenantSlugWfhApprovalsRoute,
    AuthgatedAppTenantSlugAccountingIndexRoute:
      AuthgatedAppTenantSlugAccountingIndexRoute,
    AuthgatedAppTenantSlugAttendanceIndexRoute:
      AuthgatedAppTenantSlugAttendanceIndexRoute,
    AuthgatedAppTenantSlugBulkImportsIndexRoute:
      AuthgatedAppTenantSlugBulkImportsIndexRoute,
    AuthgatedAppTenantSlugChangeRequestsIndexRoute:
      AuthgatedAppTenantSlugChangeRequestsIndexRoute,
    AuthgatedAppTenantSlugExpensesIndexRoute:
      AuthgatedAppTenantSlugExpensesIndexRoute,
    AuthgatedAppTenantSlugHiringIndexRoute:
      AuthgatedAppTenantSlugHiringIndexRoute,
    AuthgatedAppTenantSlugHrIndexRoute: AuthgatedAppTenantSlugHrIndexRoute,
    AuthgatedAppTenantSlugLeaveIndexRoute:
      AuthgatedAppTenantSlugLeaveIndexRoute,
    AuthgatedAppTenantSlugLoansIndexRoute:
      AuthgatedAppTenantSlugLoansIndexRoute,
    AuthgatedAppTenantSlugMaternityCasesIndexRoute:
      AuthgatedAppTenantSlugMaternityCasesIndexRoute,
    AuthgatedAppTenantSlugPayrollIndexRoute:
      AuthgatedAppTenantSlugPayrollIndexRoute,
    AuthgatedAppTenantSlugPeopleIndexRoute:
      AuthgatedAppTenantSlugPeopleIndexRoute,
    AuthgatedAppTenantSlugPerformanceIndexRoute:
      AuthgatedAppTenantSlugPerformanceIndexRoute,
    AuthgatedAppTenantSlugPoshIndexRoute: AuthgatedAppTenantSlugPoshIndexRoute,
    AuthgatedAppTenantSlugReportsIndexRoute:
      AuthgatedAppTenantSlugReportsIndexRoute,
    AuthgatedAppTenantSlugSettingsIndexRoute:
      AuthgatedAppTenantSlugSettingsIndexRoute,
    AuthgatedAppTenantSlugShiftsIndexRoute:
      AuthgatedAppTenantSlugShiftsIndexRoute,
    AuthgatedAppTenantSlugSurveysIndexRoute:
      AuthgatedAppTenantSlugSurveysIndexRoute,
    AuthgatedAppTenantSlugTimesheetIndexRoute:
      AuthgatedAppTenantSlugTimesheetIndexRoute,
    AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute:
      AuthgatedAppTenantSlugTravelPreapprovalsIndexRoute,
    AuthgatedAppTenantSlugWfhIndexRoute: AuthgatedAppTenantSlugWfhIndexRoute,
    AuthgatedAppTenantSlugAccountingAccountsNewRoute:
      AuthgatedAppTenantSlugAccountingAccountsNewRoute,
    AuthgatedAppTenantSlugAccountingContactsIdRoute:
      AuthgatedAppTenantSlugAccountingContactsIdRoute,
    AuthgatedAppTenantSlugAccountingContactsNewRoute:
      AuthgatedAppTenantSlugAccountingContactsNewRoute,
    AuthgatedAppTenantSlugAccountingItemsIdRoute:
      AuthgatedAppTenantSlugAccountingItemsIdRoute,
    AuthgatedAppTenantSlugAccountingItemsNewRoute:
      AuthgatedAppTenantSlugAccountingItemsNewRoute,
    AuthgatedAppTenantSlugAccountingJournalsIdRoute:
      AuthgatedAppTenantSlugAccountingJournalsIdRoute,
    AuthgatedAppTenantSlugAccountingJournalsNewRoute:
      AuthgatedAppTenantSlugAccountingJournalsNewRoute,
    AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute:
      AuthgatedAppTenantSlugAccountingLedgerAccountIdRoute,
    AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute:
      AuthgatedAppTenantSlugAccountingPayrollRunsIdRoute,
    AuthgatedAppTenantSlugAccountingPurchasesIdRoute:
      AuthgatedAppTenantSlugAccountingPurchasesIdRoute,
    AuthgatedAppTenantSlugAccountingPurchasesNewRoute:
      AuthgatedAppTenantSlugAccountingPurchasesNewRoute,
    AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute:
      AuthgatedAppTenantSlugAccountingReportsBalanceSheetRoute,
    AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute:
      AuthgatedAppTenantSlugAccountingReportsMsmeOverdueRoute,
    AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute:
      AuthgatedAppTenantSlugAccountingReportsProfitAndLossRoute,
    AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute:
      AuthgatedAppTenantSlugAccountingReportsTdsReceivableRoute,
    AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute:
      AuthgatedAppTenantSlugAccountingReportsTrialBalanceRoute,
    AuthgatedAppTenantSlugAttendanceImportRunsRoute:
      AuthgatedAppTenantSlugAttendanceImportRunsRoute,
    AuthgatedAppTenantSlugHelpdeskTicketsIdRoute:
      AuthgatedAppTenantSlugHelpdeskTicketsIdRoute,
    AuthgatedAppTenantSlugHiringCandidatesIdRoute:
      AuthgatedAppTenantSlugHiringCandidatesIdRoute,
    AuthgatedAppTenantSlugHiringRequisitionsNewRoute:
      AuthgatedAppTenantSlugHiringRequisitionsNewRoute,
    AuthgatedAppTenantSlugHrOffboardingIdRoute:
      AuthgatedAppTenantSlugHrOffboardingIdRoute,
    AuthgatedAppTenantSlugHrOffboardingNewRoute:
      AuthgatedAppTenantSlugHrOffboardingNewRoute,
    AuthgatedAppTenantSlugHrOnboardingIdRoute:
      AuthgatedAppTenantSlugHrOnboardingIdRoute,
    AuthgatedAppTenantSlugMeAccountNotificationsRoute:
      AuthgatedAppTenantSlugMeAccountNotificationsRoute,
    AuthgatedAppTenantSlugMeAccountSecurityRoute:
      AuthgatedAppTenantSlugMeAccountSecurityRoute,
    AuthgatedAppTenantSlugMeDetailsItemIdRoute:
      AuthgatedAppTenantSlugMeDetailsItemIdRoute,
    AuthgatedAppTenantSlugMeLettersIdRoute:
      AuthgatedAppTenantSlugMeLettersIdRoute,
    AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute:
      AuthgatedAppTenantSlugPayrollTaxDeclarationDeclIdRoute,
    AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute:
      AuthgatedAppTenantSlugPayrollTaxDeclarationQueueRoute,
    AuthgatedAppTenantSlugPerformanceCyclesIdRoute:
      AuthgatedAppTenantSlugPerformanceCyclesIdRoute,
    AuthgatedAppTenantSlugPerformanceCyclesNewRoute:
      AuthgatedAppTenantSlugPerformanceCyclesNewRoute,
    AuthgatedAppTenantSlugPerformanceGoalsIdRoute:
      AuthgatedAppTenantSlugPerformanceGoalsIdRoute,
    AuthgatedAppTenantSlugPerformanceGoalsNewRoute:
      AuthgatedAppTenantSlugPerformanceGoalsNewRoute,
    AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute:
      AuthgatedAppTenantSlugPerformanceMyResultsCycleIdRoute,
    AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute:
      AuthgatedAppTenantSlugPerformanceOneOnOnesIdRoute,
    AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute:
      AuthgatedAppTenantSlugPerformanceOneOnOnesNewRoute,
    AuthgatedAppTenantSlugPerformanceReviewsIdRoute:
      AuthgatedAppTenantSlugPerformanceReviewsIdRoute,
    AuthgatedAppTenantSlugPerformanceReviewsNewRoute:
      AuthgatedAppTenantSlugPerformanceReviewsNewRoute,
    AuthgatedAppTenantSlugPoshComplaintsNewRoute:
      AuthgatedAppTenantSlugPoshComplaintsNewRoute,
    AuthgatedAppTenantSlugPoshPolicyIdRoute:
      AuthgatedAppTenantSlugPoshPolicyIdRoute,
    AuthgatedAppTenantSlugPoshReportsIdRoute:
      AuthgatedAppTenantSlugPoshReportsIdRoute,
    AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute:
      AuthgatedAppTenantSlugSettingsChecklistsOffboardingRoute,
    AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute:
      AuthgatedAppTenantSlugSettingsChecklistsOnboardingRoute,
    AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute:
      AuthgatedAppTenantSlugSettingsChecklistsPreboardingRoute,
    AuthgatedAppTenantSlugSettingsTaxCodesNewRoute:
      AuthgatedAppTenantSlugSettingsTaxCodesNewRoute,
    AuthgatedAppTenantSlugSurveysIdResultsRoute:
      AuthgatedAppTenantSlugSurveysIdResultsRoute,
    AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute:
      AuthgatedAppTenantSlugTimesheetWeeksWeekStartRoute,
    AuthgatedAppTenantSlugAccountingAccountsIndexRoute:
      AuthgatedAppTenantSlugAccountingAccountsIndexRoute,
    AuthgatedAppTenantSlugAccountingContactsIndexRoute:
      AuthgatedAppTenantSlugAccountingContactsIndexRoute,
    AuthgatedAppTenantSlugAccountingItemsIndexRoute:
      AuthgatedAppTenantSlugAccountingItemsIndexRoute,
    AuthgatedAppTenantSlugAccountingJournalsIndexRoute:
      AuthgatedAppTenantSlugAccountingJournalsIndexRoute,
    AuthgatedAppTenantSlugAccountingMoneyIndexRoute:
      AuthgatedAppTenantSlugAccountingMoneyIndexRoute,
    AuthgatedAppTenantSlugAccountingPurchasesIndexRoute:
      AuthgatedAppTenantSlugAccountingPurchasesIndexRoute,
    AuthgatedAppTenantSlugAccountingReportsIndexRoute:
      AuthgatedAppTenantSlugAccountingReportsIndexRoute,
    AuthgatedAppTenantSlugAccountingSalesIndexRoute:
      AuthgatedAppTenantSlugAccountingSalesIndexRoute,
    AuthgatedAppTenantSlugAttendanceImportIndexRoute:
      AuthgatedAppTenantSlugAttendanceImportIndexRoute,
    AuthgatedAppTenantSlugHiringCandidatesIndexRoute:
      AuthgatedAppTenantSlugHiringCandidatesIndexRoute,
    AuthgatedAppTenantSlugHiringRequisitionsIndexRoute:
      AuthgatedAppTenantSlugHiringRequisitionsIndexRoute,
    AuthgatedAppTenantSlugHrOffboardingIndexRoute:
      AuthgatedAppTenantSlugHrOffboardingIndexRoute,
    AuthgatedAppTenantSlugHrOnboardingIndexRoute:
      AuthgatedAppTenantSlugHrOnboardingIndexRoute,
    AuthgatedAppTenantSlugMeAccountIndexRoute:
      AuthgatedAppTenantSlugMeAccountIndexRoute,
    AuthgatedAppTenantSlugMeDetailsIndexRoute:
      AuthgatedAppTenantSlugMeDetailsIndexRoute,
    AuthgatedAppTenantSlugMeLettersIndexRoute:
      AuthgatedAppTenantSlugMeLettersIndexRoute,
    AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute:
      AuthgatedAppTenantSlugPayrollTaxDeclarationIndexRoute,
    AuthgatedAppTenantSlugPerformanceCyclesIndexRoute:
      AuthgatedAppTenantSlugPerformanceCyclesIndexRoute,
    AuthgatedAppTenantSlugPerformanceGoalsIndexRoute:
      AuthgatedAppTenantSlugPerformanceGoalsIndexRoute,
    AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute:
      AuthgatedAppTenantSlugPerformanceMyResultsIndexRoute,
    AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute:
      AuthgatedAppTenantSlugPerformanceOneOnOnesIndexRoute,
    AuthgatedAppTenantSlugPerformanceReviewsIndexRoute:
      AuthgatedAppTenantSlugPerformanceReviewsIndexRoute,
    AuthgatedAppTenantSlugPoshComplaintsIndexRoute:
      AuthgatedAppTenantSlugPoshComplaintsIndexRoute,
    AuthgatedAppTenantSlugPoshPolicyIndexRoute:
      AuthgatedAppTenantSlugPoshPolicyIndexRoute,
    AuthgatedAppTenantSlugPoshReportsIndexRoute:
      AuthgatedAppTenantSlugPoshReportsIndexRoute,
    AuthgatedAppTenantSlugPoshTrainingIndexRoute:
      AuthgatedAppTenantSlugPoshTrainingIndexRoute,
    AuthgatedAppTenantSlugSettingsChecklistsIndexRoute:
      AuthgatedAppTenantSlugSettingsChecklistsIndexRoute,
    AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute:
      AuthgatedAppTenantSlugSettingsTaxCodesIndexRoute,
    AuthgatedAppTenantSlugSurveysIdIndexRoute:
      AuthgatedAppTenantSlugSurveysIdIndexRoute,
    AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute:
      AuthgatedAppTenantSlugAccountingMoneyPaymentsIdRoute,
    AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute:
      AuthgatedAppTenantSlugAccountingMoneyPaymentsNewRoute,
    AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute:
      AuthgatedAppTenantSlugAccountingMoneyReceiptsIdRoute,
    AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute:
      AuthgatedAppTenantSlugAccountingMoneyReceiptsNewRoute,
    AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute:
      AuthgatedAppTenantSlugAccountingSalesInvoicesIdRoute,
    AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute:
      AuthgatedAppTenantSlugAccountingSalesInvoicesNewRoute,
    AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute:
      AuthgatedAppTenantSlugAccountingSalesQuotesIdRoute,
    AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute:
      AuthgatedAppTenantSlugAccountingSalesQuotesNewRoute,
    AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute:
      AuthgatedAppTenantSlugHiringRequisitionsIdPipelineRoute,
    AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute:
      AuthgatedAppTenantSlugHiringRequisitionsIdReportRoute,
    AuthgatedAppTenantSlugPoshComplaintsIdManageRoute:
      AuthgatedAppTenantSlugPoshComplaintsIdManageRoute,
    AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute:
      AuthgatedAppTenantSlugPoshTrainingModuleIdQuizRoute,
    AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute:
      AuthgatedAppTenantSlugTimesheetAdminProjectsIdRoute,
    AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute:
      AuthgatedAppTenantSlugAccountingMoneyPaymentsIndexRoute,
    AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute:
      AuthgatedAppTenantSlugAccountingMoneyReceiptsIndexRoute,
    AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute:
      AuthgatedAppTenantSlugAccountingSalesQuotesIndexRoute,
    AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute:
      AuthgatedAppTenantSlugHiringRequisitionsIdIndexRoute,
    AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute:
      AuthgatedAppTenantSlugHrOffboardingLettersIndexRoute,
    AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute:
      AuthgatedAppTenantSlugPoshComplaintsIdIndexRoute,
    AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute:
      AuthgatedAppTenantSlugPoshTrainingModuleIdIndexRoute,
    AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute:
      AuthgatedAppTenantSlugTimesheetAdminProjectsIndexRoute,
    AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute:
      AuthgatedAppTenantSlugHrOffboardingLettersIdAcknowledgeRoute,
  }

const AuthgatedAppTenantSlugRouteWithChildren =
  AuthgatedAppTenantSlugRoute._addFileChildren(
    AuthgatedAppTenantSlugRouteChildren,
  )

interface AuthgatedRouteChildren {
  AuthgatedSuperadminRoute: typeof AuthgatedSuperadminRouteWithChildren
  AuthgatedAppTenantSlugRoute: typeof AuthgatedAppTenantSlugRouteWithChildren
}

const AuthgatedRouteChildren: AuthgatedRouteChildren = {
  AuthgatedSuperadminRoute: AuthgatedSuperadminRouteWithChildren,
  AuthgatedAppTenantSlugRoute: AuthgatedAppTenantSlugRouteWithChildren,
}

const AuthgatedRouteWithChildren = AuthgatedRoute._addFileChildren(
  AuthgatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthgatedRoute: AuthgatedRouteWithChildren,
  JoinTokenRoute: JoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
